import { defineComponent as A, computed as V, openBlock as c, createElementBlock as v, normalizeClass as B, createElementVNode as h, ref as $, onMounted as ee, onUnmounted as Ot, createVNode as O, toDisplayString as P, createCommentVNode as k, createApp as $o, createTextVNode as R, Fragment as H, useSlots as K, inject as ce, unref as F, createBlock as T, resolveDynamicComponent as Y, mergeProps as N, withCtx as J, renderSlot as w, provide as te, renderList as G, normalizeStyle as X, useAttrs as oe, useId as De, resolveDirective as dt, withDirectives as Xe, getCurrentScope as Dt, onScopeDispose as Rt, toRef as Co, readonly as So, customRef as xo, shallowRef as Nt, watch as W, nextTick as Fe, getCurrentInstance as Vo, h as To, Teleport as Te, shallowReadonly as Ie, onBeforeUnmount as Je, withKeys as Re, normalizeProps as qt, Transition as ft, createSlots as yt, guardReactiveProps as Io, useModel as Lo, mergeModels as Bo, createStaticVNode as Ht, createPropsRestProxy as Ao, vShow as Eo, render as Ct, withModifiers as zo } from "vue";
function St(e) {
  const t = e.target;
  if (!t)
    return;
  const o = t.getBoundingClientRect(), l = "joy-ripple-effect";
  let n;
  const i = t.querySelector(`.${l}`);
  i || (n = document.createElement("span"), n.classList.add(l));
  const a = i || n;
  t.prepend(a);
  const r = Math.sqrt(Math.pow(o.width, 2) + Math.pow(o.height, 2)) * 2;
  a.style.width = a.style.height = `${r}px`, a.style.left = `${e.clientX - o.left}px`, a.style.top = `${e.clientY - o.top}px`;
}
const Wt = {
  mounted: (e) => {
    e.addEventListener("click", St);
  },
  beforeUnmount: (e) => {
    e.removeEventListener("click", St);
  }
}, Jo = /\d/, Po = ["-", "_", "/", "."];
function Mo(e = "") {
  if (!Jo.test(e))
    return e !== e.toLowerCase();
}
function Fo(e, t) {
  const o = Po, l = [];
  if (!e || typeof e != "string")
    return l;
  let n = "", i, a;
  for (const r of e) {
    const u = o.includes(r);
    if (u === !0) {
      l.push(n), n = "", i = void 0;
      continue;
    }
    const s = Mo(r);
    if (a === !1) {
      if (i === !1 && s === !0) {
        l.push(n), n = r, i = s;
        continue;
      }
      if (i === !0 && s === !1 && n.length > 1) {
        const m = n.at(-1);
        l.push(n.slice(0, Math.max(0, n.length - 1))), n = m + r, i = s;
        continue;
      }
    }
    n += r, i = s, a = u;
  }
  return l.push(n), l;
}
function xt(e, t) {
  return e ? (Array.isArray(e) ? e : Fo(e)).map((o) => o.toLowerCase()).join("-") : "";
}
const Oo = {
  created: (e, t) => {
    for (const o in t.value) {
      const l = xt(o);
      e.hasAttribute(l) || e.setAttribute(l, t.value[o]);
    }
  },
  getSSRProps(e) {
    return e.value ? Object.fromEntries(
      Object.entries(e.value).map(([t, o]) => [
        xt(t),
        o
      ])
    ) : {};
  }
};
function Ut(e) {
  let t;
  switch (e) {
    case "error":
      t = "warning-triangle";
      break;
    case "success":
      t = "check-circle";
      break;
    default:
      t = "info-circle";
  }
  return t;
}
function Do(e) {
  if (!e) {
    console.warn("Missing ref element for focusOnFirstFocusableFormField use");
    return;
  }
  let t = ["input", "textarea", "select"];
  const o = (e.value ?? e).querySelectorAll(t.join(","));
  if (o.length)
    return o[0].focus();
}
const Qe = function(e = 10) {
  return Math.random().toString(36).substring(2, e + 2);
};
function he(e) {
  e ? document.body.style.overflow = "hidden" : document.body.style.removeProperty("overflow");
}
const Ro = ["role", "tabindex", "aria-label", "title"], D = /* @__PURE__ */ A({
  __name: "VJoyIcon",
  props: {
    ariaLabel: {
      type: String
    },
    title: {
      type: String
    },
    role: {
      type: String
    },
    tabIndex: {
      type: Number,
      default: 0
    },
    name: {
      type: String,
      required: !0
    },
    color: {
      type: String,
      default: "secondary"
    },
    /** Use `TJoyIconSizes` */
    size: {
      type: String,
      default: "xsmall"
    }
  },
  setup(e) {
    const t = e, o = V(() => {
      if (t.role === "button")
        return t.tabIndex;
    });
    return (l, n) => (c(), v("span", {
      class: B(["joy-icon", `joy-icon--${e.color}`, `joy-icon--${e.size}`, { "joy-icon--button": e.role === "button" }]),
      role: e.role,
      tabindex: o.value,
      "aria-label": e.ariaLabel || e.title,
      title: e.title || e.ariaLabel
    }, [
      h("i", {
        class: B(["icon", `icon-${e.name}`]),
        "aria-hidden": "true"
      }, null, 2)
    ], 10, Ro));
  }
}), No = { class: "joy-snackbar__img joy-core-radius-6" }, qo = { class: "joy-snackbar__content" }, Ho = {
  key: 0,
  class: "joy-mb-1"
}, Wo = ["innerHTML"], Uo = /* @__PURE__ */ A({
  __name: "VJoySnackbar",
  props: {
    level: {
      type: String,
      default: "success"
    },
    /** Allows to manually hide the component before its timeout */
    closable: {
      type: Boolean,
      default: !0
    },
    /** Default snackar display duration. Default to 5000ms. Set "forever" to constantly display it. */
    duration: {
      type: [String, Number],
      default: 5e3
    },
    /** The title if you need to set one */
    header: {
      type: String
    },
    /** Main snackbar message. Mandatory */
    message: {
      type: String,
      required: !0
    },
    /** If you need to trigger an action from the generated snackbar, use this field to create a CTA.
     *
     * Use `bus.on('snackbar:action-click')` to catch the event.
     */
    actionText: {
      type: String
    },
    /** Documentation purpose */
    frozen: {
      type: Boolean,
      default: !1
    },
    /** You don't need to explicitely set the bus property as the snackbar service is already handling it. */
    bus: {
      type: Object
    },
    /** Internal purpose */
    instanceNb: {
      type: Number
    }
  },
  setup(e, { expose: t }) {
    const o = e, l = $(!0);
    let n, i;
    const a = "joy-snackbar-" + Qe(), r = V(() => Ut(o.level));
    function u() {
      var g;
      (g = o.bus) == null || g.emit("snackbar:action-click");
    }
    function s() {
      n && clearTimeout(n), i && clearTimeout(i);
    }
    function m() {
      var g;
      d(), (g = o.bus) == null || g.emit("snackbar:hide");
    }
    function d() {
      l.value = !1;
    }
    function f() {
      n = setTimeout(d, o.duration), p();
    }
    function p() {
      i = setTimeout(function() {
        var g;
        (g = o.bus) == null || g.emit("snackbar:hide");
      }, o.duration + 300);
    }
    ee(() => {
      var g;
      (g = o.bus) == null || g.emit("snackbar:show"), typeof o.duration == "number" && f();
    });
    const y = {
      destroySnackbarAfterTimeout: f
    };
    return Ot(() => {
      s();
    }), t({
      isOpen: l,
      exposedMethods: y
    }), (g, b) => (c(), v("div", {
      class: B(["joy-snackbar_container", {
        "joy-snackbar__frozen": e.frozen === !0,
        "joy-snackbar__hiding": !l.value
      }])
    }, [
      h("div", {
        id: a,
        class: B(["joy-snackbar", `joy-snackbar_${e.level}`])
      }, [
        h("div", No, [
          O(D, {
            color: "white",
            name: r.value,
            size: "small"
          }, null, 8, ["name"])
        ]),
        h("div", qo, [
          e.header ? (c(), v("strong", Ho, P(e.header), 1)) : k("", !0),
          h("span", { innerHTML: e.message }, null, 8, Wo),
          e.actionText ? (c(), v("p", {
            key: 1,
            class: "joy-snackbar__trigger___action",
            onClick: u
          }, P(e.actionText), 1)) : k("", !0)
        ]),
        e.closable ? (c(), v("button", {
          key: 0,
          type: "button",
          class: "joy-snackbar__close-icon",
          onClick: m
        }, [
          O(D, {
            color: "white",
            name: "cross"
          })
        ])) : k("", !0)
      ], 2)
    ], 2));
  }
}), z = (e, t) => {
  const o = e.__vccOpts || e;
  for (const [l, n] of t)
    o[l] = n;
  return o;
}, Go = /* @__PURE__ */ z(Uo, [["__scopeId", "data-v-fb4d3964"]]);
function Ko(e) {
  return { all: e = e || /* @__PURE__ */ new Map(), on: function(t, o) {
    var l = e.get(t);
    l ? l.push(o) : e.set(t, [o]);
  }, off: function(t, o) {
    var l = e.get(t);
    l && (o ? l.splice(l.indexOf(o) >>> 0, 1) : e.set(t, []));
  }, emit: function(t, o) {
    var l = e.get(t);
    l && l.slice().map(function(n) {
      n(o);
    }), (l = e.get("*")) && l.slice().map(function(n) {
      n(t, o);
    });
  } };
}
function Yo() {
  return Ko();
}
const Gt = "joy-snackbar__container", Zo = "joy-snackbar__shell--";
let Ue = 0, Kt = [];
const Xo = {
  install: (e) => {
    typeof window < "u" && Yt(), e.directive("joy-ripple", Wt);
  }
};
function yu() {
  Ue = 0, Kt = [];
}
function Yt(e = { appendTo: "body", defaultMountSelector: Gt }) {
  var l;
  const t = document.createElement("div");
  t.id = e.defaultMountSelector;
  const o = document.createElement("style");
  o.textContent = `
        #${e.defaultMountSelector} {
            position: fixed;
            bottom: 0;
            right: 0;
            left: 0;
            margin: auto;
            z-index: var(--joy-core-z-index-snackbar);
            width: 580px;
            max-width: calc(100% - var(--joy-core-spacing-6) * 2);
        }
    `, document.head.appendChild(o), document.getElementById(t.id) === null && (e.appendTo === "body" ? document.body.appendChild(t) : (l = document.body.querySelector(e.appendTo)) == null || l.appendChild(t));
}
function mu(e) {
  var i, a;
  Ue++;
  let t, o;
  const l = Yo();
  t = $o(
    Go,
    Object.assign(e.props, {
      bus: l,
      instanceNb: Ue
    })
  );
  const n = document.createElement("div");
  return n.classList.add("joy-snackbar__shell"), o = `${Zo}${Ue}`, n.id = o, e.snackbarHostId ? (i = document.getElementById(e.snackbarHostId)) == null || i.appendChild(n) : (a = document.getElementById(Gt)) == null || a.appendChild(n), t.use(Xo).mount("#" + o), Kt.push(t), l.on("snackbar:hide", () => {
    var r;
    t.unmount(), (r = document.getElementById(o)) == null || r.remove();
  }), {
    snackbarEventBus: l,
    snackbarApp: t
  };
}
const Qo = { class: "joy-admin-banner" }, en = { class: "joy-admin-banner__label joy-font-primary-350" }, tn = /* @__PURE__ */ A({
  __name: "VJoyAdminBanner",
  props: {
    label: { default: "Admin view" }
  },
  setup(e) {
    return (t, o) => (c(), v("div", Qo, [
      h("span", en, [
        O(D, { name: "eye" }),
        R(" " + P(e.label), 1)
      ])
    ]));
  }
}), pu = /* @__PURE__ */ z(tn, [["__scopeId", "data-v-114794fd"]]), on = ["title"], nn = /* @__PURE__ */ A({
  __name: "VJoyAvailability",
  props: {
    label: {},
    status: { default: "AVAILABLE" },
    isPartial: { type: Boolean }
  },
  setup(e) {
    const t = e, o = V(() => ({
      "joy-availability__dot": !0,
      "joy-availability--partial": t.isPartial,
      [t.status]: !0
    }));
    return (l, n) => (c(), v("div", {
      class: B(["joy-availability", { "joy-availability-has-label": !!e.label }]),
      title: e.label || void 0
    }, [
      h("span", {
        class: B(o.value)
      }, null, 2),
      e.label ? (c(), v(H, { key: 0 }, [
        R(P(e.label), 1)
      ], 64)) : k("", !0)
    ], 10, on));
  }
}), vu = /* @__PURE__ */ z(nn, [["__scopeId", "data-v-b3bb9092"]]), ln = ["src", "title", "alt", "loading"], an = {
  key: 0,
  class: "joy-avatar__strategy"
}, rn = ["height"], sn = /* @__PURE__ */ A({
  __name: "VJoyAvatar",
  props: {
    size: { default: "medium" },
    fullName: {},
    photoUrl: {},
    totalNumber: {},
    link: { type: Boolean },
    profile: { default: "default" },
    loading: { default: "lazy" },
    isEmpty: { type: Boolean, default: !1 },
    placeholder: { default: "user-photo" },
    showLetters: { type: Boolean, default: !0 }
  },
  emits: ["click"],
  setup(e, { expose: t, emit: o }) {
    const l = o, n = e, i = K(), a = ce("VJoyAvatarsList", { compress: !1 });
    function r(g) {
      return g.type === "img" ? !0 : Array.isArray(g.children) ? g.children.some((b) => typeof b == "object" && b !== null && r(b)) : !1;
    }
    const u = V(() => n.size === "large" || n.size === "xlarge" || n.size === "xxlarge" ? "medium" : n.size === "medium" ? "small" : n.size === "small" ? "xsmall" : "xxsmall"), s = V(() => n.link ? {
      type: "button"
    } : null), m = V(() => ({
      "joy-avatar": !0,
      "joy-avatar__link": n.link,
      "joy-avatar__placeholder": d.value,
      [`joy-avatar__${n.size}`]: !0,
      "joy-avatar--empty": n.isEmpty
    })), d = V(() => !n.fullName && !n.photoUrl && !n.totalNumber && !n.isEmpty), f = V(() => n.photoUrl ? !0 : i.default ? i.default().some((b) => r(b)) : !1), p = V(() => {
      function g(C) {
        return C.replace(/[';,:()]/g, "").charAt(0);
      }
      let b = n.fullName.split(" ");
      return b = b.slice(0, 2), b.forEach((C, _) => {
        b[_] = g(C);
      }), b.join("").toUpperCase();
    });
    function y() {
      l("click");
    }
    return t({
      isAnonymous: d,
      initials: p
    }), (g, b) => (c(), v("div", {
      ref: "avatarEl",
      class: B(["joy-avatar__wrapper", {
        [`joy-avatar__wrapper--${e.size}`]: !0,
        "joy-avatar__wrapper--anonymous": d.value,
        "joy-avatar__wrapper--compressed": F(a).compress,
        "joy-avatar__wrapper--empty": e.isEmpty,
        "joy-avatar__wrapper--has-photo": f.value
      }])
    }, [
      (c(), T(Y(e.link ? "button" : "div"), N(s.value, {
        title: e.fullName,
        class: [m.value],
        onClick: y
      }), {
        default: J(() => [
          d.value ? (c(), T(D, {
            key: 0,
            name: e.placeholder,
            color: "neutral-50",
            size: u.value
          }, null, 8, ["name", "size"])) : k("", !0),
          w(g.$slots, "default", {}, () => [
            e.photoUrl ? (c(), v("img", {
              key: 0,
              class: "joy-avatar__img",
              src: e.photoUrl,
              title: e.fullName,
              alt: e.fullName || "",
              loading: e.loading
            }, null, 8, ln)) : k("", !0)
          ], !0),
          e.fullName && e.showLetters ? (c(), v(H, { key: 1 }, [
            R(P(p.value), 1)
          ], 64)) : k("", !0),
          e.totalNumber ? (c(), v(H, { key: 2 }, [
            R(P("+" + e.totalNumber), 1)
          ], 64)) : k("", !0)
        ]),
        _: 3
      }, 16, ["title", "class"])),
      e.profile === "strategy" ? (c(), v("span", an, [
        (c(), v("svg", {
          width: "12",
          height: e.size === "small" ? "10" : "16",
          viewBox: "0 0 12 16",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg"
        }, [...b[0] || (b[0] = [
          h("path", {
            d: "M6.40531 15.88C5.29156 15.88 4.31531 15.6737 3.47656 15.2612C2.63781 14.8487 1.98469 14.2644 1.51719 13.5081C1.04969 12.7519 0.809061 11.8719 0.795311 10.8681L4.01281 10.3525C4.01281 11.2188 4.25344 11.9131 4.73469 12.4356C5.21594 12.9581 5.82781 13.2194 6.57031 13.2194C7.16156 13.2194 7.63594 13.0612 7.99344 12.745C8.36469 12.4288 8.55031 12.0231 8.55031 11.5281C8.55031 11.1156 8.40594 10.7719 8.11719 10.4969C7.84219 10.2081 7.38844 9.95375 6.75594 9.73375L4.96156 9.15625C3.65531 8.7575 2.70656 8.21438 2.11531 7.52687C1.53781 6.83937 1.24906 5.93187 1.24906 4.80437C1.24906 3.47062 1.68219 2.39812 2.54844 1.58687C3.41469 0.775624 4.63156 0.369999 6.19906 0.369999C7.65656 0.369999 8.83219 0.768749 9.72594 1.56625C10.6197 2.35 11.0803 3.41562 11.1078 4.76312L7.97281 5.36125C7.98656 4.64625 7.82156 4.07562 7.47781 3.64937C7.13406 3.20937 6.68719 2.98937 6.13719 2.98937C5.65594 2.98937 5.26406 3.14062 4.96156 3.44313C4.65906 3.73187 4.50781 4.10312 4.50781 4.55687C4.50781 4.99687 4.64531 5.36125 4.92031 5.65C5.20906 5.925 5.67656 6.15875 6.32281 6.35125L8.03469 6.92875C9.36844 7.3275 10.3309 7.87063 10.9222 8.55812C11.5272 9.23188 11.8297 10.1325 11.8297 11.26C11.8297 12.1538 11.6166 12.9513 11.1903 13.6525C10.7641 14.3538 10.1453 14.9038 9.33406 15.3025C8.52281 15.6875 7.54656 15.88 6.40531 15.88Z",
            fill: "#F7F7F5"
          }, null, -1)
        ])], 8, rn))
      ])) : k("", !0)
    ], 2));
  }
}), un = /* @__PURE__ */ z(sn, [["__scopeId", "data-v-bbf18530"]]), cn = /* @__PURE__ */ A({
  __name: "VJoyAvatarsList",
  props: {
    /** Renders a compact list of avatars */
    compress: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    return te("VJoyAvatarsList", { compress: e.compress }), (o, l) => (c(), v("div", {
      ref: "avatarsList",
      class: B(["joy-avatars-list", { "joy-avatars-list--compressed": e.compress }])
    }, [
      w(o.$slots, "default", {}, void 0, !0)
    ], 2));
  }
}), hu = /* @__PURE__ */ z(cn, [["__scopeId", "data-v-66e67dbb"]]), dn = /* @__PURE__ */ A({
  __name: "VJoyDot",
  props: {
    number: { default: void 0 },
    variant: { default: "info" }
  },
  setup(e) {
    const t = e, o = V(() => typeof t.number < "u");
    return (l, n) => (c(), v("div", {
      class: B(["joy-dot", `joy-dot__${e.variant}`, { "joy-dot__number": o.value }])
    }, [
      h("span", null, P(e.number), 1)
    ], 2));
  }
}), Zt = /* @__PURE__ */ z(dn, [["__scopeId", "data-v-056a3587"]]), fn = /* @__PURE__ */ A({
  __name: "VJoyBadge",
  props: {
    /**
     * Display the colored bulletpoint on the left
     */
    bulletpoint: {
      type: Boolean,
      default: !1
    },
    /**
     * Use label or slot in order to inject the text.
     */
    label: {
      type: String,
      default: ""
    },
    /**
     * Color of the badge. Override the color with `--badge-bg-color` and `--badge-circle-color` if needed.
     *
     * You can use the `TJoyBadgeVariants` type.
     */
    variant: {
      type: String,
      default: "info"
    }
  },
  setup(e) {
    return (t, o) => (c(), v("span", {
      class: B(["joy-badge", `joy-badge__${e.variant}`, { "joy-badge--with-bulletpoint": e.bulletpoint }]),
      role: "status"
    }, [
      e.bulletpoint ? (c(), T(Zt, {
        key: 0,
        class: "joy-badge_dot",
        variant: e.variant
      }, null, 8, ["variant"])) : k("", !0),
      w(t.$slots, "default", {}, () => [
        R(P(e.label), 1)
      ], !0)
    ], 2));
  }
}), gu = /* @__PURE__ */ z(fn, [["__scopeId", "data-v-f3f82e51"]]);
var Z = /* @__PURE__ */ ((e) => (e.HIGH_POTENTIAL = "highpotential", e.HIGH_POTENTIAL_AUTO = "high-potential-auto", e.MALT_LINKER = "maltlinker", e.NEW = "new", e.SUPER_MALTER = "supermalter", e.VERIFIED = "verified", e))(Z || {}), Ge = /* @__PURE__ */ ((e) => (e.HIGH_POTENTIAL = "program_high-potential", e))(Ge || {});
const yn = { class: "joy-badge-level" }, mn = {
  key: 1,
  class: "joy-badge-level__highpotential",
  viewBox: "0 0 15 17",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, pn = {
  key: 2,
  class: "joy-badge-level__high-potential-auto",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 64 64",
  "enable-background": "new 0 0 64 64"
}, vn = {
  key: 3,
  class: "joy-badge-level__maltlinker",
  viewBox: "0 0 23 11",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, hn = {
  key: 4,
  class: "joy-badge-level__highpotential-program",
  viewBox: "0 0 15 17",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, gn = /* @__PURE__ */ A({
  __name: "VJoyBadgeLevel",
  props: {
    /** type: `TJoyBadges` */
    type: {
      type: String,
      required: !0
    },
    /** If supermalter type is given, specify the level (from 1 to 3) */
    superMalterLevel: {
      type: Number,
      default: 1
    },
    /** Display the default badge label */
    visibleText: {
      type: Boolean,
      default: !0
    }
  },
  setup(e) {
    const t = e, o = V(() => {
      switch (t.type) {
        case Ge.HIGH_POTENTIAL:
        case Z.HIGH_POTENTIAL:
          return "High Potential";
        case Z.HIGH_POTENTIAL_AUTO:
          return "High Potential Auto";
        case Z.MALT_LINKER:
          return "Malt Linker";
        case Z.NEW:
          return "New";
        case Z.SUPER_MALTER:
          return "Supermalter";
        case Z.VERIFIED:
          return "Verified";
        default:
          return "Supermalter";
      }
    });
    return (l, n) => (c(), v("span", yn, [
      e.type === F(Z).SUPER_MALTER ? (c(!0), v(H, { key: 0 }, G(e.superMalterLevel, (i, a) => (c(), v("svg", {
        key: a,
        class: "joy-badge-level__supermalter",
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 12 18"
      }, [...n[0] || (n[0] = [
        h("path", {
          fill: "#264FFA",
          d: "M5.71533 12.2962 11.4243 18l.0049-11.45716-5.71387 5.75336Z"
        }, null, -1),
        h("path", {
          fill: "#FC5757",
          d: "M.00195312 6.54284.00671145 18 5.7158 12.2962.00195312 6.54284Z"
        }, null, -1),
        h("path", {
          fill: "#FFC200",
          d: "M11.4289 5.68249c-.0059-1.52434-.6069-2.9554-1.69067-4.02851C8.95862.882797 7.99681.362073 6.9506.132677 6.95037.132599 6.95021.132599 6.94998.132521c-.04337-.009516-.08681-.018408-.13041-.02691-.0057-.001092-.01147-.002184-.01724-.003276-.0383-.0073317-.07675-.0142735-.11529-.0208255-.01068-.001794-.02144-.00351-.03213-.005304-.03385-.0055379-.06778-.0108418-.10179-.0158338-.01505-.002184-.03011-.0042121-.04516-.0063181-.03011-.0041339-.06022-.008112-.0904-.0117779-.01857-.002262-.03721-.0042901-.05577-.006396C6.33472.0328377 6.30766.029952 6.28051.0273 6.25914.025194 6.23769.0233999 6.21624.0215279 6.19144.0194219 6.16671.017316 6.14183.015522 6.11851.013806 6.09511.0123239 6.07171.0109199 6.04831.00951588 6.02483.00811199 6.00135.006942 5.9771.00577201 5.95276.00483616 5.92842.00397816 5.90541.00312017 5.8824.00234019 5.85931.00179419c-.02433-.00062399-.04874-.0009362-.07316-.0012482C5.76267.000234 5.73912 0 5.71564 0c-.02355 0-.04703.000234-.07051.000546-.02442.000312-.04883.0006242-.07316.00124819-.02309.000546-.0461.00140398-.06911.00218397-.02434.000858-.04859.00179385-.07293.00296384-.02348.00116999-.04696.00257388-.07036.0039779-.0234.001404-.0468.0028861-.07012.0046021-.0248.001794-.0496.0038999-.07441.0060059-.02145.001872-.0429.0036661-.06427.0057721-.02714.002652-.05421.0055377-.08135.0085797-.01857.0021059-.03721.004134-.05577.006396-.03019.0036659-.06037.007644-.09048.0117779-.01506.002106-.03011.0041341-.04516.0063181-.03401.004992-.06794.0102959-.10179.0158338-.01077.001794-.02145.00351-.03214.005304-.03853.006552-.07699.0134938-.11528.0208255-.00578.001092-.01155.002184-.01724.003276-.0436.008502-.08705.017394-.13041.02691-.00024.000078-.00047.000078-.00071.000156C3.43424.361995 2.4725.882719 1.6929 1.65398.609098 2.72702.00811193 4.15815.00218397 5.68249L0 6.15064l.00171623.39226L5.71556 12.2962l5.71384-5.7533.0017-.39202-.0022-.46839Z"
        }, null, -1)
      ])]))), 128)) : k("", !0),
      e.type === F(Z).HIGH_POTENTIAL ? (c(), v("svg", mn, [...n[1] || (n[1] = [
        h("path", {
          d: "M0.0635011 7.89462C0.0715011 5.91062 0.853501 4.04762 2.2645 2.65062C3.2795 1.64662 4.5315 0.96862 5.8925 0.67062H5.8935C5.9495 0.65862 6.0065 0.64662 6.0635 0.63562C6.0705 0.63362 6.0785 0.63262 6.0855 0.63062C6.1355 0.62062 6.1855 0.61162 6.2355 0.60362C6.2495 0.60162 6.2635 0.59862 6.2775 0.59662C6.3215 0.58962 6.3655 0.58262 6.4105 0.57662C6.4305 0.57362 6.4495 0.57062 6.4695 0.56862C6.5075 0.56262 6.5475 0.55762 6.5865 0.55262C6.6105 0.54962 6.6345 0.54662 6.6595 0.54462C6.6945 0.54062 6.7295 0.53662 6.7655 0.53362C6.7925 0.53062 6.8205 0.52762 6.8485 0.52562C6.8805 0.52262 6.9135 0.52062 6.9455 0.51762C6.9755 0.51562 7.0065 0.51362 7.0365 0.51162C7.0665 0.50962 7.0975 0.50762 7.1285 0.50662C7.1605 0.50462 7.1915 0.50362 7.2235 0.50262C7.2535 0.50162 7.2835 0.50062 7.3135 0.49962C7.3455 0.49862 7.3765 0.49862 7.4085 0.49762C7.4385 0.49762 7.4695 0.49762 7.5005 0.49762C7.5305 0.49762 7.5615 0.49762 7.5915 0.49862C7.6235 0.49862 7.6555 0.49962 7.6865 0.50062C7.7165 0.50162 7.7465 0.50262 7.7765 0.50362C7.8085 0.50362 7.8405 0.50562 7.8725 0.50662C7.9035 0.50762 7.9335 0.50962 7.9645 0.51162C7.9945 0.51362 8.0255 0.51562 8.0555 0.51762C8.0875 0.51962 8.1205 0.52262 8.1525 0.52562C8.1795 0.52762 8.2075 0.53062 8.2355 0.53362C8.2705 0.53662 8.3055 0.54062 8.3415 0.54462C8.3655 0.54762 8.3895 0.54962 8.4145 0.55262C8.4535 0.55762 8.4925 0.56262 8.5315 0.56762C8.5515 0.57062 8.5705 0.57362 8.5905 0.57662C8.6345 0.58262 8.6785 0.58962 8.7225 0.59762C8.7365 0.59962 8.7505 0.60162 8.7645 0.60362C8.8145 0.61262 8.8645 0.62162 8.9145 0.63062C8.9215 0.63162 8.9295 0.63362 8.9365 0.63462C8.9935 0.64662 9.0505 0.65762 9.1065 0.67062H9.1075C10.4695 0.96962 11.7215 1.64662 12.7355 2.65062C14.1465 4.04762 14.9285 5.91062 14.9365 7.89462L14.9395 8.50362L14.9375 9.01462L7.5005 16.5026L0.0625011 9.01462L0.0605011 8.50362L0.0635011 7.89462Z",
          fill: "#FFC200"
        }, null, -1)
      ])])) : k("", !0),
      e.type === F(Z).HIGH_POTENTIAL_AUTO ? (c(), v("svg", pn, [...n[2] || (n[2] = [
        h("path", {
          fill: "#EF4E16",
          d: "M60 23.913s-8.76-2.903-14.05 1.058C44.256 17.449 45.203 8.674 34.688 2c-.712 9.413-12.856 9.891-15.691 22.005-1.86-3.319-2.227-7.716-9.28-9.871C11.615 25.513.415 31.3 5.199 47.68c2.699 9.246 12.72 13.651 21.047 14.217 16.527 1.123 31.896-6.848 32.258-24.148.155-7.437-2.975-8.343 1.496-13.836z"
        }, null, -1),
        h("path", {
          fill: "#F9B700",
          d: "M53.226 32.962c-6.012-.063-5.458 2.387-9.883 3.896-3.212-5.842-.067-13.682-10.056-19.364.066 10.625-7.32 7.313-10.414 17.456-3.758-2.145-1.943-6.888-9.256-8.89 4.042 6.349-.99 7.542-3.526 13.335-5.093 11.632 7.181 19.813 16.548 20.382 13.019.793 25.124-4.834 25.408-17.048.122-5.25-2.342-5.888 1.179-9.767z"
        }, null, -1),
        h("path", {
          fill: "#FFE463",
          d: "M47.616 41.169c-4.47-.041-4.061 1.522-7.351 2.484-2.391-3.727-.051-8.729-7.479-12.354.049 6.778-5.446 4.666-7.746 11.137-2.795-1.368-1.447-4.395-6.885-5.672 3.006 4.051-.735 4.812-2.621 8.508-3.791 7.421 5.339 12.64 12.307 13.003 9.683.506 18.686-3.084 18.896-10.876.093-3.348-1.741-3.755.879-6.23z"
        }, null, -1),
        h("path", {
          fill: "#FFF7D1",
          d: "M37.182 54.939c0 2.188-12.427 2.188-12.427 0 0-5.849 12.427-5.849 12.427 0z"
        }, null, -1)
      ])])) : k("", !0),
      e.type === F(Z).MALT_LINKER ? (c(), v("svg", vn, [...n[3] || (n[3] = [
        h("path", {
          d: "M5.77736 10.4456C4.45736 10.4406 3.21936 9.91961 2.29036 8.98161C1.62236 8.30661 1.17136 7.47461 0.97336 6.56861C0.97336 6.56861 0.97336 6.56861 0.97336 6.56761C0.96536 6.53061 0.95736 6.49361 0.94936 6.45561C0.94936 6.45061 0.94836 6.44561 0.94736 6.44061C0.94136 6.40761 0.93536 6.37461 0.92936 6.34061C0.92736 6.33161 0.92636 6.32261 0.92436 6.31261C0.91936 6.28361 0.91536 6.25461 0.91036 6.22461C0.90836 6.21161 0.90736 6.19861 0.90536 6.18561C0.90136 6.15961 0.89836 6.13361 0.89536 6.10761C0.89336 6.09161 0.89136 6.07561 0.88936 6.05961C0.88636 6.03561 0.88436 6.01261 0.88236 5.98861C0.88036 5.97061 0.87836 5.95161 0.87736 5.93361C0.87536 5.91161 0.87336 5.89061 0.87136 5.86861C0.87036 5.84861 0.86836 5.82861 0.86736 5.80761C0.86636 5.78761 0.86536 5.76661 0.86436 5.74661C0.86336 5.72661 0.86236 5.70561 0.86136 5.68461C0.86036 5.66461 0.86036 5.64461 0.85936 5.62461C0.85936 5.60361 0.85936 5.58161 0.85836 5.56061C0.85836 5.54061 0.85836 5.51961 0.85836 5.49961C0.85836 5.47961 0.85836 5.45861 0.85836 5.43861C0.85836 5.41761 0.85936 5.39661 0.85936 5.37561C0.85936 5.35561 0.86036 5.33561 0.86136 5.31561C0.86236 5.29461 0.86336 5.27361 0.86436 5.25261C0.86536 5.23261 0.86636 5.21161 0.86736 5.19161C0.86836 5.17161 0.86936 5.15161 0.87136 5.13061C0.87336 5.10961 0.87436 5.08761 0.87636 5.06661C0.87836 5.04761 0.88036 5.02961 0.88236 5.01061C0.88436 4.98661 0.88736 4.96361 0.88936 4.94061C0.89136 4.92461 0.89336 4.90861 0.89536 4.89261C0.89836 4.86661 0.90236 4.84061 0.90536 4.81461C0.90736 4.80061 0.90836 4.78761 0.91036 4.77461C0.91436 4.74561 0.91936 4.71561 0.92436 4.68661C0.92636 4.67761 0.92736 4.66761 0.92936 4.65861C0.93536 4.62561 0.94136 4.59161 0.94736 4.55861C0.94836 4.55361 0.94936 4.54861 0.95036 4.54361C0.95736 4.50561 0.96536 4.46861 0.97336 4.43061C0.97336 4.43061 0.97336 4.43061 0.97336 4.42961C1.17136 3.52561 1.62236 2.69261 2.29036 2.01761C3.21936 1.07961 4.45836 0.559612 5.77736 0.554612L6.18236 0.552612L6.52236 0.553612L11.5024 5.49961L6.52236 10.4456L6.18236 10.4476L5.77736 10.4456Z",
          fill: "#E3F8FB"
        }, null, -1),
        h("path", {
          d: "M17.2235 0.554612C18.5425 0.559612 19.7815 1.07961 20.7105 2.01761C21.3785 2.69261 21.8285 3.52461 22.0275 4.43061C22.0275 4.43061 22.0275 4.43061 22.0275 4.43161C22.0355 4.46961 22.0435 4.50661 22.0505 4.54461C22.0515 4.54961 22.0525 4.55461 22.0535 4.55961C22.0595 4.59261 22.0655 4.62561 22.0715 4.65961C22.0735 4.66861 22.0745 4.67861 22.0765 4.68761C22.0815 4.71661 22.0855 4.74661 22.0905 4.77561C22.0925 4.78861 22.0945 4.80161 22.0955 4.81461C22.0995 4.84061 22.1025 4.86661 22.1055 4.89261C22.1075 4.90861 22.1095 4.92461 22.1115 4.94061C22.1145 4.96361 22.1165 4.98761 22.1185 5.01061C22.1205 5.02961 22.1215 5.04761 22.1235 5.06661C22.1255 5.08761 22.1275 5.10961 22.1285 5.13061C22.1295 5.15061 22.1315 5.17061 22.1325 5.19161C22.1335 5.21161 22.1345 5.23261 22.1355 5.25261C22.1365 5.27361 22.1375 5.29461 22.1385 5.31561C22.1395 5.33561 22.1395 5.35561 22.1405 5.37561C22.1415 5.39661 22.1415 5.41761 22.1415 5.43861C22.1415 5.45861 22.1415 5.47961 22.1415 5.49961C22.1415 5.51961 22.1415 5.54061 22.1415 5.56061C22.1415 5.58161 22.1405 5.60261 22.1405 5.62361C22.1405 5.64361 22.1395 5.66361 22.1385 5.68361C22.1375 5.70461 22.1365 5.72561 22.1355 5.74661C22.1345 5.76661 22.1335 5.78761 22.1325 5.80761C22.1315 5.82761 22.1305 5.84761 22.1285 5.86861C22.1265 5.88961 22.1255 5.91161 22.1235 5.93261C22.1215 5.95161 22.1205 5.96961 22.1185 5.98861C22.1165 6.01261 22.1135 6.03561 22.1115 6.05861C22.1095 6.07461 22.1075 6.09061 22.1055 6.10661C22.1025 6.13261 22.0985 6.15861 22.0955 6.18461C22.0935 6.19761 22.0915 6.21061 22.0905 6.22361C22.0865 6.25261 22.0815 6.28261 22.0765 6.31161C22.0745 6.32061 22.0735 6.33061 22.0715 6.33961C22.0655 6.37261 22.0595 6.40661 22.0535 6.43961C22.0525 6.44461 22.0515 6.44961 22.0505 6.45461C22.0435 6.49261 22.0355 6.52961 22.0275 6.56761C22.0275 6.56761 22.0275 6.56761 22.0275 6.56861C21.8285 7.47461 21.3785 8.30661 20.7105 8.98161C19.7815 9.91961 18.5425 10.4396 17.2235 10.4446L16.8185 10.4466L16.4785 10.4456L11.4985 5.49961L16.4785 0.553612L16.8175 0.552612L17.2235 0.554612Z",
          fill: "#FF91F0"
        }, null, -1)
      ])])) : k("", !0),
      e.type === F(Ge).HIGH_POTENTIAL ? (c(), v("svg", hn, [...n[4] || (n[4] = [
        h("path", {
          d: "M0.0635011 7.89462C0.0715011 5.91062 0.853501 4.04762 2.2645 2.65062C3.2795 1.64662 4.5315 0.96862 5.8925 0.67062H5.8935C5.9495 0.65862 6.0065 0.64662 6.0635 0.63562C6.0705 0.63362 6.0785 0.63262 6.0855 0.63062C6.1355 0.62062 6.1855 0.61162 6.2355 0.60362C6.2495 0.60162 6.2635 0.59862 6.2775 0.59662C6.3215 0.58962 6.3655 0.58262 6.4105 0.57662C6.4305 0.57362 6.4495 0.57062 6.4695 0.56862C6.5075 0.56262 6.5475 0.55762 6.5865 0.55262C6.6105 0.54962 6.6345 0.54662 6.6595 0.54462C6.6945 0.54062 6.7295 0.53662 6.7655 0.53362C6.7925 0.53062 6.8205 0.52762 6.8485 0.52562C6.8805 0.52262 6.9135 0.52062 6.9455 0.51762C6.9755 0.51562 7.0065 0.51362 7.0365 0.51162C7.0665 0.50962 7.0975 0.50762 7.1285 0.50662C7.1605 0.50462 7.1915 0.50362 7.2235 0.50262C7.2535 0.50162 7.2835 0.50062 7.3135 0.49962C7.3455 0.49862 7.3765 0.49862 7.4085 0.49762C7.4385 0.49762 7.4695 0.49762 7.5005 0.49762C7.5305 0.49762 7.5615 0.49762 7.5915 0.49862C7.6235 0.49862 7.6555 0.49962 7.6865 0.50062C7.7165 0.50162 7.7465 0.50262 7.7765 0.50362C7.8085 0.50362 7.8405 0.50562 7.8725 0.50662C7.9035 0.50762 7.9335 0.50962 7.9645 0.51162C7.9945 0.51362 8.0255 0.51562 8.0555 0.51762C8.0875 0.51962 8.1205 0.52262 8.1525 0.52562C8.1795 0.52762 8.2075 0.53062 8.2355 0.53362C8.2705 0.53662 8.3055 0.54062 8.3415 0.54462C8.3655 0.54762 8.3895 0.54962 8.4145 0.55262C8.4535 0.55762 8.4925 0.56262 8.5315 0.56762C8.5515 0.57062 8.5705 0.57362 8.5905 0.57662C8.6345 0.58262 8.6785 0.58962 8.7225 0.59762C8.7365 0.59962 8.7505 0.60162 8.7645 0.60362C8.8145 0.61262 8.8645 0.62162 8.9145 0.63062C8.9215 0.63162 8.9295 0.63362 8.9365 0.63462C8.9935 0.64662 9.0505 0.65762 9.1065 0.67062H9.1075C10.4695 0.96962 11.7215 1.64662 12.7355 2.65062C14.1465 4.04762 14.9285 5.91062 14.9365 7.89462L14.9395 8.50362L14.9375 9.01462L7.5005 16.5026L0.0625011 9.01462L0.0605011 8.50362L0.0635011 7.89462Z",
          fill: "#FFC200"
        }, null, -1)
      ])])) : k("", !0),
      h("span", {
        class: B([
          {
            "joy-badge-level__tag": e.visibleText,
            red: e.type === F(Z).NEW || e.type === F(Z).MALT_LINKER || e.type === F(Z).HIGH_POTENTIAL_AUTO,
            blue: e.type === F(Ge).HIGH_POTENTIAL || e.type === F(Z).HIGH_POTENTIAL || e.type === F(Z).SUPER_MALTER,
            turquoise: e.type === F(Z).VERIFIED
          }
        ])
      }, [
        e.visibleText ? w(l.$slots, "default", { key: 0 }, () => [
          R(P(o.value), 1)
        ], !0) : k("", !0)
      ], 2)
    ]));
  }
}), bu = /* @__PURE__ */ z(gn, [["__scopeId", "data-v-08a5e2c8"]]), bn = /* @__PURE__ */ A({
  __name: "VJoyBlockSkeleton",
  props: {
    /** If you want to use it properly you need to set fixed width and height */
    circle: {
      type: Boolean,
      default: !1
    },
    /** Size in any unit. Example: 50px, 100%... */
    width: {
      type: String
    },
    /** Size in any unit. */
    height: {
      type: String
    }
  },
  setup(e) {
    const t = e, o = ce("VJoyWrapperContext", {}), l = V(() => {
      if (Object.keys(o).length === 0)
        return;
      let n = "1 0";
      return t.width && (n += ` ${t.width}`), n;
    });
    return (n, i) => (c(), v("div", {
      "aria-hidden": "true",
      class: B({
        "joy-block-skeleton": !0,
        "joy-block-skeleton--circle": e.circle
      }),
      style: X({
        "max-width": e.width,
        height: e.height,
        flex: l.value
      })
    }, null, 6));
  }
}), wu = /* @__PURE__ */ z(bn, [["__scopeId", "data-v-4da2c7cb"]]), wn = /* @__PURE__ */ A({
  __name: "VJoySpinner",
  props: {
    color: {
      type: String
    }
  },
  setup(e) {
    return (t, o) => (c(), v("div", {
      class: B(["joy-spinner", `joy-spinner_${e.color}`])
    }, null, 2));
  }
}), Xt = /* @__PURE__ */ z(wn, [["__scopeId", "data-v-52944a9b"]]), jn = /* @__PURE__ */ A({
  __name: "VJoyButton",
  props: {
    /**
     * If you only need a button with an icon. To keep your component accessible, you can give a text as slot, it will be used as title and aria-label.
     * This property takes effect only if icon property is set
     * @deprecated Use `VJoyIconButton` instead.
     */
    circle: {
      type: Boolean,
      default: !1
    },
    /** The button takes all the available space (100% width) */
    full: {
      type: Boolean,
      default: !1
    },
    /** Name of the icon, placed before the text */
    icon: {
      type: String
    },
    /** Left to the text or right */
    iconPosition: {
      type: String,
      default: "left"
    },
    /**
     * Use default slot or label property.
     */
    label: {
      type: String
    },
    /** Change the component's state and display a JoySpinner. */
    loading: {
      type: Boolean,
      default: !1
    },
    /** Button or Link color variant */
    variant: {
      type: String,
      default: "primary"
    },
    /** Button or Link size */
    size: {
      type: String,
      default: "medium"
    },
    id: {
      type: String
    }
  },
  setup(e, { expose: t }) {
    const o = e, l = oe(), n = De() + "--JoyButton", i = V(() => ["ghost", "secondary"].includes(o.variant) ? "teal" : "white");
    return t({ generatedId: n }), (a, r) => {
      const u = dt("joy-ripple");
      return Xe((c(), T(Y(F(l).href ? "a" : "button"), {
        id: e.id,
        disabled: e.loading || F(l).disabled,
        type: F(l).type || "button",
        class: B([
          "joy-button",
          `joy-button_${e.variant}`,
          `joy-button_${e.size}`,
          {
            "joy-button_circle": e.circle,
            "joy-button_loading": e.loading,
            "joy-button_full": e.full
          }
        ]),
        "aria-labelledby": (a.$slots.default || e.label) && n
      }, {
        default: J(() => [
          e.icon && e.iconPosition === "left" ? (c(), T(D, {
            key: 0,
            class: "joy-button_icon joy-button_icon--left",
            name: e.icon,
            "aria-hidden": "true"
          }, null, 8, ["name"])) : k("", !0),
          e.loading ? (c(), T(Xt, {
            key: 1,
            color: i.value
          }, null, 8, ["color"])) : k("", !0),
          h("span", {
            id: n,
            class: "joy-button--slot"
          }, [
            w(a.$slots, "default", {}, () => [
              R(P(e.label), 1)
            ], !0)
          ]),
          e.icon && e.iconPosition === "right" ? (c(), T(D, {
            key: 2,
            class: "joy-button_icon joy-button_icon--right",
            name: e.icon,
            "aria-hidden": "true"
          }, null, 8, ["name"])) : k("", !0)
        ]),
        _: 3
      }, 8, ["id", "disabled", "type", "class", "aria-labelledby"])), [
        [u]
      ]);
    };
  }
}), Ee = /* @__PURE__ */ z(jn, [["__scopeId", "data-v-5478bebe"]]);
function et(e) {
  return Dt() ? (Rt(e), !0) : !1;
}
function ge(e) {
  return typeof e == "function" ? e() : F(e);
}
const tt = typeof window < "u" && typeof document < "u";
typeof WorkerGlobalScope < "u" && globalThis instanceof WorkerGlobalScope;
const kn = (e) => e != null, _n = Object.prototype.toString, Qt = (e) => _n.call(e) === "[object Object]", Le = () => {
}, at = /* @__PURE__ */ $n();
function $n() {
  var e, t;
  return tt && ((e = window == null ? void 0 : window.navigator) == null ? void 0 : e.userAgent) && (/iP(ad|hone|od)/.test(window.navigator.userAgent) || ((t = window == null ? void 0 : window.navigator) == null ? void 0 : t.maxTouchPoints) > 2 && /iPad|Macintosh/.test(window == null ? void 0 : window.navigator.userAgent));
}
function Cn(...e) {
  if (e.length !== 1)
    return Co(...e);
  const t = e[0];
  return typeof t == "function" ? So(xo(() => ({ get: t, set: Le }))) : $(t);
}
function $e(e) {
  var t;
  const o = ge(e);
  return (t = o == null ? void 0 : o.$el) != null ? t : o;
}
const mt = tt ? window : void 0;
function Ce(...e) {
  let t, o, l, n;
  if (typeof e[0] == "string" || Array.isArray(e[0]) ? ([o, l, n] = e, t = mt) : [t, o, l, n] = e, !t)
    return Le;
  Array.isArray(o) || (o = [o]), Array.isArray(l) || (l = [l]);
  const i = [], a = () => {
    i.forEach((m) => m()), i.length = 0;
  }, r = (m, d, f, p) => (m.addEventListener(d, f, p), () => m.removeEventListener(d, f, p)), u = W(
    () => [$e(t), ge(n)],
    ([m, d]) => {
      if (a(), !m)
        return;
      const f = Qt(d) ? { ...d } : d;
      i.push(
        ...o.flatMap((p) => l.map((y) => r(m, p, y, f)))
      );
    },
    { immediate: !0, flush: "post" }
  ), s = () => {
    u(), a();
  };
  return et(s), s;
}
let Vt = !1;
function Sn(e, t, o = {}) {
  const { window: l = mt, ignore: n = [], capture: i = !0, detectIframe: a = !1 } = o;
  if (!l)
    return Le;
  at && !Vt && (Vt = !0, Array.from(l.document.body.children).forEach((f) => f.addEventListener("click", Le)), l.document.documentElement.addEventListener("click", Le));
  let r = !0;
  const u = (f) => n.some((p) => {
    if (typeof p == "string")
      return Array.from(l.document.querySelectorAll(p)).some((y) => y === f.target || f.composedPath().includes(y));
    {
      const y = $e(p);
      return y && (f.target === y || f.composedPath().includes(y));
    }
  }), m = [
    Ce(l, "click", (f) => {
      const p = $e(e);
      if (!(!p || p === f.target || f.composedPath().includes(p))) {
        if (f.detail === 0 && (r = !u(f)), !r) {
          r = !0;
          return;
        }
        t(f);
      }
    }, { passive: !0, capture: i }),
    Ce(l, "pointerdown", (f) => {
      const p = $e(e);
      r = !u(f) && !!(p && !f.composedPath().includes(p));
    }, { passive: !0 }),
    a && Ce(l, "blur", (f) => {
      setTimeout(() => {
        var p;
        const y = $e(e);
        ((p = l.document.activeElement) == null ? void 0 : p.tagName) === "IFRAME" && !(y != null && y.contains(l.document.activeElement)) && t(f);
      }, 0);
    })
  ].filter(Boolean);
  return () => m.forEach((f) => f());
}
function xn() {
  const e = $(!1), t = Vo();
  return t && ee(() => {
    e.value = !0;
  }, t), e;
}
function Vn(e) {
  const t = xn();
  return V(() => (t.value, !!e()));
}
function Tn(e, t = {}) {
  const o = $(!1), l = Nt(null);
  let n = 0, i = !0;
  if (tt) {
    const a = typeof t == "function" ? { onDrop: t } : t, r = (u) => {
      var s, m;
      const d = Array.from((m = (s = u.dataTransfer) == null ? void 0 : s.files) != null ? m : []);
      return l.value = d.length === 0 ? null : d;
    };
    Ce(e, "dragenter", (u) => {
      var s, m;
      const d = Array.from(((s = u == null ? void 0 : u.dataTransfer) == null ? void 0 : s.items) || []).map((f) => f.kind === "file" ? f.type : null).filter(kn);
      if (a.dataTypes && u.dataTransfer) {
        const f = F(a.dataTypes);
        if (i = typeof f == "function" ? f(d) : f ? f.some((p) => d.includes(p)) : !0, !i)
          return;
      }
      u.preventDefault(), n += 1, o.value = !0, (m = a.onEnter) == null || m.call(a, r(u), u);
    }), Ce(e, "dragover", (u) => {
      var s;
      i && (u.preventDefault(), (s = a.onOver) == null || s.call(a, r(u), u));
    }), Ce(e, "dragleave", (u) => {
      var s;
      i && (u.preventDefault(), n -= 1, n === 0 && (o.value = !1), (s = a.onLeave) == null || s.call(a, r(u), u));
    }), Ce(e, "drop", (u) => {
      var s;
      u.preventDefault(), n = 0, o.value = !1, (s = a.onDrop) == null || s.call(a, r(u), u);
    });
  }
  return {
    files: l,
    isOverDropZone: o
  };
}
function In(e, t, o = {}) {
  const { window: l = mt, ...n } = o;
  let i;
  const a = Vn(() => l && "ResizeObserver" in l), r = () => {
    i && (i.disconnect(), i = void 0);
  }, u = V(() => Array.isArray(e) ? e.map((d) => $e(d)) : [$e(e)]), s = W(
    u,
    (d) => {
      if (r(), a.value && l) {
        i = new ResizeObserver(t);
        for (const f of d)
          f && i.observe(f, n);
      }
    },
    { immediate: !0, flush: "post" }
  ), m = () => {
    r(), s();
  };
  return et(m), {
    isSupported: a,
    stop: m
  };
}
function Ln(e) {
  var t;
  const o = $(e == null ? void 0 : e.element), l = $(e == null ? void 0 : e.input), n = (t = e == null ? void 0 : e.styleProp) != null ? t : "height", i = $(1);
  function a() {
    var r, u;
    if (!o.value)
      return;
    let s = "";
    o.value.style[n] = "1px", i.value = (r = o.value) == null ? void 0 : r.scrollHeight, e != null && e.styleTarget ? ge(e.styleTarget).style[n] = `${i.value}px` : s = `${i.value}px`, o.value.style[n] = s, (u = e == null ? void 0 : e.onResize) == null || u.call(e);
  }
  return W([l, o], () => Fe(a), { immediate: !0 }), In(o, () => a()), e != null && e.watch && W(e.watch, a, { immediate: !0, deep: !0 }), {
    textarea: o,
    input: l,
    triggerResize: a
  };
}
const pt = /* @__PURE__ */ A({
  name: "OnClickOutside",
  props: ["as", "options"],
  emits: ["trigger"],
  setup(e, { slots: t, emit: o }) {
    const l = $();
    return Sn(l, (n) => {
      o("trigger", n);
    }, e.options), () => {
      if (t.default)
        return To(e.as || "div", { ref: l }, t.default());
    };
  }
});
function Bn(e) {
  var t;
  const o = ge(e);
  return (t = o == null ? void 0 : o.$el) != null ? t : o;
}
const An = tt ? window : void 0;
function En(...e) {
  let t, o, l, n;
  if (typeof e[0] == "string" || Array.isArray(e[0]) ? ([o, l, n] = e, t = An) : [t, o, l, n] = e, !t)
    return Le;
  Array.isArray(o) || (o = [o]), Array.isArray(l) || (l = [l]);
  const i = [], a = () => {
    i.forEach((m) => m()), i.length = 0;
  }, r = (m, d, f, p) => (m.addEventListener(d, f, p), () => m.removeEventListener(d, f, p)), u = W(
    () => [Bn(t), ge(n)],
    ([m, d]) => {
      if (a(), !m)
        return;
      const f = Qt(d) ? { ...d } : d;
      i.push(
        ...o.flatMap((p) => l.map((y) => r(m, p, y, f)))
      );
    },
    { immediate: !0, flush: "post" }
  ), s = () => {
    u(), a();
  };
  return et(s), s;
}
function lt(e) {
  return typeof Window < "u" && e instanceof Window ? e.document.documentElement : typeof Document < "u" && e instanceof Document ? e.documentElement : e;
}
function eo(e) {
  const t = window.getComputedStyle(e);
  if (t.overflowX === "scroll" || t.overflowY === "scroll" || t.overflowX === "auto" && e.clientWidth < e.scrollWidth || t.overflowY === "auto" && e.clientHeight < e.scrollHeight)
    return !0;
  {
    const o = e.parentNode;
    return !o || o.tagName === "BODY" ? !1 : eo(o);
  }
}
function zn(e) {
  const t = e || window.event, o = t.target;
  return eo(o) ? !1 : t.touches.length > 1 ? !0 : (t.preventDefault && t.preventDefault(), !1);
}
const He = /* @__PURE__ */ new WeakMap();
function Jn(e, t = !1) {
  const o = $(t);
  let l = null, n;
  W(Cn(e), (r) => {
    const u = lt(ge(r));
    if (u) {
      const s = u;
      He.get(s) || He.set(s, n), o.value && (s.style.overflow = "hidden");
    }
  }, {
    immediate: !0
  });
  const i = () => {
    const r = lt(ge(e));
    !r || o.value || (at && (l = En(
      r,
      "touchmove",
      (u) => {
        zn(u);
      },
      { passive: !1 }
    )), r.style.overflow = "hidden", o.value = !0);
  }, a = () => {
    var r;
    const u = lt(ge(e));
    !u || !o.value || (at && (l == null || l()), u.style.overflow = (r = He.get(u)) != null ? r : "", He.delete(u), o.value = !1);
  };
  return et(a), V({
    get() {
      return o.value;
    },
    set(r) {
      r ? i() : a();
    }
  });
}
function Pn() {
  let e = !1;
  const t = $(!1);
  return (o, l) => {
    if (t.value = l.value, e)
      return;
    e = !0;
    const n = Jn(o, l.value);
    W(t, (i) => n.value = i);
  };
}
Pn();
const Mn = { class: "joy-bottom-sheet_content" }, Fn = { class: "joy-bottom-sheet_footer" }, Tt = 75, It = "moving", On = /* @__PURE__ */ A({
  inheritAttrs: !1,
  __name: "VJoyBottomSheet",
  props: {
    closeLabel: { default: "Close" },
    open: { type: Boolean, default: !1 },
    preventBodyScroll: { type: Boolean, default: !0 },
    teleport: { default: "body" },
    frozen: { type: Boolean, default: !1 }
  },
  emits: ["bottom-sheet:close"],
  setup(e, { expose: t, emit: o }) {
    const l = e, n = oe(), i = V(() => {
      if (u.value)
        return n;
    }), a = o, r = {
      ignore: ["[data-click-outside-ignore]"]
    }, u = $(!1), s = $(!1), m = $(l.open), d = $(!1), f = $();
    let p = 0;
    function y() {
      m.value = !0, x();
    }
    function g() {
      l.frozen || (s.value = !0, setTimeout(async () => {
        d.value = !1, s.value = !1, m.value = !1, he(!1), a("bottom-sheet:close");
      }, 300));
    }
    function b(M) {
      d.value = !0, f.value.classList.add(It), p = S(M);
    }
    function C(M) {
      d.value && (j(M) > Tt && g(), L());
    }
    function _(M) {
      if (d.value) {
        const E = j(M);
        E > Tt ? g() : E > 0 && I(E);
      }
    }
    function j(M) {
      return S(M) - p;
    }
    function S(M) {
      return ["touchend", "touchmove", "touchstart"].includes(M.type) ? M.changedTouches[0].clientY : M.clientY;
    }
    function I(M) {
      f.value.style.setProperty("transform", `translateY(${M}px)`);
    }
    function L() {
      f.value.classList.remove(It), f.value.style.removeProperty("transform"), d.value = !1;
    }
    function x() {
      l.preventBodyScroll && he(!0);
    }
    return W(
      () => l.open,
      (M) => {
        M === !0 ? y() : g();
      }
    ), ee(() => {
      u.value = !0, l.open && x();
    }), t({
      hide: g,
      show: y,
      isOpen: m,
      moveContainer: I
    }), (M, E) => u.value ? (c(), T(Te, {
      key: 0,
      to: e.teleport
    }, [
      m.value ? (c(), v("div", N({ key: 0 }, i.value, {
        class: [
          "joy-bottom-sheet",
          {
            "joy-bottom-sheet--open": m.value,
            "joy-bottom-sheet--hiding": s.value && m.value,
            "joy-bottom-sheet--frozen": e.frozen
          }
        ]
      }), [
        E[1] || (E[1] = h("div", { class: "joy-bottom-sheet-overlay" }, null, -1)),
        O(F(pt), {
          options: r,
          onTrigger: g
        }, {
          default: J(() => [
            h("div", {
              ref_key: "bottomSheetContainerElement",
              ref: f,
              class: "joy-bottom-sheet-container"
            }, [
              h("div", {
                class: "joy-bottom-sheet_header",
                onMousedown: b,
                onMouseup: C,
                onMousemove: _,
                onMouseleave: C,
                onTouchstart: b,
                onTouchend: C,
                onTouchmove: _
              }, [...E[0] || (E[0] = [
                h("div", { class: "joy-bottom-sheet_header-close" }, null, -1)
              ])], 32),
              h("div", Mn, [
                w(M.$slots, "bottom-sheet-content", {}, void 0, !0)
              ]),
              h("div", Fn, [
                w(M.$slots, "bottom-sheet-cta", {}, () => [
                  O(Ee, {
                    class: "joy-bottom-sheet_footer-close",
                    label: e.closeLabel,
                    onClick: g
                  }, null, 8, ["label"])
                ], !0)
              ])
            ], 512)
          ]),
          _: 3
        })
      ], 16)) : k("", !0)
    ], 8, ["to"])) : k("", !0);
  }
}), ju = /* @__PURE__ */ z(On, [["__scopeId", "data-v-0f122c0c"]]), ku = /* @__PURE__ */ A({
  __name: "VJoyBottomSheetTrigger",
  props: {
    bottomSheet: {}
  },
  emits: ["click"],
  setup(e, { emit: t }) {
    const o = e, l = t, n = V(() => o.bottomSheet), i = K(), a = V(() => i.default());
    function r() {
      var u;
      l("click"), (u = n.value) == null || u.show();
    }
    return (u, s) => (c(!0), v(H, null, G(a.value, (m) => (c(), T(Y(m), {
      key: m,
      onClick: r
    }))), 128));
  }
}), Dn = /* @__PURE__ */ A({
  inheritAttrs: !1,
  __name: "VJoyButtonCard",
  props: {
    disabled: { type: Boolean, default: !1 },
    href: {},
    type: { default: "button" },
    align: { default: "left" }
  },
  setup(e) {
    const t = e, o = oe(), l = V(() => t.type === "button" && t.href ? "a" : t.type === "button" ? "div" : t.type), n = V(() => l.value === "a"), i = V(() => l.value === "div"), a = V(() => {
      if (t.disabled)
        return -1;
      if (i.value)
        return 0;
    });
    function r(s) {
      t.disabled && (s.preventDefault(), s.stopPropagation());
    }
    function u(s) {
      var m;
      i.value && (s.key !== "Enter" && s.key !== " " || (s.preventDefault(), !t.disabled && ((m = s.currentTarget) == null || m.click())));
    }
    return (s, m) => (c(), T(Y(l.value), N(F(o), {
      class: [
        "joy-button-card",
        `joy-button-card--align-${e.align}`,
        {
          "joy-button-card--disabled": e.disabled
        }
      ],
      href: n.value ? e.href : void 0,
      role: i.value ? "button" : void 0,
      "aria-disabled": e.disabled ? "true" : void 0,
      tabindex: a.value,
      onClick: r,
      onKeydown: u
    }), {
      default: J(() => [
        w(s.$slots, "default", {}, void 0, !0)
      ]),
      _: 3
    }, 16, ["class", "href", "role", "aria-disabled", "tabindex"]));
  }
}), _u = /* @__PURE__ */ z(Dn, [["__scopeId", "data-v-c87dff4c"]]), me = "JoyFormElementContext", Rn = { class: "joy-checkbox__wrapper" }, Nn = { class: "joy-checkbox__input-wrapper" }, qn = ["id", "name", "disabled", "checked", "required", "value", "indeterminate"], Hn = { class: "joy-checkbox__content-wrapper" }, Wn = { class: "joy-checkbox__content" }, Un = /* @__PURE__ */ A({
  __name: "VJoyCheckbox",
  props: {
    indeterminate: { type: Boolean, default: !1 },
    displayFocus: { type: Boolean, default: !0 },
    label: {},
    checked: { type: Boolean, default: !1 },
    invalid: { type: Boolean, default: !1 },
    value: { default: "on" },
    disabled: { type: Boolean, default: !1 },
    id: {},
    name: {},
    required: { type: Boolean, default: !1 }
  },
  emits: ["update:checked", "focus", "blur"],
  setup(e, { expose: t, emit: o }) {
    const l = o, n = e;
    te(me, !0);
    const i = $(), a = $(n.indeterminate), r = $(n.invalid && !n.checked), u = $(!1);
    W(
      () => n.invalid,
      (m) => {
        r.value = m && !n.checked;
      }
    ), W(
      () => n.checked,
      (m) => {
        m ? r.value = !1 : r.value = n.invalid;
      }
    );
    const s = {
      onChange: (m) => {
        const d = m.target.checked;
        a.value = !1, d ? r.value = !1 : r.value = n.invalid, l("update:checked", d);
      },
      onFocus: () => {
        u.value = !0, l("focus");
      },
      onBlur: () => {
        u.value = !1, l("blur");
      }
    };
    return t({
      isIndeterminate: a
    }), (m, d) => (c(), v("div", Rn, [
      h("label", {
        class: B([
          "joy-checkbox",
          {
            "joy-checkbox__checked": e.checked,
            "joy-checkbox__indeterminate": a.value,
            "joy-checkbox__disabled": e.disabled,
            "joy-checkbox__invalid": r.value,
            "joy-checkbox__focusing": u.value && e.displayFocus
          }
        ])
      }, [
        h("div", Nn, [
          h("input", {
            id: e.id,
            ref_key: "input",
            ref: i,
            "data-joy-form-field": "",
            type: "checkbox",
            class: "joy-checkbox__input",
            name: e.name,
            disabled: e.disabled,
            checked: e.checked,
            required: e.required,
            value: e.value,
            indeterminate: a.value,
            onChange: d[0] || (d[0] = //@ts-ignore
            (...f) => s.onChange && s.onChange(...f)),
            onFocus: d[1] || (d[1] = //@ts-ignore
            (...f) => s.onFocus && s.onFocus(...f)),
            onBlur: d[2] || (d[2] = //@ts-ignore
            (...f) => s.onBlur && s.onBlur(...f))
          }, null, 40, qn)
        ]),
        h("div", Hn, [
          w(m.$slots, "default", {}, () => [
            R(P(e.label), 1)
          ], !0)
        ])
      ], 2),
      h("div", Wn, [
        w(m.$slots, "checkbox-content", {}, void 0, !0)
      ])
    ]));
  }
}), vt = /* @__PURE__ */ z(Un, [["__scopeId", "data-v-c9d8e097"]]), Gn = { class: "joy-checkbox-card__header" }, Kn = { class: "joy-checkbox-card__labels" }, Yn = { class: "joy-checkbox-card__label" }, Zn = {
  key: 0,
  class: "joy-checkbox-card__sublabel"
}, Xn = {
  key: 0,
  class: "joy-checkbox-card__header-right"
}, Qn = {
  key: 0,
  class: "joy-checkbox-card__content"
}, el = /* @__PURE__ */ A({
  inheritAttrs: !1,
  __name: "VJoyCheckboxCard",
  props: {
    subLabel: { default: "" },
    fitContent: { type: Boolean, default: !1 },
    indeterminate: { type: Boolean, default: !1 },
    label: {},
    checked: { type: Boolean, default: !1 },
    invalid: { type: Boolean, default: !1 },
    value: { default: "on" },
    disabled: { type: Boolean, default: !1 },
    id: {},
    name: {},
    required: { type: Boolean, default: !1 }
  },
  emits: ["update:checked", "focus", "blur"],
  setup(e, { emit: t }) {
    const o = t, l = e, n = oe(), i = $(!1), a = $(!1), r = $(l.checked), u = $(l.indeterminate), s = $(), m = V(() => {
      const { subLabel: f, ...p } = l;
      return {
        ...n,
        ...p,
        checked: r.value,
        indeterminate: u.value
      };
    });
    W(
      () => l.checked,
      (f) => {
        r.value = f;
      }
    ), W(
      () => l.indeterminate,
      (f) => {
        u.value = f;
      }
    );
    const d = {
      onFocus: () => {
        i.value = !0, o("focus");
      },
      onBlur: () => {
        i.value = !1, o("blur");
      },
      onCheckedUpdate: (f) => {
        r.value = f, u.value = !1, o("update:checked", f);
      },
      onMouseEnter: () => {
        a.value = !0;
      },
      onMouseLeave: () => {
        a.value = !1;
      },
      onClick: (f) => {
        var g, b;
        if (l.disabled)
          return;
        const p = f.target;
        if (!p || p.closest("label, input") || p.closest('a, button, textarea, select, option, [role="button"], [data-no-card-toggle]'))
          return;
        const y = !r.value;
        r.value = y, u.value = !1, o("update:checked", y), (b = (g = s.value) == null ? void 0 : g.querySelector("input.joy-checkbox__input")) == null || b.focus(), i.value = !0, o("focus");
      }
    };
    return (f, p) => (c(), v("div", {
      ref_key: "cardRoot",
      ref: s,
      class: B([
        "joy-checkbox-card",
        {
          "joy-checkbox-card--hovered": a.value && !e.disabled,
          "joy-checkbox-card--checked": r.value,
          "joy-checkbox-card--indeterminate": u.value,
          "joy-checkbox-card--invalid": e.invalid && !r.value,
          "joy-checkbox-card--disabled": e.disabled,
          "joy-checkbox-card--focusing": i.value,
          "joy-checkbox-card--fit-content": e.fitContent
        }
      ]),
      onMouseenter: p[0] || (p[0] = //@ts-ignore
      (...y) => d.onMouseEnter && d.onMouseEnter(...y)),
      onMouseleave: p[1] || (p[1] = //@ts-ignore
      (...y) => d.onMouseLeave && d.onMouseLeave(...y)),
      onClick: p[2] || (p[2] = //@ts-ignore
      (...y) => d.onClick && d.onClick(...y))
    }, [
      O(vt, N(m.value, {
        "onUpdate:checked": d.onCheckedUpdate,
        onFocus: d.onFocus,
        onBlur: d.onBlur
      }), {
        "checkbox-content": J(() => [
          f.$slots["checkbox-card-content"] ? (c(), v("div", Qn, [
            w(f.$slots, "checkbox-card-content", {}, void 0, !0)
          ])) : k("", !0)
        ]),
        default: J(() => [
          h("div", Gn, [
            h("div", Kn, [
              h("div", Yn, P(e.label), 1),
              e.subLabel ? (c(), v("div", Zn, P(e.subLabel), 1)) : k("", !0)
            ]),
            f.$slots["header-right"] ? (c(), v("div", Xn, [
              w(f.$slots, "header-right", {}, void 0, !0)
            ])) : k("", !0)
          ])
        ]),
        _: 3
      }, 16, ["onUpdate:checked", "onFocus", "onBlur"])
    ], 34));
  }
}), $u = /* @__PURE__ */ z(el, [["__scopeId", "data-v-2598ae39"]]), it = Math.min, tl = Math.max, ol = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function rt(e, t, o) {
  return tl(e, it(t, o));
}
function Se(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function be(e) {
  return e.split("-")[0];
}
function Ne(e) {
  return e.split("-")[1];
}
function ht(e) {
  return e === "x" ? "y" : "x";
}
function gt(e) {
  return e === "y" ? "height" : "width";
}
function fe(e) {
  const t = e[0];
  return t === "t" || t === "b" ? "y" : "x";
}
function bt(e) {
  return ht(fe(e));
}
function nl(e, t, o) {
  o === void 0 && (o = !1);
  const l = Ne(e), n = bt(e), i = gt(n);
  let a = n === "x" ? l === (o ? "end" : "start") ? "right" : "left" : l === "start" ? "bottom" : "top";
  return t.reference[i] > t.floating[i] && (a = Ke(a)), [a, Ke(a)];
}
function ll(e) {
  const t = Ke(e);
  return [st(e), t, st(t)];
}
function st(e) {
  return e.includes("start") ? e.replace("start", "end") : e.replace("end", "start");
}
const Lt = ["left", "right"], Bt = ["right", "left"], al = ["top", "bottom"], il = ["bottom", "top"];
function rl(e, t, o) {
  switch (e) {
    case "top":
    case "bottom":
      return o ? t ? Bt : Lt : t ? Lt : Bt;
    case "left":
    case "right":
      return t ? al : il;
    default:
      return [];
  }
}
function sl(e, t, o, l) {
  const n = Ne(e);
  let i = rl(be(e), o === "start", l);
  return n && (i = i.map((a) => a + "-" + n), t && (i = i.concat(i.map(st)))), i;
}
function Ke(e) {
  const t = be(e);
  return ol[t] + e.slice(t.length);
}
function ul(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function to(e) {
  return typeof e != "number" ? ul(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function Ye(e) {
  const {
    x: t,
    y: o,
    width: l,
    height: n
  } = e;
  return {
    width: l,
    height: n,
    top: o,
    left: t,
    right: t + l,
    bottom: o + n,
    x: t,
    y: o
  };
}
function At(e, t, o) {
  let {
    reference: l,
    floating: n
  } = e;
  const i = fe(t), a = bt(t), r = gt(a), u = be(t), s = i === "y", m = l.x + l.width / 2 - n.width / 2, d = l.y + l.height / 2 - n.height / 2, f = l[r] / 2 - n[r] / 2;
  let p;
  switch (u) {
    case "top":
      p = {
        x: m,
        y: l.y - n.height
      };
      break;
    case "bottom":
      p = {
        x: m,
        y: l.y + l.height
      };
      break;
    case "right":
      p = {
        x: l.x + l.width,
        y: d
      };
      break;
    case "left":
      p = {
        x: l.x - n.width,
        y: d
      };
      break;
    default:
      p = {
        x: l.x,
        y: l.y
      };
  }
  switch (Ne(t)) {
    case "start":
      p[a] -= f * (o && s ? -1 : 1);
      break;
    case "end":
      p[a] += f * (o && s ? -1 : 1);
      break;
  }
  return p;
}
async function cl(e, t) {
  var o;
  t === void 0 && (t = {});
  const {
    x: l,
    y: n,
    platform: i,
    rects: a,
    elements: r,
    strategy: u
  } = e, {
    boundary: s = "clippingAncestors",
    rootBoundary: m = "viewport",
    elementContext: d = "floating",
    altBoundary: f = !1,
    padding: p = 0
  } = Se(t, e), y = to(p), b = r[f ? d === "floating" ? "reference" : "floating" : d], C = Ye(await i.getClippingRect({
    element: (o = await (i.isElement == null ? void 0 : i.isElement(b))) == null || o ? b : b.contextElement || await (i.getDocumentElement == null ? void 0 : i.getDocumentElement(r.floating)),
    boundary: s,
    rootBoundary: m,
    strategy: u
  })), _ = d === "floating" ? {
    x: l,
    y: n,
    width: a.floating.width,
    height: a.floating.height
  } : a.reference, j = await (i.getOffsetParent == null ? void 0 : i.getOffsetParent(r.floating)), S = await (i.isElement == null ? void 0 : i.isElement(j)) ? await (i.getScale == null ? void 0 : i.getScale(j)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, I = Ye(i.convertOffsetParentRelativeRectToViewportRelativeRect ? await i.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: r,
    rect: _,
    offsetParent: j,
    strategy: u
  }) : _);
  return {
    top: (C.top - I.top + y.top) / S.y,
    bottom: (I.bottom - C.bottom + y.bottom) / S.y,
    left: (C.left - I.left + y.left) / S.x,
    right: (I.right - C.right + y.right) / S.x
  };
}
const dl = 50, fl = async (e, t, o) => {
  const {
    placement: l = "bottom",
    strategy: n = "absolute",
    middleware: i = [],
    platform: a
  } = o, r = a.detectOverflow ? a : {
    ...a,
    detectOverflow: cl
  }, u = await (a.isRTL == null ? void 0 : a.isRTL(t));
  let s = await a.getElementRects({
    reference: e,
    floating: t,
    strategy: n
  }), {
    x: m,
    y: d
  } = At(s, l, u), f = l, p = 0;
  const y = {};
  for (let g = 0; g < i.length; g++) {
    const b = i[g];
    if (!b)
      continue;
    const {
      name: C,
      fn: _
    } = b, {
      x: j,
      y: S,
      data: I,
      reset: L
    } = await _({
      x: m,
      y: d,
      initialPlacement: l,
      placement: f,
      strategy: n,
      middlewareData: y,
      rects: s,
      platform: r,
      elements: {
        reference: e,
        floating: t
      }
    });
    m = j ?? m, d = S ?? d, y[C] = {
      ...y[C],
      ...I
    }, L && p < dl && (p++, typeof L == "object" && (L.placement && (f = L.placement), L.rects && (s = L.rects === !0 ? await a.getElementRects({
      reference: e,
      floating: t,
      strategy: n
    }) : L.rects), {
      x: m,
      y: d
    } = At(s, f, u)), g = -1);
  }
  return {
    x: m,
    y: d,
    placement: f,
    strategy: n,
    middlewareData: y
  };
}, yl = (e) => ({
  name: "arrow",
  options: e,
  async fn(t) {
    const {
      x: o,
      y: l,
      placement: n,
      rects: i,
      platform: a,
      elements: r,
      middlewareData: u
    } = t, {
      element: s,
      padding: m = 0
    } = Se(e, t) || {};
    if (s == null)
      return {};
    const d = to(m), f = {
      x: o,
      y: l
    }, p = bt(n), y = gt(p), g = await a.getDimensions(s), b = p === "y", C = b ? "top" : "left", _ = b ? "bottom" : "right", j = b ? "clientHeight" : "clientWidth", S = i.reference[y] + i.reference[p] - f[p] - i.floating[y], I = f[p] - i.reference[p], L = await (a.getOffsetParent == null ? void 0 : a.getOffsetParent(s));
    let x = L ? L[j] : 0;
    (!x || !await (a.isElement == null ? void 0 : a.isElement(L))) && (x = r.floating[j] || i.floating[y]);
    const M = S / 2 - I / 2, E = x / 2 - g[y] / 2 - 1, q = it(d[C], E), U = it(d[_], E), ne = q, ke = x - g[y] - U, Q = x / 2 - g[y] / 2 + M, _e = rt(ne, Q, ke), de = !u.arrow && Ne(n) != null && Q !== _e && i.reference[y] / 2 - (Q < ne ? q : U) - g[y] / 2 < 0, ie = de ? Q < ne ? Q - ne : Q - ke : 0;
    return {
      [p]: f[p] + ie,
      data: {
        [p]: _e,
        centerOffset: Q - _e - ie,
        ...de && {
          alignmentOffset: ie
        }
      },
      reset: de
    };
  }
}), oo = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(t) {
      var o, l;
      const {
        placement: n,
        middlewareData: i,
        rects: a,
        initialPlacement: r,
        platform: u,
        elements: s
      } = t, {
        mainAxis: m = !0,
        crossAxis: d = !0,
        fallbackPlacements: f,
        fallbackStrategy: p = "bestFit",
        fallbackAxisSideDirection: y = "none",
        flipAlignment: g = !0,
        ...b
      } = Se(e, t);
      if ((o = i.arrow) != null && o.alignmentOffset)
        return {};
      const C = be(n), _ = fe(r), j = be(r) === r, S = await (u.isRTL == null ? void 0 : u.isRTL(s.floating)), I = f || (j || !g ? [Ke(r)] : ll(r)), L = y !== "none";
      !f && L && I.push(...sl(r, g, y, S));
      const x = [r, ...I], M = await u.detectOverflow(t, b), E = [];
      let q = ((l = i.flip) == null ? void 0 : l.overflows) || [];
      if (m && E.push(M[C]), d) {
        const Q = nl(n, a, S);
        E.push(M[Q[0]], M[Q[1]]);
      }
      if (q = [...q, {
        placement: n,
        overflows: E
      }], !E.every((Q) => Q <= 0)) {
        var U, ne;
        const Q = (((U = i.flip) == null ? void 0 : U.index) || 0) + 1, _e = x[Q];
        if (_e && (!(d === "alignment" ? _ !== fe(_e) : !1) || // We leave the current main axis only if every placement on that axis
        // overflows the main axis.
        q.every((re) => fe(re.placement) === _ ? re.overflows[0] > 0 : !0)))
          return {
            data: {
              index: Q,
              overflows: q
            },
            reset: {
              placement: _e
            }
          };
        let de = (ne = q.filter((ie) => ie.overflows[0] <= 0).sort((ie, re) => ie.overflows[1] - re.overflows[1])[0]) == null ? void 0 : ne.placement;
        if (!de)
          switch (p) {
            case "bestFit": {
              var ke;
              const ie = (ke = q.filter((re) => {
                if (L) {
                  const ve = fe(re.placement);
                  return ve === _ || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  ve === "y";
                }
                return !0;
              }).map((re) => [re.placement, re.overflows.filter((ve) => ve > 0).reduce((ve, _o) => ve + _o, 0)]).sort((re, ve) => re[1] - ve[1])[0]) == null ? void 0 : ke[0];
              ie && (de = ie);
              break;
            }
            case "initialPlacement":
              de = r;
              break;
          }
        if (n !== de)
          return {
            reset: {
              placement: de
            }
          };
      }
      return {};
    }
  };
}, no = /* @__PURE__ */ new Set(["left", "top"]);
async function ml(e, t) {
  const {
    placement: o,
    platform: l,
    elements: n
  } = e, i = await (l.isRTL == null ? void 0 : l.isRTL(n.floating)), a = be(o), r = Ne(o), u = fe(o) === "y", s = no.has(a) ? -1 : 1, m = i && u ? -1 : 1, d = Se(t, e);
  let {
    mainAxis: f,
    crossAxis: p,
    alignmentAxis: y
  } = typeof d == "number" ? {
    mainAxis: d,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: d.mainAxis || 0,
    crossAxis: d.crossAxis || 0,
    alignmentAxis: d.alignmentAxis
  };
  return r && typeof y == "number" && (p = r === "end" ? y * -1 : y), u ? {
    x: p * m,
    y: f * s
  } : {
    x: f * s,
    y: p * m
  };
}
const lo = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(t) {
      var o, l;
      const {
        x: n,
        y: i,
        placement: a,
        middlewareData: r
      } = t, u = await ml(t, e);
      return a === ((o = r.offset) == null ? void 0 : o.placement) && (l = r.arrow) != null && l.alignmentOffset ? {} : {
        x: n + u.x,
        y: i + u.y,
        data: {
          ...u,
          placement: a
        }
      };
    }
  };
}, ao = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(t) {
      const {
        x: o,
        y: l,
        placement: n,
        platform: i
      } = t, {
        mainAxis: a = !0,
        crossAxis: r = !1,
        limiter: u = {
          fn: (C) => {
            let {
              x: _,
              y: j
            } = C;
            return {
              x: _,
              y: j
            };
          }
        },
        ...s
      } = Se(e, t), m = {
        x: o,
        y: l
      }, d = await i.detectOverflow(t, s), f = fe(be(n)), p = ht(f);
      let y = m[p], g = m[f];
      if (a) {
        const C = p === "y" ? "top" : "left", _ = p === "y" ? "bottom" : "right", j = y + d[C], S = y - d[_];
        y = rt(j, y, S);
      }
      if (r) {
        const C = f === "y" ? "top" : "left", _ = f === "y" ? "bottom" : "right", j = g + d[C], S = g - d[_];
        g = rt(j, g, S);
      }
      const b = u.fn({
        ...t,
        [p]: y,
        [f]: g
      });
      return {
        ...b,
        data: {
          x: b.x - o,
          y: b.y - l,
          enabled: {
            [p]: a,
            [f]: r
          }
        }
      };
    }
  };
}, io = function(e) {
  return e === void 0 && (e = {}), {
    options: e,
    fn(t) {
      const {
        x: o,
        y: l,
        placement: n,
        rects: i,
        middlewareData: a
      } = t, {
        offset: r = 0,
        mainAxis: u = !0,
        crossAxis: s = !0
      } = Se(e, t), m = {
        x: o,
        y: l
      }, d = fe(n), f = ht(d);
      let p = m[f], y = m[d];
      const g = Se(r, t), b = typeof g == "number" ? {
        mainAxis: g,
        crossAxis: 0
      } : {
        mainAxis: 0,
        crossAxis: 0,
        ...g
      };
      if (u) {
        const j = f === "y" ? "height" : "width", S = i.reference[f] - i.floating[j] + b.mainAxis, I = i.reference[f] + i.reference[j] - b.mainAxis;
        p < S ? p = S : p > I && (p = I);
      }
      if (s) {
        var C, _;
        const j = f === "y" ? "width" : "height", S = no.has(be(n)), I = i.reference[d] - i.floating[j] + (S && ((C = a.offset) == null ? void 0 : C[d]) || 0) + (S ? 0 : b.crossAxis), L = i.reference[d] + i.reference[j] + (S ? 0 : ((_ = a.offset) == null ? void 0 : _[d]) || 0) - (S ? b.crossAxis : 0);
        y < I ? y = I : y > L && (y = L);
      }
      return {
        [f]: p,
        [d]: y
      };
    }
  };
}, ut = Math.min, Be = Math.max, Ze = Math.round, We = Math.floor, we = (e) => ({
  x: e,
  y: e
});
function je(e) {
  return ro(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function le(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function pe(e) {
  var t;
  return (t = (ro(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function ro(e) {
  return e instanceof Node || e instanceof le(e).Node;
}
function ye(e) {
  return e instanceof Element || e instanceof le(e).Element;
}
function ue(e) {
  return e instanceof HTMLElement || e instanceof le(e).HTMLElement;
}
function Et(e) {
  return typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof le(e).ShadowRoot;
}
function qe(e) {
  const {
    overflow: t,
    overflowX: o,
    overflowY: l,
    display: n
  } = ae(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + l + o) && !["inline", "contents"].includes(n);
}
function pl(e) {
  return ["table", "td", "th"].includes(je(e));
}
function wt(e) {
  const t = jt(), o = ae(e);
  return o.transform !== "none" || o.perspective !== "none" || (o.containerType ? o.containerType !== "normal" : !1) || !t && (o.backdropFilter ? o.backdropFilter !== "none" : !1) || !t && (o.filter ? o.filter !== "none" : !1) || ["transform", "perspective", "filter"].some((l) => (o.willChange || "").includes(l)) || ["paint", "layout", "strict", "content"].some((l) => (o.contain || "").includes(l));
}
function vl(e) {
  let t = ze(e);
  for (; ue(t) && !ot(t); ) {
    if (wt(t))
      return t;
    t = ze(t);
  }
  return null;
}
function jt() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function ot(e) {
  return ["html", "body", "#document"].includes(je(e));
}
function ae(e) {
  return le(e).getComputedStyle(e);
}
function nt(e) {
  return ye(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.pageXOffset,
    scrollTop: e.pageYOffset
  };
}
function ze(e) {
  if (je(e) === "html")
    return e;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    Et(e) && e.host || // Fallback.
    pe(e)
  );
  return Et(t) ? t.host : t;
}
function so(e) {
  const t = ze(e);
  return ot(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : ue(t) && qe(t) ? t : so(t);
}
function Oe(e, t, o) {
  var l;
  t === void 0 && (t = []), o === void 0 && (o = !0);
  const n = so(e), i = n === ((l = e.ownerDocument) == null ? void 0 : l.body), a = le(n);
  return i ? t.concat(a, a.visualViewport || [], qe(n) ? n : [], a.frameElement && o ? Oe(a.frameElement) : []) : t.concat(n, Oe(n, [], o));
}
function uo(e) {
  const t = ae(e);
  let o = parseFloat(t.width) || 0, l = parseFloat(t.height) || 0;
  const n = ue(e), i = n ? e.offsetWidth : o, a = n ? e.offsetHeight : l, r = Ze(o) !== i || Ze(l) !== a;
  return r && (o = i, l = a), {
    width: o,
    height: l,
    $: r
  };
}
function kt(e) {
  return ye(e) ? e : e.contextElement;
}
function Ae(e) {
  const t = kt(e);
  if (!ue(t))
    return we(1);
  const o = t.getBoundingClientRect(), {
    width: l,
    height: n,
    $: i
  } = uo(t);
  let a = (i ? Ze(o.width) : o.width) / l, r = (i ? Ze(o.height) : o.height) / n;
  return (!a || !Number.isFinite(a)) && (a = 1), (!r || !Number.isFinite(r)) && (r = 1), {
    x: a,
    y: r
  };
}
const hl = /* @__PURE__ */ we(0);
function co(e) {
  const t = le(e);
  return !jt() || !t.visualViewport ? hl : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function gl(e, t, o) {
  return t === void 0 && (t = !1), !o || t && o !== le(e) ? !1 : t;
}
function xe(e, t, o, l) {
  t === void 0 && (t = !1), o === void 0 && (o = !1);
  const n = e.getBoundingClientRect(), i = kt(e);
  let a = we(1);
  t && (l ? ye(l) && (a = Ae(l)) : a = Ae(e));
  const r = gl(i, o, l) ? co(i) : we(0);
  let u = (n.left + r.x) / a.x, s = (n.top + r.y) / a.y, m = n.width / a.x, d = n.height / a.y;
  if (i) {
    const f = le(i), p = l && ye(l) ? le(l) : l;
    let y = f.frameElement;
    for (; y && l && p !== f; ) {
      const g = Ae(y), b = y.getBoundingClientRect(), C = ae(y), _ = b.left + (y.clientLeft + parseFloat(C.paddingLeft)) * g.x, j = b.top + (y.clientTop + parseFloat(C.paddingTop)) * g.y;
      u *= g.x, s *= g.y, m *= g.x, d *= g.y, u += _, s += j, y = le(y).frameElement;
    }
  }
  return Ye({
    width: m,
    height: d,
    x: u,
    y: s
  });
}
function bl(e) {
  let {
    rect: t,
    offsetParent: o,
    strategy: l
  } = e;
  const n = ue(o), i = pe(o);
  if (o === i)
    return t;
  let a = {
    scrollLeft: 0,
    scrollTop: 0
  }, r = we(1);
  const u = we(0);
  if ((n || !n && l !== "fixed") && ((je(o) !== "body" || qe(i)) && (a = nt(o)), ue(o))) {
    const s = xe(o);
    r = Ae(o), u.x = s.x + o.clientLeft, u.y = s.y + o.clientTop;
  }
  return {
    width: t.width * r.x,
    height: t.height * r.y,
    x: t.x * r.x - a.scrollLeft * r.x + u.x,
    y: t.y * r.y - a.scrollTop * r.y + u.y
  };
}
function wl(e) {
  return Array.from(e.getClientRects());
}
function fo(e) {
  return xe(pe(e)).left + nt(e).scrollLeft;
}
function jl(e) {
  const t = pe(e), o = nt(e), l = e.ownerDocument.body, n = Be(t.scrollWidth, t.clientWidth, l.scrollWidth, l.clientWidth), i = Be(t.scrollHeight, t.clientHeight, l.scrollHeight, l.clientHeight);
  let a = -o.scrollLeft + fo(e);
  const r = -o.scrollTop;
  return ae(l).direction === "rtl" && (a += Be(t.clientWidth, l.clientWidth) - n), {
    width: n,
    height: i,
    x: a,
    y: r
  };
}
function kl(e, t) {
  const o = le(e), l = pe(e), n = o.visualViewport;
  let i = l.clientWidth, a = l.clientHeight, r = 0, u = 0;
  if (n) {
    i = n.width, a = n.height;
    const s = jt();
    (!s || s && t === "fixed") && (r = n.offsetLeft, u = n.offsetTop);
  }
  return {
    width: i,
    height: a,
    x: r,
    y: u
  };
}
function _l(e, t) {
  const o = xe(e, !0, t === "fixed"), l = o.top + e.clientTop, n = o.left + e.clientLeft, i = ue(e) ? Ae(e) : we(1), a = e.clientWidth * i.x, r = e.clientHeight * i.y, u = n * i.x, s = l * i.y;
  return {
    width: a,
    height: r,
    x: u,
    y: s
  };
}
function zt(e, t, o) {
  let l;
  if (t === "viewport")
    l = kl(e, o);
  else if (t === "document")
    l = jl(pe(e));
  else if (ye(t))
    l = _l(t, o);
  else {
    const n = co(e);
    l = {
      ...t,
      x: t.x - n.x,
      y: t.y - n.y
    };
  }
  return Ye(l);
}
function yo(e, t) {
  const o = ze(e);
  return o === t || !ye(o) || ot(o) ? !1 : ae(o).position === "fixed" || yo(o, t);
}
function $l(e, t) {
  const o = t.get(e);
  if (o)
    return o;
  let l = Oe(e, [], !1).filter((r) => ye(r) && je(r) !== "body"), n = null;
  const i = ae(e).position === "fixed";
  let a = i ? ze(e) : e;
  for (; ye(a) && !ot(a); ) {
    const r = ae(a), u = wt(a);
    !u && r.position === "fixed" && (n = null), (i ? !u && !n : !u && r.position === "static" && !!n && ["absolute", "fixed"].includes(n.position) || qe(a) && !u && yo(e, a)) ? l = l.filter((m) => m !== a) : n = r, a = ze(a);
  }
  return t.set(e, l), l;
}
function Cl(e) {
  let {
    element: t,
    boundary: o,
    rootBoundary: l,
    strategy: n
  } = e;
  const a = [...o === "clippingAncestors" ? $l(t, this._c) : [].concat(o), l], r = a[0], u = a.reduce((s, m) => {
    const d = zt(t, m, n);
    return s.top = Be(d.top, s.top), s.right = ut(d.right, s.right), s.bottom = ut(d.bottom, s.bottom), s.left = Be(d.left, s.left), s;
  }, zt(t, r, n));
  return {
    width: u.right - u.left,
    height: u.bottom - u.top,
    x: u.left,
    y: u.top
  };
}
function Sl(e) {
  return uo(e);
}
function xl(e, t, o) {
  const l = ue(t), n = pe(t), i = o === "fixed", a = xe(e, !0, i, t);
  let r = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const u = we(0);
  if (l || !l && !i)
    if ((je(t) !== "body" || qe(n)) && (r = nt(t)), l) {
      const s = xe(t, !0, i, t);
      u.x = s.x + t.clientLeft, u.y = s.y + t.clientTop;
    } else n && (u.x = fo(n));
  return {
    x: a.left + r.scrollLeft - u.x,
    y: a.top + r.scrollTop - u.y,
    width: a.width,
    height: a.height
  };
}
function Jt(e, t) {
  return !ue(e) || ae(e).position === "fixed" ? null : t ? t(e) : e.offsetParent;
}
function mo(e, t) {
  const o = le(e);
  if (!ue(e))
    return o;
  let l = Jt(e, t);
  for (; l && pl(l) && ae(l).position === "static"; )
    l = Jt(l, t);
  return l && (je(l) === "html" || je(l) === "body" && ae(l).position === "static" && !wt(l)) ? o : l || vl(e) || o;
}
const Vl = async function(e) {
  let {
    reference: t,
    floating: o,
    strategy: l
  } = e;
  const n = this.getOffsetParent || mo, i = this.getDimensions;
  return {
    reference: xl(t, await n(o), l),
    floating: {
      x: 0,
      y: 0,
      ...await i(o)
    }
  };
};
function Tl(e) {
  return ae(e).direction === "rtl";
}
const Il = {
  convertOffsetParentRelativeRectToViewportRelativeRect: bl,
  getDocumentElement: pe,
  getClippingRect: Cl,
  getOffsetParent: mo,
  getElementRects: Vl,
  getClientRects: wl,
  getDimensions: Sl,
  getScale: Ae,
  isElement: ye,
  isRTL: Tl
};
function Ll(e, t) {
  let o = null, l;
  const n = pe(e);
  function i() {
    clearTimeout(l), o && o.disconnect(), o = null;
  }
  function a(r, u) {
    r === void 0 && (r = !1), u === void 0 && (u = 1), i();
    const {
      left: s,
      top: m,
      width: d,
      height: f
    } = e.getBoundingClientRect();
    if (r || t(), !d || !f)
      return;
    const p = We(m), y = We(n.clientWidth - (s + d)), g = We(n.clientHeight - (m + f)), b = We(s), _ = {
      rootMargin: -p + "px " + -y + "px " + -g + "px " + -b + "px",
      threshold: Be(0, ut(1, u)) || 1
    };
    let j = !0;
    function S(I) {
      const L = I[0].intersectionRatio;
      if (L !== u) {
        if (!j)
          return a();
        L ? a(!1, L) : l = setTimeout(() => {
          a(!1, 1e-7);
        }, 100);
      }
      j = !1;
    }
    try {
      o = new IntersectionObserver(S, {
        ..._,
        // Handle <iframe>s
        root: n.ownerDocument
      });
    } catch {
      o = new IntersectionObserver(S, _);
    }
    o.observe(e);
  }
  return a(!0), i;
}
function Bl(e, t, o, l) {
  l === void 0 && (l = {});
  const {
    ancestorScroll: n = !0,
    ancestorResize: i = !0,
    elementResize: a = typeof ResizeObserver == "function",
    layoutShift: r = typeof IntersectionObserver == "function",
    animationFrame: u = !1
  } = l, s = kt(e), m = n || i ? [...s ? Oe(s) : [], ...Oe(t)] : [];
  m.forEach((C) => {
    n && C.addEventListener("scroll", o, {
      passive: !0
    }), i && C.addEventListener("resize", o);
  });
  const d = s && r ? Ll(s, o) : null;
  let f = -1, p = null;
  a && (p = new ResizeObserver((C) => {
    let [_] = C;
    _ && _.target === s && p && (p.unobserve(t), cancelAnimationFrame(f), f = requestAnimationFrame(() => {
      p && p.observe(t);
    })), o();
  }), s && !u && p.observe(s), p.observe(t));
  let y, g = u ? xe(e) : null;
  u && b();
  function b() {
    const C = xe(e);
    g && (C.x !== g.x || C.y !== g.y || C.width !== g.width || C.height !== g.height) && o(), g = C, y = requestAnimationFrame(b);
  }
  return o(), () => {
    m.forEach((C) => {
      n && C.removeEventListener("scroll", o), i && C.removeEventListener("resize", o);
    }), d && d(), p && p.disconnect(), p = null, u && cancelAnimationFrame(y);
  };
}
const Al = (e, t, o) => {
  const l = /* @__PURE__ */ new Map(), n = {
    platform: Il,
    ...o
  }, i = {
    ...n.platform,
    _c: l
  };
  return fl(e, t, {
    ...n,
    platform: i
  });
};
function ct(e) {
  var t;
  return (t = e == null ? void 0 : e.$el) != null ? t : e;
}
function po(e) {
  return {
    name: "arrow",
    options: e,
    fn(t) {
      const o = ct(F(e.element));
      return o == null ? {} : yl({
        element: o,
        padding: e.padding
      }).fn(t);
    }
  };
}
function vo(e) {
  return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function Pt(e, t) {
  const o = vo(e);
  return Math.round(t * o) / o;
}
function ho(e, t, o) {
  o === void 0 && (o = {});
  const l = o.whileElementsMounted, n = V(() => {
    var x;
    return (x = F(o.open)) != null ? x : !0;
  }), i = V(() => F(o.middleware)), a = V(() => {
    var x;
    return (x = F(o.placement)) != null ? x : "bottom";
  }), r = V(() => {
    var x;
    return (x = F(o.strategy)) != null ? x : "absolute";
  }), u = V(() => {
    var x;
    return (x = F(o.transform)) != null ? x : !0;
  }), s = V(() => ct(e.value)), m = V(() => ct(t.value)), d = $(0), f = $(0), p = $(r.value), y = $(a.value), g = Nt({}), b = $(!1), C = V(() => {
    const x = {
      position: p.value,
      left: "0",
      top: "0"
    };
    if (!m.value)
      return x;
    const M = Pt(m.value, d.value), E = Pt(m.value, f.value);
    return u.value ? {
      ...x,
      transform: "translate(" + M + "px, " + E + "px)",
      ...vo(m.value) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: p.value,
      left: M + "px",
      top: E + "px"
    };
  });
  let _;
  function j() {
    s.value == null || m.value == null || Al(s.value, m.value, {
      middleware: i.value,
      placement: a.value,
      strategy: r.value
    }).then((x) => {
      d.value = x.x, f.value = x.y, p.value = x.strategy, y.value = x.placement, g.value = x.middlewareData, b.value = !0;
    });
  }
  function S() {
    typeof _ == "function" && (_(), _ = void 0);
  }
  function I() {
    if (S(), l === void 0) {
      j();
      return;
    }
    if (s.value != null && m.value != null) {
      _ = l(s.value, m.value, j);
      return;
    }
  }
  function L() {
    n.value || (b.value = !1);
  }
  return W([i, a, r], j, {
    flush: "sync"
  }), W([s, m], I, {
    flush: "sync"
  }), W(n, L, {
    flush: "sync"
  }), Dt() && Rt(S), {
    x: Ie(d),
    y: Ie(f),
    strategy: Ie(p),
    placement: Ie(y),
    middlewareData: Ie(g),
    isPositioned: Ie(b),
    floatingStyles: C,
    update: j
  };
}
const El = ["aria-describedby"], zl = ["id"], Jl = /* @__PURE__ */ A({
  __name: "VJoyTooltip",
  props: {
    /** If you are 100% sure the content you want to inject does not contain anything that could lead to any XSS, use this  */
    text: {
      type: String
    },
    /** It will automatically switch to another placement if there is not enough space. Please see https://floating-ui.com/docs/tutorial#placements for available values */
    placement: {
      type: String,
      default: "bottom"
    },
    /** Mouseenter (default) or click */
    event: {
      type: String,
      default: "mouseenter"
    },
    /** By default the tooltip is shown after a certain delay to make the experience smoother. You can change the value (in ms) */
    delay: {
      type: Number,
      default: 100
    },
    /** Mostly for visual testing purpose */
    show: {
      type: Boolean,
      default: !1
    },
    /** Maw-width for the generated tooltip. */
    tooltipWidth: {
      type: Number,
      default: 250
    },
    /**
     * @deprecated
     *
     * This property will be activated by default. Enable interacting with the content.
     *  */
    enableClickInContent: {
      type: Boolean,
      default: !0
    },
    id: {
      type: String
    }
  },
  setup(e, { expose: t }) {
    const o = K(), l = e, n = $(!1), i = $(null), a = $(null), r = $(null), u = $(), s = $(
      ho(i, r, {
        placement: l.placement,
        transform: !1,
        middleware: [
          lo(10),
          ao({
            limiter: io()
          }),
          oo({
            fallbackPlacements: ["bottom", "top", "left", "right"]
          }),
          po({ element: u, padding: 0 })
        ]
      })
    ), m = V(
      () => l.enableClickInContent ? {
        ignore: [a]
      } : {}
    ), d = V(() => o["tooltip-content"] || l.text);
    function f(C) {
      C.preventDefault(), C.stopPropagation(), !n.value && l.event !== "click" && g();
    }
    function p() {
      l.event !== "click" && g(!1);
    }
    function y(C) {
      !n.value && l.event === "click" && (C.preventDefault(), C.stopPropagation(), g());
    }
    function g(C = !0) {
      var _;
      (_ = s.value) == null || _.update(), setTimeout(() => {
        n.value = C;
      }, l.delay);
    }
    const b = V(() => {
      const { middlewareData: C, placement: _ } = s.value, j = C.arrow, S = {
        top: "bottom",
        right: "left",
        bottom: "top",
        left: "right"
      }[_.split("-")[0]];
      return {
        left: (j == null ? void 0 : j.x) && `${j == null ? void 0 : j.x}px`,
        top: (j == null ? void 0 : j.y) && `${j == null ? void 0 : j.y}px`,
        right: "",
        bottom: "",
        [S]: "-4px"
      };
    });
    return ee(() => {
      l.show && g();
    }), Je(() => {
      n.value = !1;
    }), t({
      tooltipVisible: n,
      tooltip: r
    }), (C, _) => (c(), T(F(pt), {
      ref: "tooltipClickOutside",
      class: "joy-tooltip__click-outside",
      options: m.value,
      onTrigger: _[1] || (_[1] = (j) => g(!1))
    }, {
      default: J(() => {
        var j;
        return [
          h("div", {
            ref_key: "tooltipWrapper",
            ref: i,
            class: "joy-tooltip__wrapper",
            "aria-describedby": e.id,
            onClick: y,
            onMouseenter: f,
            onMouseleave: p,
            onKeydown: _[0] || (_[0] = Re((S) => g(!1), ["tab"]))
          }, [
            w(C.$slots, "default", {}, void 0, !0),
            (c(), T(Te, { to: "body" }, [
              n.value && d.value ? (c(), v("div", {
                key: 0,
                id: e.id,
                ref_key: "tooltip",
                ref: r,
                role: "tooltip",
                class: B([
                  "joy-tooltip__content",
                  {
                    "joy-tooltip__content--hiding": !n.value
                  }
                ]),
                style: X({ ...(j = s.value) == null ? void 0 : j.floatingStyles, maxWidth: `${e.tooltipWidth}px` })
              }, [
                h("div", {
                  ref_key: "tooltipArrow",
                  ref: u,
                  class: "joy-tooltip__arrow",
                  style: X(b.value)
                }, null, 4),
                h("div", {
                  ref_key: "tooltipContent",
                  ref: a,
                  class: "joy-tooltip__content__inner"
                }, [
                  w(C.$slots, "tooltip-content", {}, () => [
                    R(P(e.text), 1)
                  ], !0)
                ], 512)
              ], 14, zl)) : k("", !0)
            ]))
          ], 40, El)
        ];
      }),
      _: 3
    }, 8, ["options"]));
  }
}), Pl = /* @__PURE__ */ z(Jl, [["__scopeId", "data-v-4ab73c2f"]]), Ml = { class: "joy-label__group___main" }, Fl = {
  key: 0,
  class: "joy-label-required"
}, Ol = {
  key: 1,
  class: "joy-label-optional joy-color-neutral-40"
}, Dl = {
  key: 0,
  class: "joy-label__legend joy-font-primary-300 joy-color-neutral-40"
}, Rl = /* @__PURE__ */ A({
  __name: "VJoyLabel",
  props: {
    size: {
      type: String,
      default: "medium"
    },
    tagName: {
      type: String,
      default: "label"
    },
    required: {
      type: Boolean,
      default: !1
    },
    optionalLabel: {
      type: String
    },
    text: String
  },
  setup(e) {
    const t = ce(me, !1);
    return (o, l) => (c(), v("div", {
      class: B(["joy-label__group", { "joy-label__group--standalone": !F(t) }])
    }, [
      h("div", Ml, [
        (c(), T(Y(e.tagName), N({
          "data-joy-form-label": "",
          class: ["joy-label", `joy-label--${e.size}`]
        }, o.$attrs), {
          default: J(() => [
            w(o.$slots, "default", {}, () => [
              R(P(e.text), 1)
            ], !0),
            e.required ? (c(), v("span", Fl, "*")) : k("", !0),
            e.optionalLabel ? (c(), v("span", Ol, "- " + P(e.optionalLabel), 1)) : k("", !0)
          ]),
          _: 3
        }, 16, ["class"])),
        o.$slots["label-tooltip"] ? (c(), T(Pl, {
          key: 0,
          class: "joy-label__tooltip joy-ml-2"
        }, {
          "tooltip-content": J(() => [
            w(o.$slots, "label-tooltip", {}, void 0, !0)
          ]),
          default: J(() => [
            O(D, {
              name: "question-circle",
              class: "joy-label__tooltip___icon joy-color-neutral-40"
            })
          ]),
          _: 3
        })) : k("", !0)
      ]),
      o.$slots["label-legend"] ? (c(), v("span", Dl, [
        w(o.$slots, "label-legend", {}, void 0, !0)
      ])) : k("", !0)
    ], 2));
  }
}), Pe = /* @__PURE__ */ z(Rl, [["__scopeId", "data-v-77417189"]]), Nl = ["id"], ql = /* @__PURE__ */ A({
  __name: "VJoyCheckboxGroup",
  props: {
    options: { default: () => [] },
    id: {},
    value: { default: () => [] },
    direction: { default: "vertical" },
    required: { type: Boolean, default: !1 },
    label: {},
    labelSize: { default: "medium" },
    optionalLabel: {},
    requiredMark: { type: Boolean, default: !1 }
  },
  emits: ["update:value"],
  setup(e, { emit: t }) {
    const o = t, l = e;
    te(me, !0);
    const n = V(() => ({
      value: l.value,
      isChecked: i,
      updateModel: a
    }));
    function i(r) {
      return l.value.includes(r);
    }
    function a(r, u) {
      let s = [...l.value || []];
      u ? s.push(r) : s.splice(s.indexOf(r), 1), o("update:value", s);
    }
    return (r, u) => (c(), v("fieldset", {
      id: e.id,
      class: "joy-multi-checkbox__wrapper"
    }, [
      e.label ? (c(), T(Pe, {
        key: 0,
        "tag-name": "legend",
        required: e.required && e.requiredMark,
        "optional-label": e.optionalLabel,
        size: e.labelSize
      }, {
        default: J(() => [
          R(P(e.label), 1)
        ]),
        _: 1
      }, 8, ["required", "optional-label", "size"])) : k("", !0),
      h("div", {
        class: B(["joy-multi-checkbox", `joy-multi-checkbox--${e.direction}`])
      }, [
        r.$slots.default ? w(r.$slots, "default", qt(N({ key: 0 }, n.value)), void 0, !0) : (c(!0), v(H, { key: 1 }, G(e.options, (s) => (c(), T(vt, {
          id: s.id,
          key: s.id,
          name: s.name,
          value: s.value,
          checked: i(s.value),
          "onUpdate:checked": (m) => a(s.value, m)
        }, {
          default: J(() => [
            w(r.$slots, "checkbox", N({ ref_for: !0 }, s), () => [
              R(P(s.label), 1)
            ], !0)
          ]),
          _: 2
        }, 1032, ["id", "name", "value", "checked", "onUpdate:checked"]))), 128))
      ], 2)
    ], 8, Nl));
  }
}), Cu = /* @__PURE__ */ z(ql, [["__scopeId", "data-v-70dbe1be"]]), Hl = ["id"], Wl = { class: "joy-collapse-item__header-right" }, Ul = {
  key: 0,
  class: "joy-collapse-item__summary___subheader"
}, Gl = { class: "joy-collapse-item__summary___preview" }, Kl = ["aria-labelledby"], Yl = /* @__PURE__ */ A({
  __name: "VJoyCollapseItem",
  props: {
    /** Title of the collapse item */
    header: {
      type: String,
      required: !0
    },
    subheader: {
      type: String
    },
    open: {
      type: Boolean,
      default: !1
    },
    /** Pick the icon you want to display in front of the header/title */
    summaryIcon: {
      type: String
    },
    id: {
      type: String
    },
    /**
     * Experimental: outline mode may be the default one in near future
     */
    mode: {
      type: String,
      default: "default"
    }
  },
  emits: ["collapse-item:open", "collapse-item:close"],
  setup(e, { expose: t, emit: o }) {
    const l = e, n = o, i = $(l.open), a = $(!1);
    W(
      () => l.open,
      (s) => {
        i.value = s;
      }
    );
    function r() {
      i.value = !i.value, u();
    }
    function u() {
      i.value ? n("collapse-item:open") : n("collapse-item:close");
    }
    return t({
      isOpen: i,
      onToggle: r,
      props: l
    }), (s, m) => (c(), v("div", {
      class: B([
        "joy-collapse-item",
        {
          "joy-collapse-item--open": i.value,
          "joy-collapse-item--outline": e.mode === "outline",
          "joy-collapse-item--focusing": a.value
        }
      ])
    }, [
      h("div", {
        role: "button",
        tabindex: "0",
        class: "joy-collapse-item__summary",
        onClick: r,
        onKeydown: Re(r, ["enter"]),
        onFocus: m[0] || (m[0] = (d) => a.value = !0),
        onBlur: m[1] || (m[1] = (d) => a.value = !1)
      }, [
        h("div", {
          id: e.id,
          class: "joy-collapse-item__summary___content"
        }, [
          e.summaryIcon ? (c(), T(D, {
            key: 0,
            "aria-hidden": "true",
            color: "secondary",
            name: e.summaryIcon
          }, null, 8, ["name"])) : k("", !0),
          R(" " + P(e.header), 1)
        ], 8, Hl),
        h("div", Wl, [
          w(s.$slots, "collapse-header-right")
        ]),
        O(D, {
          class: "joy-collapse-item__summary___marker joy-mt-1",
          name: "chevron-down"
        }),
        e.subheader ? (c(), v("span", Ul, P(e.subheader), 1)) : k("", !0),
        h("span", Gl, [
          w(s.$slots, "collapse-preview")
        ])
      ], 32),
      i.value ? (c(), v("div", {
        key: 0,
        role: "region",
        "aria-labelledby": e.id,
        class: B([
          "joy-collapse-item__detail",
          {
            "joy-collapse-item__detail--open": i.value
          }
        ])
      }, [
        w(s.$slots, "default")
      ], 10, Kl)) : k("", !0)
    ], 2));
  }
}), Zl = /* @__PURE__ */ z(Yl, [["__scopeId", "data-v-382ef065"]]), Xl = { class: "joy-collapse" }, Ql = /* @__PURE__ */ A({
  __name: "VJoyCollapse",
  props: {
    /** Open one item at a time. Works with modelValue */
    accordion: {
      type: Boolean,
      default: !1
    },
    /** Use v-model to handle   */
    modelValue: {
      type: Array,
      default() {
        return [];
      }
    },
    /**
     * Experimental: outline mode may be the default one in near future
     */
    mode: {
      type: String,
      default: "default"
    }
  },
  emits: ["update:modelValue"],
  setup(e, { expose: t, emit: o }) {
    const l = e, n = $(l.modelValue), i = K(), a = o, r = V(() => {
      const y = i.default();
      return y.length === 1 && typeof y[0].type != "object" ? y[0].children.filter(u) : y.filter(u);
    });
    function u(y) {
      var g;
      return ((g = y == null ? void 0 : y.type) == null ? void 0 : g.__name) === "VJoyCollapseItem";
    }
    function s(y, g) {
      if (!(!y.children || !y.children[g]))
        return y.children[g]();
    }
    function m(y) {
      return l.modelValue.length ? l.modelValue.includes(p(y)) : y.props.open;
    }
    async function d(y) {
      if (l.accordion) {
        let g = [];
        g.push(p(y)), n.value = g;
      }
      n.value.indexOf(p(y)) === -1 && n.value.push(p(y)), a("update:modelValue", n.value);
    }
    function f(y) {
      l.accordion && (n.value = []);
      const g = n.value.indexOf(p(y));
      g !== -1 && n.value.splice(g, 1), a("update:modelValue", n.value);
    }
    function p(y) {
      return y.props.id || y.props.header;
    }
    return t({
      getValForModel: p,
      isItem: u,
      isOpen: m,
      items: r,
      openedCollapseItem: n
    }), (y, g) => (c(), v("div", Xl, [
      (c(!0), v(H, null, G(r.value, (b) => (c(), T(Zl, N({ ref_for: !0 }, b.props, {
        key: b.props.id,
        open: m(b),
        mode: e.mode,
        "onCollapseItem:open": () => d(b),
        "onCollapseItem:close": () => f(b)
      }), {
        "collapse-header-right": J(() => [
          (c(!0), v(H, null, G(s(b, "collapse-header-right"), (C, _) => (c(), T(Y(C), { key: _ }))), 128))
        ]),
        "collapse-preview": J(() => [
          (c(!0), v(H, null, G(s(b, "collapse-preview"), (C, _) => (c(), T(Y(C), { key: _ }))), 128))
        ]),
        default: J(() => [
          (c(!0), v(H, null, G(s(b, "default"), (C, _) => (c(), T(Y(C), { key: _ }))), 128))
        ]),
        _: 2
      }, 1040, ["open", "mode", "onCollapseItem:open", "onCollapseItem:close"]))), 128))
    ]));
  }
}), Su = /* @__PURE__ */ z(Ql, [["__scopeId", "data-v-35744932"]]), ea = ["src", "alt", "title", "loading"], ta = /* @__PURE__ */ A({
  __name: "VJoyCompanyAvatar",
  props: {
    /** Inject the URL of your image. Fallback will be the icon */
    imgSrc: String,
    /** Mostly for accessibility, use this to add an alternative text. */
    imgAlt: String,
    /** Used as "title" attribute for the img. */
    companyName: String,
    size: {
      type: String,
      default: "large"
    },
    /** Only applied if you set a imgSrc */
    loading: {
      type: String,
      default: "lazy"
    }
  },
  setup(e) {
    const t = e, o = V(() => {
      switch (t.size) {
        case "large":
          return "small";
        case "medium":
          return "xsmall";
        case "small":
          return "xxsmall";
        default:
          return "xsmall";
      }
    });
    return (l, n) => (c(), v("div", {
      class: B(["joy-company-avatar", `joy-company-avatar--${e.size}`])
    }, [
      e.imgSrc ? (c(), v("img", {
        key: 0,
        src: e.imgSrc,
        alt: e.imgAlt || e.companyName,
        title: e.companyName,
        loading: e.loading
      }, null, 8, ea)) : (c(), T(D, {
        key: 1,
        name: "company-placeholder",
        size: o.value
      }, null, 8, ["size"]))
    ], 2));
  }
}), xu = /* @__PURE__ */ z(ta, [["__scopeId", "data-v-2f1289c1"]]), oa = /* @__PURE__ */ A({
  __name: "VJoyIconButton",
  props: {
    /** Name of the icon displayed inside the button */
    icon: {
      type: String,
      required: !0
    },
    /**
     * Accessible label used when no default slot is provided.
     * The text is hidden visually by JoyIconButton styles.
     */
    label: {
      type: String
    },
    /** Change the component's state and display a JoySpinner. */
    loading: {
      type: Boolean,
      default: !1
    },
    /** Button or Link color variant */
    variant: {
      type: String,
      default: "primary"
    },
    /** Button or Link size */
    size: {
      type: String,
      default: "medium"
    },
    id: {
      type: String
    }
  },
  setup(e) {
    const t = e, o = oe();
    return (l, n) => (c(), T(Ee, N({
      id: e.id,
      class: "joy-icon-button"
    }, F(o), {
      icon: e.icon,
      label: e.label,
      loading: e.loading,
      variant: t.variant,
      size: t.size
    }), {
      default: J(() => [
        w(l.$slots, "default", {}, () => [
          R(P(e.label), 1)
        ], !0)
      ]),
      _: 3
    }, 16, ["id", "icon", "label", "loading", "variant", "size"]));
  }
}), Ve = /* @__PURE__ */ z(oa, [["__scopeId", "data-v-dc9489f6"]]), na = /* @__PURE__ */ A({
  __name: "VJoyWrapper",
  props: {
    /** Horizontal spread. Refers to CSS flex justify-content. */
    justify: {
      type: String,
      default: "flex-start"
    },
    /** Vertical spread. Refers to CSS flex align-items. */
    align: {
      type: String,
      default: "center"
    },
    /** Vertical flex, or horizontal. Refers to CSS flex-direction */
    direction: {
      type: String,
      default: "row"
    },
    /** Automatically sets new line if there are not enough horizontal space. Refers to CSS flex-wrap */
    wrap: {
      type: String,
      default: "wrap"
    },
    /** Applies a flex-grow to children in order to stretch them all along horizontal space */
    itemStretch: {
      type: Boolean
    },
    /** Removes the default bottom margin applied to the wrapper */
    noMargin: {
      type: Boolean,
      default: !1
    },
    /** Gap between the columns. Refers to CSS column-gap. Value is based on spacing tokens. */
    columnGap: {
      type: String,
      default: "4"
    },
    /** Gap between the rows. Refers to CSS row-gap. Value is based on spacing tokens. */
    rowGap: {
      type: String,
      default: "8"
    }
  },
  setup(e) {
    return te("VJoyWrapperContext", e), (o, l) => (c(), v("div", {
      class: B([
        "joy-wrapper",
        `joy-wrapper--justify-${e.justify}`,
        `joy-wrapper--align-${e.align}`,
        `joy-wrapper--direction-${e.direction}`,
        `joy-wrapper--wrap-${e.wrap}`,
        `joy-wrapper--row-gap-${e.rowGap}`,
        `joy-wrapper--column-gap-${e.columnGap}`,
        { "joy-wrapper--item-stretch": e.itemStretch },
        { "joy-wrapper--has-margin": !e.noMargin }
      ])
    }, [
      w(o.$slots, "default", {}, void 0, !0)
    ], 2));
  }
}), se = /* @__PURE__ */ z(na, [["__scopeId", "data-v-68d89412"]]), la = ["id", "aria-labelledby"], aa = { class: "joy-dialog__inner" }, ia = {
  key: 0,
  class: "joy-dialog__shapes"
}, ra = { class: "joy-dialog--header" }, sa = {
  key: 0,
  class: "joy-dialog--preheader"
}, ua = ["id"], ca = {
  id: "dialogDescription",
  class: "joy-dialog--subheader"
}, da = {
  class: "joy-dialog--body",
  tabindex: "0"
}, fa = {
  key: 2,
  class: "joy-dialog--indicators"
}, ya = /* @__PURE__ */ A({
  inheritAttrs: !1,
  __name: "VJoyDialog",
  props: {
    id: {
      type: String
    },
    size: {
      type: String,
      default: "default"
    },
    /** By default the dialog is teleported to the end of body tag */
    teleport: {
      type: String,
      default: "body"
    },
    open: {
      type: Boolean,
      default: !1
    },
    /**
     * Mostly for documentation purpose
     */
    preventBodyScroll: {
      type: Boolean,
      default: !0
    },
    disableTeleport: {
      type: Boolean,
      default: !1
    },
    /** Mostly for documentation purpose, it prevents the component from being hidden */
    demoMode: {
      type: Boolean,
      default: !1
    },
    /** **For accessibility purpose**. Label associated with the top right corner icon.  */
    closeLabel: {
      type: String,
      default: "Close dialog"
    },
    /** Display the dialog without the top right icon to close it.
     * Click on backdrop is disabled and pressing Escape does not trigger anything.
     */
    patternConfirm: {
      type: Boolean,
      default: !1
    },
    /**
     * EXPERIMENTAL: activates a new centered layout and display decorative colored shapes. Shapes can't be disabled.
     */
    patternBrand: {
      type: Boolean,
      default: !1
    },
    /** Use this property to directly create a cancel CTA (VJoyButton), if you don't need to customize the CTA. */
    cancelText: {
      type: String
    },
    /** Use this property to directly create a confirm CTA (VJoyButton), if you don't need to customize the CTA. */
    confirmText: {
      type: String
    },
    buttonSize: {
      type: String,
      default: "medium"
    },
    /** Link to inject an image on top of the dialog */
    bannerSrc: {
      type: String
    },
    /** Based on CSS propetty background-position. https://developer.mozilla.org/en-US/docs/Web/CSS/background-position */
    bannerPosition: {
      type: String
    },
    bannerHeight: {
      type: Number,
      default: 250
    }
  },
  emits: ["dialog:open", "dialog:after-open", "dialog:hide", "dialog:after-hide", "dialog:before-unmount", "dialog:confirm"],
  setup(e, { expose: t, emit: o }) {
    const l = e, n = o, i = De() + "--JoyDialog", a = K(), r = $(!1), u = $(), s = $(l.open), m = oe(), d = V(() => {
      if (r.value)
        return m;
    }), f = V(() => {
      const I = a["dialog-cancel"] || a["dialog-confirm"], L = l.cancelText || l.confirmText;
      return !!I || !!L;
    }), p = V(() => l.id || i), y = V(() => p.value + "-header");
    function g() {
      !l.patternConfirm && b();
    }
    async function b(I = { fireHideEvent: !0 }) {
      l.demoMode || (s.value = !1, await Fe(), he(!1), I.fireHideEvent && n("dialog:hide"));
    }
    async function C() {
      s.value = !0, await Fe(), l.preventBodyScroll && he(!0);
    }
    function _() {
      n("dialog:open");
    }
    function j() {
      n("dialog:after-open");
    }
    function S() {
      n("dialog:after-hide");
    }
    return ee(async () => {
      r.value = !0;
    }), Je(() => {
      s.value === !0 && (n("dialog:before-unmount"), he(!1));
    }), t({
      hasFooterSlots: f,
      hide: b,
      isOpen: s,
      show: C
    }), (I, L) => r.value ? (c(), T(Te, {
      key: 0,
      to: e.teleport,
      disabled: e.disableTeleport
    }, [
      O(ft, {
        duration: { enter: 300, leave: 100 },
        name: "dialog",
        appear: "",
        onEnter: _,
        onAfterEnter: j,
        onAfterLeave: S
      }, {
        default: J(() => [
          s.value ? (c(), v("div", N({ key: 0 }, d.value, {
            id: e.id || i,
            ref_key: "dialogRef",
            ref: u,
            role: "dialog",
            "aria-modal": "true",
            class: ["joy-dialog", `joy-dialog--${e.size}`, { "joy-dialog--open": s.value, "joy-dialog--pattern-brand": e.patternBrand }],
            "aria-labelledby": y.value,
            onKeydown: Re(g, ["esc"])
          }), [
            h("div", {
              class: B([
                {
                  "joy-dialog__overlay": !0,
                  "joy-dialog__overlay--open": s.value,
                  "joy-dialog__overlay___disabled": e.patternConfirm
                }
              ]),
              onClick: g
            }, null, 2),
            h("div", {
              class: B([
                {
                  "joy-dialog--wrapper": !0,
                  "joy-dialog--wrapper-open": s.value
                }
              ])
            }, [
              h("div", aa, [
                e.patternBrand ? (c(), v("div", ia, [...L[3] || (L[3] = [
                  h("div", { class: "joy-dialog__shapes___shape" }, null, -1),
                  h("div", { class: "joy-dialog__shapes___shape" }, null, -1)
                ])])) : k("", !0),
                e.bannerSrc ? (c(), v("div", {
                  key: 1,
                  class: "joy-dialog--banner",
                  style: X({
                    backgroundImage: `url(${e.bannerSrc})`,
                    backgroundPosition: e.bannerPosition,
                    height: `${e.bannerHeight}px`
                  })
                }, null, 4)) : k("", !0),
                h("div", ra, [
                  I.$slots["dialog-preheader"] ? (c(), v("div", sa, [
                    w(I.$slots, "dialog-preheader", {}, void 0, !0)
                  ])) : k("", !0),
                  h("div", {
                    id: y.value,
                    class: "joy-dialog--header__title"
                  }, [
                    w(I.$slots, "dialog-header", {}, void 0, !0)
                  ], 8, ua),
                  h("p", ca, [
                    w(I.$slots, "dialog-subheader", {}, void 0, !0)
                  ]),
                  e.patternConfirm ? k("", !0) : (c(), T(Ve, {
                    key: 1,
                    id: "joy-dialog--close",
                    icon: "cross",
                    size: "small",
                    variant: "ghost",
                    name: "cross",
                    label: e.closeLabel,
                    class: "joy-dialog--close",
                    onClick: L[0] || (L[0] = (x) => b())
                  }, null, 8, ["label"]))
                ]),
                h("div", da, [
                  w(I.$slots, "dialog-body", {}, void 0, !0)
                ]),
                h("div", {
                  class: B([
                    {
                      "joy-dialog--footer": !0,
                      "joy-dialog--footer-filled": f.value
                    }
                  ])
                }, [
                  O(se, {
                    justify: "flex-end",
                    "no-margin": ""
                  }, {
                    default: J(() => [
                      w(I.$slots, "dialog-cancel", {}, () => [
                        e.cancelText ? (c(), T(Ee, {
                          key: 0,
                          class: "joy-dialog--cancel",
                          variant: "ghost",
                          size: e.buttonSize,
                          onClick: L[1] || (L[1] = (x) => b())
                        }, {
                          default: J(() => [
                            R(P(e.cancelText), 1)
                          ]),
                          _: 1
                        }, 8, ["size"])) : k("", !0)
                      ], !0),
                      w(I.$slots, "dialog-confirm", {}, () => [
                        e.confirmText ? (c(), T(Ee, {
                          key: 0,
                          class: "joy-dialog--confirm",
                          variant: "main",
                          size: e.buttonSize,
                          onClick: L[2] || (L[2] = (x) => n("dialog:confirm"))
                        }, {
                          default: J(() => [
                            R(P(e.confirmText), 1)
                          ]),
                          _: 1
                        }, 8, ["size"])) : k("", !0)
                      ], !0)
                    ]),
                    _: 3
                  })
                ], 2),
                F(a)["dialog-indicators"] ? (c(), v("div", fa, [
                  w(I.$slots, "dialog-indicators", {}, void 0, !0)
                ])) : k("", !0)
              ])
            ], 2)
          ], 16, la)) : k("", !0)
        ]),
        _: 3
      })
    ], 8, ["to", "disabled"])) : k("", !0);
  }
}), Vu = /* @__PURE__ */ z(ya, [["__scopeId", "data-v-86fff334"]]), Tu = /* @__PURE__ */ A({
  __name: "VJoyDialogTrigger",
  props: {
    dialog: {}
  },
  emits: ["click"],
  setup(e, { emit: t }) {
    const o = e, l = V(() => o.dialog), n = t, i = K(), a = V(() => i.default());
    async function r() {
      var u;
      n("click"), await ((u = l.value) == null ? void 0 : u.show());
    }
    return (u, s) => (c(!0), v(H, null, G(a.value, (m) => (c(), T(Y(m), {
      key: m,
      onClick: r
    }))), 128));
  }
}), ma = ["id", "aria-labelledby"], pa = { class: "joy-drawer__inner" }, va = { class: "joy-drawer--header" }, ha = ["id"], ga = {
  id: "drawerDescription",
  class: "joy-drawer--subheader"
}, ba = {
  class: "joy-drawer--body",
  tabindex: "0"
}, wa = /* @__PURE__ */ A({
  inheritAttrs: !1,
  __name: "VJoyDrawer",
  props: {
    id: {
      type: String
    },
    size: {
      type: String,
      default: "default"
    },
    /** By default the drawer is teleported to the end of body tag */
    teleport: {
      type: String,
      default: "body"
    },
    open: {
      type: Boolean,
      default: !1
    },
    /** Removes the overlay and allows interacting with background content.*/
    elevated: {
      type: Boolean,
      default: !1
    },
    /**
     * Mostly for documentation purpose
     */
    preventBodyScroll: {
      type: Boolean,
      default: !0
    },
    disableTeleport: {
      type: Boolean,
      default: !1
    },
    /** Mostly for documentation purpose, it prevents the component from being hidden */
    demoMode: {
      type: Boolean,
      default: !1
    },
    /** **For accessibility purpose**. Label associated with the top right corner icon.  */
    closeLabel: {
      type: String,
      default: "Close drawer"
    },
    /** Use this property to directly create a cancel CTA (VJoyButton), if you don't need to customize the CTA. */
    cancelText: {
      type: String
    },
    /** Use this property to directly create a confirm CTA (VJoyButton), if you don't need to customize the CTA. */
    confirmText: {
      type: String
    },
    buttonSize: {
      type: String,
      default: "medium"
    },
    /** Called just before you close the drawer. Returning false will cancel the closing.
     * This is useful when you need confirmation from the user to close the drawer. */
    onBeforeHide: {
      type: Function
    }
  },
  emits: ["drawer:open", "drawer:after-open", "drawer:hide", "drawer:after-hide", "drawer:before-unmount", "drawer:confirm"],
  setup(e, { expose: t, emit: o }) {
    const l = e, n = o, i = De() + "--JoyDrawer", a = K(), r = $(!1), u = $(), s = $(l.open), m = oe(), d = V(() => {
      if (r.value)
        return m;
    }), f = V(() => {
      const S = a["drawer-cancel"] || a["drawer-confirm"], I = l.cancelText || l.confirmText;
      return !!S || !!I;
    }), p = V(() => l.id || i), y = V(() => p.value + "-header");
    async function g(S = { fireHideEvent: !0 }) {
      l.demoMode || l.onBeforeHide && !await l.onBeforeHide() || (s.value = !1, await Fe(), he(!1), S.fireHideEvent && n("drawer:hide"));
    }
    async function b() {
      s.value = !0, await Fe(), !l.elevated && l.preventBodyScroll && he(!0);
    }
    function C() {
      n("drawer:open");
    }
    function _() {
      n("drawer:after-open");
    }
    function j() {
      n("drawer:after-hide");
    }
    return ee(() => {
      r.value = !0;
    }), Je(() => {
      s.value === !0 && (n("drawer:before-unmount"), he(!1));
    }), t({
      hasFooterSlots: f,
      hide: g,
      isOpen: s,
      show: b
    }), (S, I) => r.value ? (c(), T(Te, {
      key: 0,
      to: e.teleport,
      disabled: e.disableTeleport
    }, [
      O(ft, {
        duration: { enter: 300, leave: 100 },
        name: "drawer",
        appear: "",
        onEnter: C,
        onAfterEnter: _,
        onAfterLeave: j
      }, {
        default: J(() => [
          s.value ? (c(), v("div", N({ key: 0 }, d.value, {
            id: p.value,
            ref_key: "drawerRef",
            ref: u,
            role: "dialog",
            "aria-modal": "true",
            class: [
              "joy-drawer",
              `joy-drawer--${e.size}`,
              {
                "joy-drawer--open": s.value,
                "joy-drawer--elevated": e.elevated
              }
            ],
            "aria-labelledby": y.value,
            onKeydown: I[4] || (I[4] = Re((L) => g(), ["esc"]))
          }), [
            e.elevated ? k("", !0) : (c(), v("div", {
              key: 0,
              class: B([
                {
                  "joy-drawer__overlay": !0,
                  "joy-drawer__overlay--open": s.value
                }
              ]),
              onClick: I[0] || (I[0] = (L) => g())
            }, null, 2)),
            h("div", {
              class: B([
                {
                  "joy-drawer--wrapper": !0,
                  "joy-drawer--wrapper-open": s.value
                }
              ])
            }, [
              h("div", pa, [
                h("div", va, [
                  h("div", {
                    id: y.value,
                    class: "joy-drawer--header__title"
                  }, [
                    w(S.$slots, "drawer-header", {}, void 0, !0)
                  ], 8, ha),
                  h("p", ga, [
                    w(S.$slots, "drawer-subheader", {}, void 0, !0)
                  ]),
                  O(Ve, {
                    id: "joy-drawer--close",
                    icon: "cross",
                    size: "small",
                    variant: "ghost",
                    name: "cross",
                    label: e.closeLabel,
                    class: "joy-drawer--close",
                    onClick: I[1] || (I[1] = (L) => g())
                  }, null, 8, ["label"])
                ]),
                h("div", ba, [
                  w(S.$slots, "drawer-body", {}, void 0, !0)
                ]),
                h("div", {
                  class: B([
                    {
                      "joy-drawer--footer": !0,
                      "joy-drawer--footer-filled": f.value
                    }
                  ])
                }, [
                  O(se, {
                    justify: "flex-end",
                    "no-margin": "",
                    class: "joy-drawer--footer-wrapper"
                  }, {
                    default: J(() => [
                      w(S.$slots, "drawer-cancel", {}, () => [
                        e.cancelText ? (c(), T(Ee, {
                          key: 0,
                          class: "joy-drawer--cancel",
                          variant: "ghost",
                          size: e.buttonSize,
                          onClick: I[2] || (I[2] = (L) => g())
                        }, {
                          default: J(() => [
                            R(P(e.cancelText), 1)
                          ]),
                          _: 1
                        }, 8, ["size"])) : k("", !0)
                      ], !0),
                      w(S.$slots, "drawer-confirm", {}, () => [
                        e.confirmText ? (c(), T(Ee, {
                          key: 0,
                          class: "joy-drawer--confirm",
                          variant: "main",
                          size: e.buttonSize,
                          onClick: I[3] || (I[3] = (L) => n("drawer:confirm"))
                        }, {
                          default: J(() => [
                            R(P(e.confirmText), 1)
                          ]),
                          _: 1
                        }, 8, ["size"])) : k("", !0)
                      ], !0)
                    ]),
                    _: 3
                  })
                ], 2)
              ])
            ], 2)
          ], 16, ma)) : k("", !0)
        ]),
        _: 3
      })
    ], 8, ["to", "disabled"])) : k("", !0);
  }
}), Iu = /* @__PURE__ */ z(wa, [["__scopeId", "data-v-29200965"]]), Lu = /* @__PURE__ */ A({
  __name: "VJoyDrawerTrigger",
  props: {
    drawer: {}
  },
  emits: ["click"],
  setup(e, { emit: t }) {
    const o = e, l = t, n = V(() => o.drawer), i = K(), a = V(() => i.default());
    async function r() {
      var u;
      l("click"), await ((u = n.value) == null ? void 0 : u.show());
    }
    return (u, s) => (c(!0), v(H, null, G(a.value, (m) => (c(), T(Y(m), {
      key: m,
      onClick: r
    }))), 128));
  }
}), ja = {
  key: 0,
  class: "joy-dropdown-list__header"
}, ka = ["aria-label", "aria-labelledby"], _a = ["id", "tabindex", "aria-disabled", "aria-selected", "title", "aria-label", ".dataModel", "onClick"], $a = {
  key: 1,
  class: "joy-dropdown-list__footer"
}, Ca = /* @__PURE__ */ A({
  __name: "VJoyDropdownList",
  props: {
    /**
     * You need to pass an unique ID for each option. You can also pass a value if you want to customize the value of the v-model.
     */
    options: {
      type: Array,
      default() {
        return [];
      }
    },
    /** Customize the actual size of each items. */
    size: {
      type: String,
      default: "medium"
    },
    modelValue: {
      type: String
    },
    width: {
      type: String,
      default: "300"
    },
    height: {
      type: String,
      default: "300"
    },
    reset: {
      type: Boolean,
      default: !1
    },
    resetLabel: {
      type: String
    },
    ariaLabelledBy: {
      type: String
    },
    ariaLabel: {
      type: String
    }
  },
  emits: ["update:modelValue", "close:dropdownList", "reset"],
  setup(e, { expose: t, emit: o }) {
    const l = o, n = e, i = $(), a = V(() => (y) => !n.modelValue || !y.value && !y.id ? !1 : n.modelValue === y.value || n.modelValue === y.id);
    function r(y) {
      y.disabled || l("update:modelValue", y.value || y.id);
    }
    function u() {
      var y;
      return Array.from(((y = i.value) == null ? void 0 : y.querySelectorAll("li")) || []);
    }
    function s() {
      const y = u().find((g) => g.getAttribute("aria-selected") === "true");
      y && (y.focus(), i.value.scrollTo({
        top: y.offsetTop
      }));
    }
    function m() {
      return u().find((y) => y === document.activeElement);
    }
    function d(y) {
      var g;
      if (!(i.value && !i.value.contains(document.activeElement) || !i.value)) {
        if ((y.key === "Escape" || y.key === "Tab") && l("close:dropdownList"), (y.key === "Enter" || y.key === "enter") && (y.preventDefault(), m() && ((g = i.value) != null && g.contains(m())))) {
          const b = m();
          if (!b)
            return;
          if (b.querySelector("a"))
            return b.querySelector("a").click();
          l("update:modelValue", b.dataModel);
        }
        if (m() && y.key === " " && y.preventDefault(), ["ArrowDown", "ArrowUp", "Home", "End"].includes(y.key)) {
          const b = u(), C = m();
          let _ = b.indexOf(C);
          if (b.length) {
            y.preventDefault(), y.key === "ArrowDown" ? _++ : y.key === "ArrowUp" ? _-- : y.key === "Home" ? _ = 0 : y.key === "End" && (_ = b.length - 1), _ < 0 && (_ = b.length - 1), _ > b.length - 1 && (_ = 0), f(b[_]);
            return;
          }
        }
      }
    }
    function f(y) {
      y.focus();
    }
    function p() {
      l("reset");
    }
    return ee(() => {
      window.addEventListener("keydown", d), s();
    }), Je(() => {
      window.removeEventListener("keydown", d);
    }), t({
      isSelected: a
    }), (y, g) => (c(), v("div", {
      class: "joy-dropdown-list",
      style: X({ width: `${e.width}px`, "max-width": `${e.width}px` })
    }, [
      y.$slots["dropdown-list-header"] || e.reset ? (c(), v("header", ja, [
        e.reset ? (c(), v("button", {
          key: 0,
          type: "button",
          class: "joy-dropdown-list__reset",
          onClick: p
        }, P(e.resetLabel || "Reset"), 1)) : k("", !0),
        w(y.$slots, "dropdown-list-header", {}, void 0, !0)
      ])) : k("", !0),
      h("div", {
        tabindex: "0",
        class: B(["joy-dropdown-list__items", { "joy-dropdown-list__items-slotted": y.$slots["dropdown-list-items"] }]),
        style: X({ "max-height": `${e.height}px` })
      }, [
        w(y.$slots, "dropdown-list-items", {}, void 0, !0),
        e.options.length ? (c(), v("ul", {
          key: 0,
          ref_key: "listbox",
          ref: i,
          role: "listbox",
          "aria-expanded": "true",
          "aria-label": e.ariaLabel,
          "aria-labelledby": e.ariaLabelledBy
        }, [
          (c(!0), v(H, null, G(e.options, (b) => (c(), v("li", {
            id: b.id,
            key: b.id,
            style: X({ "max-width": `${e.width}px` }),
            class: B([
              "joy-dropdown-list__item",
              `joy-dropdown-list__item--${e.size}`,
              {
                "joy-dropdown-list__item--selected": a.value(b),
                "joy-dropdown-list__item--disabled": b.disabled
              }
            ]),
            tabindex: b.disabled ? void 0 : -1,
            "aria-disabled": b.disabled,
            "aria-selected": a.value(b),
            title: b.label,
            "aria-label": b.label,
            ".dataModel": b.value || b.id,
            role: "option",
            onClick: (C) => r(b)
          }, [
            w(y.$slots, "label", N({ ref_for: !0 }, b), () => [
              h("span", null, P(b.label), 1)
            ], !0)
          ], 46, _a))), 128))
        ], 8, ka)) : k("", !0)
      ], 6),
      y.$slots["dropdown-list-footer"] ? (c(), v("footer", $a, [
        w(y.$slots, "dropdown-list-footer", {}, void 0, !0)
      ])) : k("", !0)
    ], 4));
  }
}), Sa = /* @__PURE__ */ z(Ca, [["__scopeId", "data-v-7a3292aa"]]);
function xa(e) {
  const t = () => e();
  ee(() => {
    window.addEventListener("resize", t);
  }), Je(() => {
    window.removeEventListener("resize", t);
  });
}
function go(e, t) {
  ee(() => {
    var o;
    t && ((o = e.value) == null || o.focus());
  });
}
const Va = /* @__PURE__ */ A({
  __name: "VJoyDropdown",
  props: {
    /** DOM valid selector to give to Vue3 Teleport "to" property */
    appendTo: {
      type: String,
      default: "body"
    },
    /**
     * Disable teleport for testing purpose mostly.
     */
    disableTeleport: {
      type: Boolean,
      default: !1
    },
    /** close the dropdown list when clicking on any item. Default to false */
    closeOnSelect: {
      type: Boolean,
      default: !0
    },
    /** Dropdown vertical position according to the trigger */
    direction: {
      type: String,
      default: "down"
    },
    /** Dropdown horizontal justify according to the trigger */
    justify: {
      type: String,
      default: "left"
    },
    /**
     * Use options to render a pre-designed list.
     *
     * ```
     * interface Option {id: string; value?: string; label: string; href?: string; disabled?:boolean; checked?:boolean}
     * ```
     */
    options: {
      type: Array,
      default() {
        return [];
      }
    },
    size: {
      type: String,
      default: "medium"
    },
    /** Use v-model */
    modelValue: {
      type: String,
      default: ""
    },
    /**
     * Space between the trigger and the list
     */
    dropdownGap: {
      type: String,
      default: "12"
    },
    /**
     * Max-width of the dropdown list
     */
    width: {
      type: String,
      default: "300"
    },
    /**
     * Max-height of the dropdown list
     */
    height: {
      type: String,
      default: "300"
    },
    /**
     * Display a reset CTA on top of the dropdown list. Useful when using a VJoyCheckboxGroup.
     * Please note that is does not automatically apply changes to you models, it simply fires a **dropdown:reset** custom event
     * */
    reset: {
      type: Boolean,
      default: !1
    },
    /** Label of the reset CTA. Depends on reset property activation */
    resetLabel: {
      type: String
    }
  },
  emits: ["update:modelValue", "dropdown:open", "dropdown:hide", "dropdown:reset"],
  setup(e, { expose: t, emit: o }) {
    const l = o, n = e, i = $(!1), a = $(null), r = $(), u = $(null), s = $(null), m = $(!1), d = "joy-dropdown--" + Qe();
    te("VJoyDropdownContext", n);
    const f = {
      ignore: [r, ".joy-dropdown__list", "[data-click-outside-ignore]"]
    };
    let p = null;
    W(
      () => i.value,
      (x) => {
        x && Do(u);
      },
      { flush: "post" }
    );
    const y = V(() => {
      let x = `${n.dropdownGap}px`;
      return n.direction === "up" && (x = "-" + x), {
        marginTop: x
      };
    });
    function g() {
      p && clearTimeout(p), m.value = !0, p = setTimeout(() => {
        i.value = !1, m.value = !1, l("dropdown:hide");
      }, 300);
    }
    function b() {
      m.value = !1, p && clearTimeout(p), i.value = !0, l("dropdown:open");
    }
    function C(x) {
      x.stopPropagation(), i.value ? _() : b(), s.value = x.target;
    }
    function _() {
      g(), j();
    }
    function j() {
      s.value && s.value.focus();
    }
    function S(x) {
      l("update:modelValue", x), n.closeOnSelect && (g(), j());
    }
    function I() {
      l("dropdown:reset");
    }
    function L() {
      !r.value || !r.value.children.length || (r.value.children[0].id = d);
    }
    return xa(g), ee(() => {
      L();
    }), t({
      showDropdownList: i,
      generatedId: d
    }), (x, M) => (c(), T(F(pt), {
      ref_key: "dropdown",
      ref: a,
      options: f,
      class: "joy-dropdown",
      onTrigger: g
    }, {
      default: J(() => [
        h("div", {
          ref_key: "button",
          ref: r,
          class: "joy-dropdown__button",
          "data-testid": "dropdown-trigger",
          onClick: C
        }, [
          w(x.$slots, "dropdown-button", {}, void 0, !0)
        ], 512),
        i.value ? (c(), v("div", {
          key: 0,
          ref_key: "list",
          ref: u,
          class: B([
            "joy-dropdown__list",
            `joy-dropdown__list--${e.justify}`,
            `joy-dropdown__list--${e.direction}`,
            {
              "joy-dropdown__list--visible": !m.value,
              "joy-dropdown__list--hiding": m.value
            }
          ]),
          style: X(y.value)
        }, [
          O(Sa, {
            "model-value": e.modelValue,
            options: e.options,
            size: e.size,
            width: e.width,
            height: e.height,
            reset: e.reset,
            "reset-label": e.resetLabel,
            "aria-labelled-by": d,
            "onUpdate:modelValue": S,
            "onClose:dropdownList": _,
            onReset: I
          }, yt({
            label: J((E) => [
              w(x.$slots, "dropdown-item", qt(Io(E)), () => [
                h("span", null, P(E.label), 1)
              ], !0)
            ]),
            _: 2
          }, [
            x.$slots["dropdown-header"] ? {
              name: "dropdown-list-header",
              fn: J(() => [
                w(x.$slots, "dropdown-header", {}, void 0, !0)
              ]),
              key: "0"
            } : void 0,
            x.$slots["dropdown-items"] ? {
              name: "dropdown-list-items",
              fn: J(() => [
                w(x.$slots, "dropdown-items", {}, void 0, !0)
              ]),
              key: "1"
            } : void 0,
            x.$slots["dropdown-footer"] ? {
              name: "dropdown-list-footer",
              fn: J(() => [
                w(x.$slots, "dropdown-footer", {}, void 0, !0)
              ]),
              key: "2"
            } : void 0
          ]), 1032, ["model-value", "options", "size", "width", "height", "reset", "reset-label"])
        ], 6)) : k("", !0)
      ]),
      _: 3
    }, 512));
  }
}), Bu = /* @__PURE__ */ z(Va, [["__scopeId", "data-v-b597f860"]]), Ta = ["aria-hidden"], Ia = { key: 1 }, La = /* @__PURE__ */ A({
  __name: "VJoyFormError",
  props: {
    /**
     * In some cases you'll need to inject the error in the DOM but hide it. Visible by default
     * @deprecated - The property is now ignored.
     */
    visible: {
      type: Boolean,
      default: !0
    },
    /**
     * Display a list of errors without the need of a slot
     */
    errors: {
      type: Array,
      required: !1
    },
    /**
     * Error message to display. If you need a list of errors, use the slot instead
     * @deprecated Use the slot instead, or the errors prop.
     */
    noHtmlErrorText: String,
    /**
     * Allows to remove any bottom margin on the component
     */
    noMargin: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const t = K();
    return (o, l) => (c(), v("div", {
      "data-joy-form-error": "",
      "aria-hidden": e.visible,
      class: B(["joy-form-error", { "joy-has-error": e.visible, "joy-form-error--no-margin": e.noMargin }]),
      role: "alert"
    }, [
      O(D, {
        class: "joy-icon-error",
        name: "warning-triangle"
      }),
      h("div", null, [
        t.default ? w(o.$slots, "default", { key: 0 }, void 0, !0) : e.errors ? (c(), v("ul", Ia, [
          (c(!0), v(H, null, G(e.errors, (n) => (c(), v("li", { key: n }, P(n), 1))), 128))
        ])) : (c(), v(H, { key: 2 }, [
          R(P(e.noHtmlErrorText), 1)
        ], 64))
      ])
    ], 10, Ta));
  }
}), _t = /* @__PURE__ */ z(La, [["__scopeId", "data-v-de16f6d9"]]), Ba = { class: "joy-dropzone__icon-wrapper" }, Aa = /* @__PURE__ */ A({
  __name: "VJoyDropzoneIcon",
  props: {
    name: { type: String, required: !0 }
  },
  setup(e) {
    return (t, o) => (c(), v("div", Ba, [
      O(D, {
        "aria-hidden": "true",
        name: e.name,
        class: "joy-dropzone__icon"
      }, null, 8, ["name"])
    ]));
  }
}), bo = /* @__PURE__ */ z(Aa, [["__scopeId", "data-v-5a2d1889"]]), Ea = { class: "joy-dropzone__file__description" }, za = { class: "joy-dropzone__file__name" }, Ja = {
  key: 0,
  class: "joy-dropzone__file__information"
}, Pa = {
  key: 1,
  class: "joy-dropzone__file__error"
}, Ma = /* @__PURE__ */ A({
  __name: "VJoyDropzoneFileItem",
  props: {
    file: {},
    deleteLabel: {},
    updateLabel: {},
    error: {},
    canDelete: { type: Boolean, default: !0 }
  },
  emits: ["delete", "update"],
  setup(e) {
    const t = K(), o = e;
    return (l, n) => (c(), T(se, {
      "column-gap": "6",
      "row-gap": "4",
      justify: "flex-start",
      wrap: "nowrap",
      align: "center",
      "no-margin": "",
      class: "joy-dropzone__file"
    }, {
      default: J(() => [
        O(bo, {
          name: "file-check",
          class: "joy-dropzone__file__icon"
        }),
        h("div", Ea, [
          h("span", za, P(o.file.name), 1),
          t.information ? (c(), v("div", Ja, [
            w(l.$slots, "information", { file: e.file }, void 0, !0)
          ])) : k("", !0),
          e.error ? (c(), v("p", Pa, P(e.error), 1)) : k("", !0)
        ]),
        O(se, {
          "column-gap": "1",
          wrap: "nowrap",
          "no-margin": "",
          class: "joy-dropzone__file__actions"
        }, {
          default: J(() => [
            w(l.$slots, "actions", { file: e.file }, void 0, !0),
            O(Ve, {
              size: "medium",
              variant: "ghost",
              icon: "pen",
              title: e.updateLabel,
              label: e.updateLabel,
              onClick: n[0] || (n[0] = (i) => l.$emit("update"))
            }, null, 8, ["title", "label"]),
            e.canDelete ? (c(), T(Ve, {
              key: 0,
              size: "medium",
              variant: "ghost",
              icon: "trash",
              title: e.deleteLabel,
              label: e.deleteLabel,
              onClick: n[1] || (n[1] = (i) => l.$emit("delete"))
            }, null, 8, ["title", "label"])) : k("", !0)
          ]),
          _: 3
        })
      ]),
      _: 3
    }));
  }
}), Fa = /* @__PURE__ */ z(Ma, [["__scopeId", "data-v-a7525ca4"]]), Oa = ["name", "accept", "multiple"], Da = ["for"], Ra = {
  key: 0,
  class: "joy-dropzone__files"
}, Na = { class: "joy-dropzone__instruction__text" }, qa = {
  key: 0,
  class: "joy-dropzone__legend"
}, Ha = /* @__PURE__ */ A({
  __name: "VJoyDropzone",
  props: /* @__PURE__ */ Bo({
    name: {},
    multiple: { type: Boolean, default: !1 },
    accept: { default: () => [] },
    maxSize: { default: 32 },
    deleteLabel: { default: "Delete this file" },
    updateLabel: { default: "Update this file" },
    errorTextFormat: { default: "This format is not supported" },
    errorTextMaxSize: { default: (e) => `The file is over ${e.maxSize}MB. Upload a file smaller than ${e.maxSize}MB.` },
    errorTextFormatAndMaxSize: { default: (e) => `The file format isn't correct and is over ${e.maxSize}MB. Upload a file smaller than ${e.maxSize}MB.` },
    canDelete: { type: Boolean, default: !0 }
  }, {
    modelValue: { required: !0 },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e, { expose: t }) {
    const o = K(), l = e, n = Lo(e, "modelValue"), i = $(y(n.value)), a = $(), r = $(), u = $(), { isOverDropZone: s } = Tn(r, {
      onDrop: j
    }), m = V(() => n.value.filter((E) => E instanceof File)), d = V(() => l.multiple || m.value.length === 0 ? void 0 : g(m.value[0]));
    function f(E) {
      return l.accept.length > 0 ? l.accept.includes(E.type) : !0;
    }
    function p(E) {
      return E.size < l.maxSize * 1024 * 1024;
    }
    function y(E) {
      return E.filter((U) => U instanceof File).some((U) => !f(U) || !p(U));
    }
    function g(E) {
      if (!(E instanceof File))
        return;
      const q = f(E), U = p(E);
      if (!q && !U)
        return l.errorTextFormatAndMaxSize;
      if (!q)
        return l.errorTextFormat;
      if (!U)
        return l.errorTextMaxSize;
    }
    function b() {
      a.value = void 0, u.value && u.value.click();
    }
    function C() {
      u.value && (u.value.value = "");
    }
    function _(E) {
      var U;
      const q = (U = E.target) == null ? void 0 : U.files;
      !q || q.length === 0 || (a.value ? (M(a.value, Array.from(q)), a.value = void 0) : x(Array.from(q)));
    }
    function j(E) {
      !E || E.length === 0 || (a.value = void 0, x(E));
    }
    function S(E) {
      a.value = E, u.value && u.value.click();
    }
    function I(E) {
      i.value = y(E), n.value = E;
    }
    function L(E) {
      I(n.value.filter((q) => q !== E));
    }
    function x(E) {
      l.multiple ? I([...n.value, ...E]) : I([E[0]]);
    }
    function M(E, [q, ...U]) {
      if (l.multiple) {
        const ne = [...n.value];
        ne[n.value.indexOf(E)] = q, ne.push(...U), I(ne);
      } else
        I([q]);
    }
    return t({
      invalid: i
    }), (E, q) => (c(), v("div", {
      class: B(["joy-dropzone", {
        "joy-dropzone--dragover": F(s),
        "joy-dropzone--invalid": i.value,
        "joy-dropzone--empty": n.value.length === 0
      }])
    }, [
      h("div", {
        ref_key: "dropzoneAreaRef",
        ref: r,
        class: "joy-dropzone__area"
      }, [
        h("input", {
          ref_key: "inputRef",
          ref: u,
          name: e.name,
          type: "file",
          accept: e.accept.join(","),
          multiple: e.multiple,
          tabindex: "-1",
          onChange: _,
          onClick: C
        }, null, 40, Oa),
        h("label", {
          for: e.name,
          class: "joy-dropzone__label"
        }, [
          n.value.length > 0 ? (c(), v("div", Ra, [
            (c(!0), v(H, null, G(n.value, (U, ne) => (c(), T(Fa, {
              key: `${U.name}_${ne}`,
              file: U,
              error: e.multiple ? g(U) : void 0,
              "update-label": e.updateLabel,
              "delete-label": e.deleteLabel,
              "can-delete": e.canDelete,
              onUpdate: (ke) => S(U),
              onDelete: (ke) => L(U)
            }, yt({ _: 2 }, [
              o["file-information"] ? {
                name: "information",
                fn: J(() => [
                  w(E.$slots, "file-information", { file: U }, void 0, !0)
                ]),
                key: "0"
              } : void 0,
              o["file-actions"] ? {
                name: "actions",
                fn: J(() => [
                  w(E.$slots, "file-actions", { file: U }, void 0, !0)
                ]),
                key: "1"
              } : void 0
            ]), 1032, ["file", "error", "update-label", "delete-label", "can-delete", "onUpdate", "onDelete"]))), 128))
          ])) : k("", !0),
          n.value.length === 0 || e.multiple ? (c(), T(se, {
            key: 1,
            wrap: "nowrap",
            "no-margin": "",
            class: "joy-dropzone__instruction",
            onClick: b
          }, {
            default: J(() => [
              O(bo, {
                name: "add",
                class: "joy-dropzone__instruction__icon"
              }),
              h("p", Na, [
                w(E.$slots, "dropzone-description", {}, () => [
                  q[0] || (q[0] = R("Drop your file here or click here", -1))
                ], !0)
              ])
            ]),
            _: 3
          })) : k("", !0)
        ], 8, Da)
      ], 512),
      o["dropzone-legend"] ? (c(), v("div", qa, [
        w(E.$slots, "dropzone-legend", {}, void 0, !0)
      ])) : k("", !0),
      d.value ? (c(), T(_t, {
        key: 1,
        "no-html-error-text": d.value,
        class: "joy-dropzone__error"
      }, null, 8, ["no-html-error-text"])) : k("", !0)
    ], 2));
  }
}), Au = /* @__PURE__ */ z(Ha, [["__scopeId", "data-v-3c9052aa"]]), Wa = ["aria-label"], Ua = { class: "joy-filter-bar__wrapper" }, Ga = /* @__PURE__ */ A({
  __name: "VJoyFilterBar",
  props: {
    /** To give a label to the whole component */
    ariaLabel: String
  },
  setup(e) {
    return (t, o) => (c(), v("div", {
      class: "joy-filter-bar",
      role: "group",
      "aria-label": e.ariaLabel || "Filter bar"
    }, [
      h("div", Ua, [
        w(t.$slots, "default", {}, void 0, !0)
      ])
    ], 8, Wa));
  }
}), Eu = /* @__PURE__ */ z(Ga, [["__scopeId", "data-v-cb769d05"]]), Ka = /* @__PURE__ */ A({
  __name: "VJoyFilterBarButton",
  props: {
    /** Label to inject inside the  button */
    label: String,
    /** Required when used in the `VJoyFilterBar` to properly handle v-model */
    value: {
      type: String,
      required: !0
    },
    active: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["filter"],
  setup(e, { emit: t }) {
    const o = e, l = t, n = ce("VJoyDropdownContext", null);
    function i() {
      l("filter", o.value);
    }
    return (a, r) => (c(), v("button", {
      type: "button",
      "data-joy-form-field": "",
      class: B(["joy-filter-bar-button", { "joy-filter-bar-button--active": e.active }]),
      onClick: i
    }, [
      R(P(e.label) + " ", 1),
      w(a.$slots, "default", {}, void 0, !0),
      F(n) ? (c(), T(D, {
        key: 0,
        class: "joy-filter-bar-button__icon",
        name: "chevron-down",
        size: "xxsmall",
        color: "neutral"
      })) : k("", !0)
    ], 2));
  }
}), zu = /* @__PURE__ */ z(Ka, [["__scopeId", "data-v-ef875842"]]), Ya = { class: "floating-actions-bar__content" }, Za = { class: "floating-actions-bar__actions" }, Xa = /* @__PURE__ */ A({
  __name: "VJoyFloatingActionsBar",
  props: {
    height: { default: "92px" },
    appendTo: { default: "body" },
    justify: { default: "space-between" }
  },
  setup(e) {
    const t = e, o = $(!1);
    return ee(() => {
      o.value = !0;
    }), (l, n) => o.value ? (c(), T(Te, {
      key: 0,
      to: t.appendTo
    }, [
      h("div", {
        class: B([
          "floating-actions-bar",
          "joy-bgcolor-neutral-0",
          "joy-core-elevation-2",
          "joy-core-radius-4",
          {
            "floating-actions-bar--scoped": t.appendTo !== "body"
          }
        ]),
        style: X({ height: t.height })
      }, [
        h("div", {
          class: "floating-actions-bar__inner",
          style: X({ justifyContent: t.justify })
        }, [
          h("div", Ya, [
            w(l.$slots, "content", {}, void 0, !0)
          ]),
          h("div", Za, [
            w(l.$slots, "actions", {}, void 0, !0)
          ])
        ], 4)
      ], 6)
    ], 8, ["to"])) : k("", !0);
  }
}), Ju = /* @__PURE__ */ z(Xa, [["__scopeId", "data-v-2d398d78"]]), Qa = /* @__PURE__ */ A({
  __name: "VJoyFormFieldSkeleton",
  props: {
    /** In some cases you'll need to inject the error in the DOM but hide it. Visible by default */
    size: {
      type: String,
      default: "medium"
    },
    width: {
      type: String
    },
    /** The component is aimed to be used with a VJoyWrapper to quickly create skeleton layouts.
     * Use flex property to spread your items horizontally, by default they will all have the same width.
     */
    flex: {
      type: String,
      default: "1"
    }
  },
  setup(e, { expose: t }) {
    const o = e, l = ce("VJoyWrapperContext", {}), n = V(() => {
      const i = l.direction === "column" ? "auto" : null;
      if (!o.width && o.flex === "1") {
        const u = ["1", "0"];
        return i && u.push(i), u.join(" ");
      }
      const a = [o.flex || "1", "0"], r = o.width || i;
      return r && a.push(r), a.join(" ");
    });
    return t({ flexStyle: n }), (i, a) => (c(), v("div", {
      "aria-hidden": "true",
      class: B(["joy-form-skeleton", `joy-form-skeleton--${e.size}`]),
      style: X({
        "max-width": e.width,
        flex: n.value
      })
    }, null, 6));
  }
}), Pu = /* @__PURE__ */ z(Qa, [["__scopeId", "data-v-3004f370"]]), ei = /* @__PURE__ */ A({
  inheritAttrs: !1,
  __name: "VJoyFormGroup",
  setup(e) {
    return (t, o) => (c(), v("div", N({ class: "joy-form-group" }, t.$attrs), [
      w(t.$slots, "default", {}, void 0, !0)
    ], 16));
  }
}), Mu = /* @__PURE__ */ z(ei, [["__scopeId", "data-v-0424f0f1"]]), ti = { class: "joy-funnel__header" }, oi = { class: "funnel__header__inner" }, ni = /* @__PURE__ */ A({
  __name: "VJoyFunnel",
  props: {
    /**
     * Remove decorative shapes placed at the bottom right corner
     */
    hideShapes: {
      type: Boolean,
      default: !1
    },
    layoutWidth: {
      type: String,
      default: "large"
    },
    profile: {
      type: String,
      default: "default"
    }
  },
  setup(e, { expose: t }) {
    const o = $(!0), l = K(), n = $(!0);
    te("VJoyStepperShowLabels", n);
    function i(u) {
      const s = u.currentTarget;
      o.value = s.scrollTop === 0, a.value && !o.value ? n.value = !1 : a.value && o.value && (n.value = !0);
    }
    const a = V(() => !!l["funnel-stepper"]), r = V(() => l["funnel-footer"] ? l["funnel-footer"]().length > 0 : !1);
    return t({
      scrollOnTop: o,
      hasStepperSlot: a,
      hasFooterSlot: r
    }), (u, s) => (c(), v("div", {
      class: B([
        "joy-funnel",
        {
          "joy-funnel--no-stepper": !a.value
        }
      ])
    }, [
      h("div", ti, [
        h("div", oi, [
          w(u.$slots, "funnel-header", {}, void 0, !0)
        ])
      ]),
      e.hideShapes ? k("", !0) : (c(), v("div", {
        key: 0,
        class: B([
          "joy-funnel__shapes",
          {
            "joy-funnel__shapes--strategy": e.profile === "strategy",
            "joy-funnel__shapes--no-footer": !r.value
          }
        ])
      }, [...s[0] || (s[0] = [
        Ht('<div class="shapes__wrapper" data-v-e2fccb79><div class="shape_1" data-v-e2fccb79></div><div class="shape_2" data-v-e2fccb79></div><div class="shape_3" data-v-e2fccb79></div><div class="shape_4" data-v-e2fccb79></div></div>', 1)
      ])], 2)),
      h("div", {
        class: B(["joy-funnel__stepper", { "joy-funnel__stepper--medium": e.layoutWidth === "medium" }])
      }, [
        w(u.$slots, "funnel-stepper", {}, void 0, !0)
      ], 2),
      h("div", {
        class: "joy-funnel__scrollable",
        onScroll: i
      }, [
        h("div", {
          class: B(["joy-funnel__content", { "joy-funnel__content--medium": e.layoutWidth === "medium" }])
        }, [
          w(u.$slots, "default", {}, void 0, !0)
        ], 2)
      ], 32)
    ], 2));
  }
}), Fu = /* @__PURE__ */ z(ni, [["__scopeId", "data-v-e2fccb79"]]), li = { class: "joy-funnel-footer" }, ai = { class: "joy-funnel-footer__left" }, ii = { class: "joy-funnel-footer__right" }, ri = /* @__PURE__ */ A({
  __name: "VJoyFunnelFooter",
  setup(e) {
    return (t, o) => (c(), v("footer", li, [
      h("div", ai, [
        w(t.$slots, "footer-left", {}, void 0, !0)
      ]),
      h("div", ii, [
        w(t.$slots, "footer-right", {}, void 0, !0)
      ])
    ]));
  }
}), Ou = /* @__PURE__ */ z(ri, [["__scopeId", "data-v-bdeeb2bd"]]), si = { class: "joy-funnel-header" }, ui = { class: "joy-funnel-header__left" }, ci = { class: "joy-funnel-header__right" }, di = /* @__PURE__ */ A({
  __name: "VJoyFunnelHeader",
  setup(e) {
    return (t, o) => (c(), v("header", si, [
      h("div", ui, [
        w(t.$slots, "funnel-header-left", {}, void 0, !0)
      ]),
      h("div", ci, [
        w(t.$slots, "funnel-header-right", {}, void 0, !0)
      ])
    ]));
  }
}), Du = /* @__PURE__ */ z(di, [["__scopeId", "data-v-e423038b"]]), fi = { class: "joy-highlight__decorator" }, yi = { class: "joy-highlight__text" }, mi = { key: 0 }, pi = /* @__PURE__ */ A({
  __name: "VJoyHighlight",
  props: {
    accent: {
      type: Boolean,
      default: !1
    },
    displayIcon: {
      type: Boolean,
      default: !1
    },
    /** Based on maltjoy/icons availabilities. Works in pair with displayIcon boolean prop. */
    icon: {
      type: String
    },
    /** import `TJoyHighlightLevels` */
    level: {
      type: String,
      default: "neutral"
    },
    /** Please note that 'default' variant has no effect. This property is meant to completely override "level" prop style */
    variant: {
      type: String,
      default: "default"
    }
  },
  setup(e, { expose: t }) {
    const o = e, l = V(() => o.icon ? o.icon : Ut(o.level));
    return t({
      getRelevantIcon: l
    }), (n, i) => (c(), v("div", {
      class: B([
        "joy-highlight",
        `joy-highlight_${e.level}`,
        `joy-highlight_${e.variant}`,
        {
          "joy-highlight__accent": e.accent,
          "joy-highlight__titled": n.$slots["highlight-title"]
        }
      ])
    }, [
      h("div", fi, [
        w(n.$slots, "highlight-decorator", {}, () => [
          e.displayIcon ? (c(), T(D, {
            key: 0,
            name: l.value
          }, null, 8, ["name"])) : k("", !0)
        ], !0)
      ]),
      h("div", yi, [
        n.$slots["highlight-title"] ? (c(), v("strong", mi, [
          w(n.$slots, "highlight-title", {}, void 0, !0)
        ])) : k("", !0),
        w(n.$slots, "default", {}, void 0, !0)
      ])
    ], 2));
  }
}), Ru = /* @__PURE__ */ z(pi, [["__scopeId", "data-v-e5c2ff23"]]), vi = ["aria-label"], hi = /* @__PURE__ */ A({
  __name: "VJoyIndicator",
  props: {
    /** Value is used for the parent v-model. Mandatory */
    value: {
      type: [String, Number],
      required: !0
    },
    /** Automatically handled by parent. No need to set it manually */
    selected: {
      type: Boolean,
      default: !1
    },
    variant: {
      type: String,
      default: "default"
    },
    /** Indicators are text-less buttons by design. To make them more accessible, you can pass them an aria-label that will describe more their action. */
    ariaLabel: {
      type: String
    }
  },
  setup(e) {
    return (t, o) => (c(), v("li", {
      class: B(["joy-indicator", `joy-indicator--${e.variant}`, { "joy-indicator--selected": e.selected }])
    }, [
      h("button", {
        type: "button",
        class: B(["joy-indicator--button", { "joy-indicator--button-selected": e.selected }]),
        "aria-label": e.ariaLabel || e.value.toString()
      }, null, 10, vi)
    ], 2));
  }
}), gi = /* @__PURE__ */ z(hi, [["__scopeId", "data-v-5fbd653e"]]), bi = /* @__PURE__ */ A({
  __name: "VJoyIndicators",
  props: {
    variant: {
      type: String
    },
    /** Use the component with a v-model to easily handle selected items */
    modelValue: {
      type: [String, Number]
    }
  },
  emits: ["update:modelValue"],
  setup(e, { expose: t, emit: o }) {
    const l = e, n = o, i = K(), a = $(l.modelValue), r = V(() => {
      const d = i.default();
      return d.length === 1 && typeof d[0].type != "object" ? d[0].children.filter(s) : d.filter(s);
    });
    function u(d) {
      return a.value === d.props.value;
    }
    function s(d) {
      var f;
      return ((f = d == null ? void 0 : d.type) == null ? void 0 : f.__name) === "VJoyIndicator";
    }
    function m(d) {
      n("update:modelValue", d.props.value), a.value = d.props.value;
    }
    return W(
      () => l.modelValue,
      (d, f) => {
        d !== f && (a.value = d);
      }
    ), t({
      indicators: r,
      isSelected: u
    }), (d, f) => (c(), v("ul", {
      class: B(["joy-indicators", `joy-indicators--${e.variant}`])
    }, [
      (c(!0), v(H, null, G(r.value, (p) => (c(), T(gi, N({
        key: p.props.value
      }, { ref_for: !0 }, { ...p.props, variant: e.variant }, {
        selected: u(p),
        onClick: (y) => m(p)
      }), null, 16, ["selected", "onClick"]))), 128))
    ], 2));
  }
}), Nu = /* @__PURE__ */ z(bi, [["__scopeId", "data-v-f2dd63e9"]]), wi = ["id", "name", "required", "disabled", "readonly", "type", "value"], ji = ["data-unit"], ki = /* @__PURE__ */ A({
  inheritAttrs: !1,
  __name: "VJoyInput",
  props: {
    autofocus: { type: Boolean, default: !1 },
    modelValue: {},
    disabled: { type: Boolean, default: !1 },
    id: {},
    invalid: { type: Boolean, default: !1 },
    name: {},
    required: { type: Boolean, default: !1 },
    label: {},
    labelSize: { default: "medium" },
    optionalLabel: {},
    requiredMark: { type: Boolean, default: !1 },
    modelModifiers: { default: () => ({ lazy: !1 }) },
    clearable: { type: Boolean, default: !1 },
    icon: {},
    size: { default: "medium" },
    type: { default: "text" },
    unit: {},
    readonly: { type: Boolean, default: !1 },
    clearAriaLabel: { default: "Clear input" }
  },
  emits: ["update:modelValue"],
  setup(e, { expose: t, emit: o }) {
    const l = o, n = e, i = ce("VJoyWrapperContext", {});
    te(me, !0);
    const a = $(), r = $(), u = oe(), s = K(), m = $(!1), d = $(!1);
    go(a, n.autofocus);
    const f = V(() => typeof n.modelValue == "number" || !n.clearable || n.unit || !n.modelValue ? !1 : n.modelValue.length > 0 && !n.unit), p = V(() => s.default && s.default()), y = V(() => Object.keys(i).length > 0), g = $(n.type), b = V(() => n.type === "password" && !!n.modelValue);
    W(
      () => [n.type, n.unit],
      () => {
        g.value = n.unit ? "number" : n.type;
      },
      { immediate: !0 }
    );
    function C() {
      var j;
      n.readonly || (j = a.value) == null || j.focus();
    }
    const _ = {
      onFocus: () => {
        n.readonly || (m.value = !0);
      },
      onBlur: () => {
        m.value = !1;
      },
      onWheelScroll(j) {
        n.type === "number" && j.preventDefault();
      },
      onInput: (j) => {
        let S = j.target.value;
        n.modelModifiers.lazy || l("update:modelValue", S);
      },
      onChange: (j) => {
        let S = j.target.value;
        n.modelModifiers.lazy && l("update:modelValue", S);
      },
      clearValue: () => {
        n.disabled || l("update:modelValue", "");
      },
      togglePassword: (j) => {
        j.preventDefault(), d.value = !d.value, d.value ? g.value = "text" : g.value = "password";
      }
    };
    return t({
      focus: C
    }), (j, S) => (c(), v("div", {
      ref_key: "root",
      ref: r,
      class: B([`joy-input--${n.size}`])
    }, [
      h("div", {
        class: B([
          "joy-input",
          {
            "joy-input--focusing": m.value,
            "joy-input--disabled": e.disabled,
            "joy-input--invalid": e.invalid,
            "joy-input--readonly": e.readonly,
            "joy-input--valid": !e.invalid && !F(u).disabled
          }
        ])
      }, [
        p.value || e.label ? (c(), T(Pe, {
          key: 0,
          for: e.id || e.name,
          required: e.required && e.requiredMark,
          "optional-label": e.optionalLabel,
          size: e.labelSize
        }, {
          default: J(() => [
            w(j.$slots, "default", {}, () => [
              R(P(e.label), 1)
            ], !0)
          ]),
          _: 3
        }, 8, ["for", "required", "optional-label", "size"])) : k("", !0),
        h("div", {
          class: B([
            "joy-input--wrapper",
            {
              "joy-input--wrapper-has-icon": !!e.icon,
              "joy-input--wrapper---clearable": e.clearable,
              "joy-input--wrapper-unit": !!e.unit,
              "joy-input--wrapper-margin": !y.value
            }
          ])
        }, [
          e.icon ? (c(), T(D, {
            key: 0,
            class: "joy-input--decorative-icon",
            name: e.icon
          }, null, 8, ["name"])) : k("", !0),
          h("input", N(j.$attrs, {
            id: e.id || e.name,
            ref_key: "input",
            ref: a,
            "data-joy-form-field": "",
            name: e.name,
            required: e.required,
            disabled: e.disabled,
            readonly: e.readonly,
            class: [
              {
                "joy-input--field-disabled": e.disabled,
                "joy-input--field-invalid": e.invalid
              }
            ],
            type: g.value,
            value: e.modelValue,
            onFocus: S[0] || (S[0] = //@ts-ignore
            (...I) => _.onFocus && _.onFocus(...I)),
            onBlur: S[1] || (S[1] = //@ts-ignore
            (...I) => _.onBlur && _.onBlur(...I)),
            onInput: S[2] || (S[2] = //@ts-ignore
            (...I) => _.onInput && _.onInput(...I)),
            onChange: S[3] || (S[3] = //@ts-ignore
            (...I) => _.onChange && _.onChange(...I)),
            onWheel: S[4] || (S[4] = //@ts-ignore
            (...I) => _.onWheelScroll && _.onWheelScroll(...I))
          }), null, 16, wi),
          f.value ? (c(), T(Ve, {
            key: 1,
            class: "joy-input--clear",
            label: e.clearAriaLabel,
            variant: "ghost",
            size: "xxsmall",
            icon: "cross",
            onClick: _.clearValue
          }, null, 8, ["label", "onClick"])) : k("", !0),
          w(j.$slots, "right-action", {}, () => [
            b.value ? (c(), T(D, {
              key: 0,
              class: "joy-input--password-icon",
              name: d.value ? "eye-masked" : "eye",
              onClick: _.togglePassword
            }, null, 8, ["name", "onClick"])) : k("", !0),
            e.unit ? (c(), v("div", {
              key: 1,
              "data-unit": e.unit,
              class: "joy-input--unit"
            }, null, 8, ji)) : k("", !0)
          ], !0)
        ], 2)
      ], 2)
    ], 2));
  }
}), $t = /* @__PURE__ */ z(ki, [["__scopeId", "data-v-b420342d"]]), _i = { class: "joy-input-digit__wrapper" }, $i = /* @__PURE__ */ A({
  inheritAttrs: !1,
  __name: "VJoyInputDigit",
  props: {
    modelValue: { default: "" },
    length: { default: 6 },
    invalid: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    name: { default: "joy-input-digit" },
    inputAriaLabel: { default: "Digit" }
  },
  emits: ["update:modelValue", "change", "focus", "blur"],
  setup(e, { expose: t, emit: o }) {
    const l = e, n = o, i = oe(), a = $([]), r = $([]);
    te("VJoyWrapperContext", { withinInputDigit: !0 });
    const u = V(() => Math.max(1, l.length));
    function s(j) {
      return `${l.inputAriaLabel ?? "Digit"} ${j + 1}/${u.value}`;
    }
    function m(j) {
      return j ? /^\d$/.test(j) : !1;
    }
    function d(j = "") {
      const S = j.split("").filter((I) => m(I)).slice(0, u.value);
      r.value = Array.from({ length: u.value }, (I, L) => S[L] || "");
    }
    function f(j) {
      const S = r.value.join("");
      n("update:modelValue", S), n("change", S, j);
    }
    function p(j) {
      const S = a.value[j], I = S == null ? void 0 : S.$el;
      return I == null ? void 0 : I.querySelector("input");
    }
    function y(j) {
      const S = p(j);
      S == null || S.focus(), S == null || S.select();
    }
    function g(j) {
      const S = Math.min(j + 1, u.value - 1);
      S !== j && y(S);
    }
    function b(j) {
      const S = Math.max(j - 1, 0);
      S !== j && y(S);
    }
    function C(j, S) {
      let I = j;
      for (const L of S) {
        if (I >= u.value)
          break;
        r.value[I] = L, I += 1;
      }
      return Math.min(I, u.value - 1);
    }
    const _ = {
      onInput: (j, S) => {
        const I = j.split("").filter((x) => m(x)).slice(0, u.value - S);
        if (I.length === 0) {
          r.value[S] = "", f(new Event("input"));
          return;
        }
        const L = C(S, I);
        f(new Event("input")), l.disabled || (y(L), I.length === 1 && g(S));
      },
      onKeyDown: (j, S) => {
        if (!(j.ctrlKey || j.metaKey))
          switch (j.key) {
            case "ArrowLeft":
              b(S), j.preventDefault();
              return;
            case "ArrowRight":
              g(S), j.preventDefault();
              return;
            case "ArrowUp":
            case "ArrowDown":
              j.preventDefault();
              return;
            case "Backspace":
              r.value[S] || b(S);
              return;
            case "Enter":
            case "Tab":
            case "Delete":
              return;
            default:
              m(j.key) || j.preventDefault();
          }
      },
      onPaste: (j, S) => {
        var M;
        j.preventDefault();
        const L = (((M = j.clipboardData) == null ? void 0 : M.getData("text")) || "").split("").filter((E) => m(E)).slice(0, u.value - S);
        if (!L.length)
          return;
        const x = C(S, L);
        f(j), y(x);
      },
      onFocus: (j) => {
        j.target.select(), n("focus", j);
      },
      onBlur: (j) => {
        n("blur", j);
      },
      onClick: (j) => {
        j.target.select();
      }
    };
    return W(
      () => [l.modelValue, l.length],
      () => {
        d(l.modelValue);
      },
      { immediate: !0 }
    ), t({
      focusInput: y,
      tokens: r
    }), (j, S) => (c(), v("div", _i, [
      h("div", {
        class: B([
          "joy-input-digit",
          {
            "joy-input-digit--invalid": l.invalid,
            "joy-input-digit--disabled": l.disabled
          }
        ])
      }, [
        (c(!0), v(H, null, G(u.value, (I, L) => (c(), v("div", {
          key: L,
          class: "joy-input-digit__field joy-input-digit__item"
        }, [
          O($t, N({ ref_for: !0 }, F(i), {
            ref_for: !0,
            ref_key: "inputRefs",
            ref: a,
            name: `${l.name}-${L + 1}`,
            "model-value": r.value[L],
            type: "number",
            inputmode: "numeric",
            size: "medium",
            disabled: l.disabled,
            invalid: l.invalid,
            "aria-label": s(L),
            autocomplete: "one-time-code",
            maxlength: "1",
            "onUpdate:modelValue": (x) => _.onInput(x, L),
            onKeydown: (x) => _.onKeyDown(x, L),
            onPaste: (x) => _.onPaste(x, L),
            onFocus: _.onFocus,
            onBlur: _.onBlur,
            onClick: _.onClick
          }), null, 16, ["name", "model-value", "disabled", "invalid", "aria-label", "onUpdate:modelValue", "onKeydown", "onPaste", "onFocus", "onBlur", "onClick"])
        ]))), 128))
      ], 2)
    ]));
  }
}), qu = /* @__PURE__ */ z($i, [["__scopeId", "data-v-f359f1d1"]]), Ci = { class: "joy-input-unit" }, Si = {
  key: 0,
  class: "joy-input__unit___label"
}, xi = { class: "joy-input__unit___label____text" }, Vi = /* @__PURE__ */ A({
  inheritAttrs: !1,
  __name: "VJoyInputNumber",
  props: {
    autofocus: { type: Boolean, default: !1 },
    modelValue: {},
    disabled: { type: Boolean, default: !1 },
    id: {},
    invalid: { type: Boolean, default: !1 },
    name: { default: "joy-input-password" },
    required: { type: Boolean, default: !1 },
    label: {},
    labelSize: { default: "medium" },
    optionalLabel: {},
    requiredMark: { type: Boolean, default: !1 },
    modelModifiers: { default: () => ({ lazy: !1 }) },
    icon: {},
    size: {},
    type: { default: "number" },
    unit: { default: "€" },
    readonly: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue"],
  setup(e, { expose: t, emit: o }) {
    const l = o, n = e, i = oe(), a = $();
    function r() {
      var u;
      (u = a.value) == null || u.focus();
    }
    return t({
      focus: r
    }), (u, s) => (c(), v("div", Ci, [
      O($t, N({
        ref_key: "input",
        ref: a
      }, { ...F(i), ...n }, {
        "onUpdate:modelValue": s[0] || (s[0] = (m) => l("update:modelValue", m))
      }), {
        "right-action": J(() => [
          e.unit ? (c(), v("div", Si, [
            h("span", xi, P(e.unit), 1)
          ])) : k("", !0)
        ]),
        _: 1
      }, 16)
    ]));
  }
}), Hu = /* @__PURE__ */ z(Vi, [["__scopeId", "data-v-4747ea64"]]), Ti = { class: "joy-input-password" }, Ii = /* @__PURE__ */ A({
  inheritAttrs: !1,
  __name: "VJoyInputPassword",
  props: {
    autofocus: { type: Boolean, default: !1 },
    modelValue: {},
    disabled: { type: Boolean, default: !1 },
    id: {},
    invalid: { type: Boolean, default: !1 },
    name: { default: "joy-input-password" },
    required: { type: Boolean, default: !1 },
    label: {},
    labelSize: { default: "medium" },
    optionalLabel: {},
    requiredMark: { type: Boolean, default: !1 },
    modelModifiers: { default: () => ({ lazy: !1 }) },
    icon: {},
    size: {},
    unit: {}
  },
  emits: ["update:modelValue"],
  setup(e, { expose: t, emit: o }) {
    const l = o, n = e, i = oe(), a = $(), r = $(!1), u = V(() => r.value ? "text" : "password");
    function s(d) {
      d.preventDefault(), !n.disabled && (r.value = !r.value);
    }
    function m() {
      var d;
      (d = a.value) == null || d.focus();
    }
    return t({
      focus: m
    }), (d, f) => (c(), v("div", Ti, [
      O($t, N({
        ref_key: "input",
        ref: a
      }, { ...F(i), ...n }, {
        type: u.value,
        "onUpdate:modelValue": f[0] || (f[0] = (p) => l("update:modelValue", p))
      }), {
        "right-action": J(() => [
          O(D, {
            class: B(["joy-input__password-icon", { "joy-input__password-icon--disabled": e.disabled }]),
            name: r.value ? "eye-masked" : "eye",
            onClick: s
          }, null, 8, ["class", "name"])
        ]),
        _: 1
      }, 16, ["type"]),
      d.$slots["password-requirements"] ? (c(), T(se, {
        key: 0,
        class: "joy-mt-2",
        "no-margin": "",
        "row-gap": "2",
        justify: "flex-start"
      }, {
        default: J(() => [
          w(d.$slots, "password-requirements", {}, void 0, !0)
        ]),
        _: 3
      })) : k("", !0)
    ]));
  }
}), Wu = /* @__PURE__ */ z(Ii, [["__scopeId", "data-v-48cbd09c"]]), Li = { class: "joy-link__text" }, Bi = /* @__PURE__ */ A({
  __name: "VJoyLink",
  props: {
    href: {
      type: String
    },
    color: {
      type: String,
      default: "teal"
    },
    icon: String,
    text: String,
    type: {
      type: String
    }
  },
  setup(e) {
    return (t, o) => (c(), T(Y(e.href ? "a" : "button"), N({ href: e.href }, t.$attrs, {
      class: ["joy-link", `joy-link_${e.color}`],
      type: e.type
    }), {
      default: J(() => [
        e.icon ? (c(), T(D, {
          key: 0,
          name: e.icon
        }, null, 8, ["name"])) : k("", !0),
        h("span", Li, [
          w(t.$slots, "default", {}, () => [
            R(P(e.text), 1)
          ], !0)
        ])
      ]),
      _: 3
    }, 16, ["href", "class", "type"]));
  }
}), Uu = /* @__PURE__ */ z(Bi, [["__scopeId", "data-v-19a65db4"]]), Ai = { class: "joy-list-item__left" }, Ei = { class: "joy-font-primary-300 joy-m-0" }, zi = { class: "joy-list-item__right" }, Ji = /* @__PURE__ */ A({
  __name: "VJoyListItem",
  props: {
    icon: {}
  },
  emits: ["click"],
  setup(e) {
    return (t, o) => (c(), v("div", {
      class: "joy-list-item joy-core-radius-3 joy-pt-2 joy-pl-3 joy-pr-3 joy-pb-2 joy-color-neutral-60",
      onClick: o[0] || (o[0] = (l) => t.$emit("click"))
    }, [
      O(se, {
        "no-margin": "",
        "row-gap": "2",
        wrap: "nowrap",
        justify: "space-between"
      }, {
        default: J(() => [
          h("div", Ai, [
            e.icon ? (c(), T(D, {
              key: 0,
              class: "joy-p-3 joy-list-item__left-icon",
              name: e.icon
            }, null, 8, ["name"])) : k("", !0),
            h("p", Ei, [
              w(t.$slots, "list-item-left", {}, void 0, !0)
            ])
          ]),
          h("div", zi, [
            w(t.$slots, "list-item-right", {}, void 0, !0)
          ])
        ]),
        _: 3
      })
    ]));
  }
}), Gu = /* @__PURE__ */ z(Ji, [["__scopeId", "data-v-6c3750f0"]]), Pi = ["aria-activedescendant", "aria-label"], Mi = ["aria-disabled", "aria-current", "title", "aria-label", ".dataModel", "onClick"], Fi = { "aria-hidden": "true" }, Oi = /* @__PURE__ */ A({
  __name: "VJoyMenu",
  props: {
    /**
     * DEPRECATED: In order to make it work with v-model, you need to pass for each option, a value or an ID.
     */
    items: {
      type: Array,
      default() {
        return [];
      }
    },
    modelValue: {
      type: String
    },
    ariaLabel: {
      type: String
    }
  },
  emits: ["selectItem"],
  setup(e, { expose: t, emit: o }) {
    const l = o, n = $();
    $(0);
    const i = $();
    function a(d) {
      d.disabled || l("selectItem", d);
    }
    function r() {
      var d;
      return Array.from(((d = n.value) == null ? void 0 : d.querySelectorAll("li")) || []).filter((f) => f.getAttribute("aria-disabled") !== "true");
    }
    function u(d) {
      return d.id || Qe();
    }
    function s() {
      return r().find((d) => d === document.activeElement);
    }
    function m(d) {
      if (s() && d.key === " " && d.preventDefault(), d.key === "Tab" && (i.value = void 0), ["ArrowDown", "ArrowUp", "Home", "End"].includes(d.key)) {
        d.preventDefault();
        const f = r(), p = s();
        let y = f.indexOf(p);
        if (d.key === "ArrowDown" ? y++ : d.key === "ArrowUp" ? y-- : d.key === "Home" ? y = 0 : d.key === "End" && (y = f.length - 1), y < 0 && (y = 0), y > f.length - 1)
          return;
        i.value = f[y].id, f[y].focus();
      }
      if (d.key === "Enter") {
        const f = s();
        if (!f)
          return;
        const p = f.querySelector("a");
        f && p ? p.click() : f.click();
      }
    }
    return t({
      activeMenuItemId: i,
      getItems: r,
      getItemId: u,
      getFocusedItem: s
    }), (d, f) => {
      const p = dt("bind-once");
      return c(), v("ul", {
        ref_key: "menu",
        ref: n,
        class: "joy-menu-list joy-menu-list__items",
        "aria-activedescendant": i.value,
        "aria-label": e.ariaLabel,
        role: "menu",
        onKeydown: m
      }, [
        w(d.$slots, "default", {}, void 0, !0),
        (c(!0), v(H, null, G(e.items, (y) => Xe((c(), v("li", {
          key: y.label,
          class: B([
            "joy-menu-list__item",
            {
              "joy-menu-list__item--current": y.current,
              "joy-menu-list__item--disabled": y.disabled
            }
          ]),
          tabindex: "-1",
          "aria-disabled": y.disabled,
          "aria-current": y.current,
          title: y.label,
          "aria-label": y.label,
          ".dataModel": y.value || y.id,
          role: "menuitem",
          onClick: (g) => a(y)
        }, [
          h("div", Fi, [
            w(d.$slots, "menu-item", N({ ref_for: !0 }, y), () => [
              y.icon ? (c(), T(D, {
                key: 0,
                name: y.icon
              }, null, 8, ["name"])) : k("", !0),
              h("span", null, P(y.label), 1)
            ], !0)
          ])
        ], 42, Mi)), [
          [p, { id: u(y) }]
        ])), 128))
      ], 40, Pi);
    };
  }
}), Ku = /* @__PURE__ */ z(Oi, [["__scopeId", "data-v-b76ae1e8"]]), Di = ["aria-disabled", "aria-current", "title", "aria-label"], Ri = { class: "joy-menu-item__label joy-font-primary-400" }, Ni = /* @__PURE__ */ A({
  inheritAttrs: !1,
  __name: "VJoyMenuItem",
  props: {
    label: {},
    href: {},
    icon: {},
    current: { type: Boolean },
    disabled: { type: Boolean },
    status: {},
    statusColor: {},
    type: { default: "a" },
    linkProps: {}
  },
  emits: ["click"],
  setup(e, { expose: t, emit: o }) {
    const l = o, n = oe(), i = e, a = V(() => i.type !== "a" && i.type !== "button" ? i.linkProps : { ...n, href: i.href });
    function r() {
      i.disabled || l("click");
    }
    return t({
      getProps: a
    }), (u, s) => (c(), v("li", {
      class: B(["joy-menu-item"]),
      "aria-disabled": e.disabled,
      "aria-current": e.current,
      title: e.label,
      "aria-label": e.label,
      role: "menuitem"
    }, [
      (c(), T(Y(e.disabled ? "div" : e.type), N({ ...a.value, ...u.$attrs }, {
        class: [
          "joy-menu-item__inner",
          {
            "joy-menu-item__inner--current": e.current,
            "joy-menu-item__inner--disabled": e.disabled
          }
        ],
        type: e.type === "button" ? "button" : null,
        onClick: r
      }), {
        default: J(() => [
          e.icon ? (c(), T(D, {
            key: 0,
            class: "joy-menu-item__icon-left",
            name: e.icon
          }, null, 8, ["name"])) : k("", !0),
          h("span", Ri, P(e.label), 1),
          e.status ? (c(), T(D, {
            key: 1,
            class: "joy-menu-item__icon-right",
            name: e.status,
            color: e.statusColor
          }, null, 8, ["name", "color"])) : k("", !0)
        ]),
        _: 1
      }, 16, ["class", "type"]))
    ], 8, Di));
  }
}), Yu = /* @__PURE__ */ z(Ni, [["__scopeId", "data-v-1a8cef6b"]]), Mt = /* @__PURE__ */ A({
  __name: "PaginationIcon",
  props: {
    label: {
      type: String,
      required: !1
    },
    next: {
      type: Boolean,
      default: !1
    },
    disabled: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["click"],
  setup(e) {
    return (t, o) => (c(), T(Ve, {
      class: "joy-pagination__icon",
      label: e.label,
      title: e.label,
      color: "grey",
      icon: e.next ? "chevron-right" : "chevron-left",
      variant: "ghost",
      size: "xsmall",
      disabled: e.disabled,
      onClick: o[0] || (o[0] = (l) => t.$emit("click"))
    }, null, 8, ["label", "title", "icon", "disabled"]));
  }
}), qi = ["aria-label", "data-current"], Hi = ["onClick"], Wi = ["aria-current"], Ui = 6, Gi = /* @__PURE__ */ A({
  __name: "VJoyPagination",
  props: {
    /** Current page number */
    currentPage: {
      type: Number,
      default: 1
    },
    /** Total number of pages in order to construct the pagination */
    totalPages: {
      type: Number,
      default: 1
    },
    /** Can be used as aria-label attribute for the full component */
    labelPagination: {
      type: String,
      required: !1
    },
    /** Can be used as title and aria-label attributes for the previous CTA */
    labelPrev: {
      type: String,
      required: !1
    },
    /** Can be used as title and aria-label attributes for the next CTA */
    labelNext: {
      type: String,
      required: !1
    }
  },
  emits: ["update:current-page"],
  setup(e, { emit: t }) {
    const o = e, l = t, n = V(() => {
      const m = a.value.length;
      return a.value[m - 1] !== a.value[m - 2] + 1;
    }), i = V(() => a.value[0] !== a.value[1] - 1), a = V(() => o.totalPages === 1 ? [1] : o.totalPages < Ui ? u(2, o.totalPages - 1) : s(o.currentPage));
    function r(m, d) {
      o.currentPage === 1 && d === "prev" || o.currentPage === o.totalPages && d === "next" || l("update:current-page", m);
    }
    function u(m, d) {
      const f = [];
      f.push(1);
      for (let p = m; p <= d; p++)
        f.push(p);
      return f.push(o.totalPages), f;
    }
    function s(m) {
      let d = m - 2, f = m + 1;
      return d <= 1 && (d = 2, f = 5), f >= o.totalPages && (f = o.totalPages - 1, d = f - 3), u(d, f);
    }
    return (m, d) => (c(), v("nav", {
      role: "navigation",
      "aria-label": e.labelPagination,
      class: "joy-pagination",
      "data-current": e.currentPage
    }, [
      h("ul", null, [
        h("li", {
          class: "joy-pagination__item joy-pagination__previous",
          onClick: d[0] || (d[0] = (f) => r(e.currentPage - 1, "prev"))
        }, [
          w(m.$slots, "pagination-prev", {}, () => [
            O(Mt, {
              label: e.labelPrev,
              disabled: e.currentPage === 1
            }, null, 8, ["label", "disabled"])
          ], !0)
        ]),
        h("li", null, [
          h("ul", null, [
            (c(!0), v(H, null, G(a.value, (f) => (c(), v("li", {
              key: f,
              class: B({
                "joy-pagination__item": !0,
                "joy-pagination__page": !0,
                current: f === e.currentPage,
                "joy-pagination__separator joy-pagination__separator-after": e.totalPages > 1 && f === 1 && i.value,
                "joy-pagination__separator joy-pagination__separator-before": e.totalPages > 1 && f === e.totalPages && n.value
              }),
              onClick: (p) => r(f)
            }, [
              w(m.$slots, "page", N({ ref_for: !0 }, { page: f }), () => [
                h("button", {
                  type: "button",
                  "aria-current": f === e.currentPage ? "true" : "false"
                }, P(f), 9, Wi)
              ], !0)
            ], 10, Hi))), 128))
          ])
        ]),
        h("li", {
          class: "joy-pagination__next",
          onClick: d[1] || (d[1] = (f) => r(e.currentPage + 1, "next"))
        }, [
          w(m.$slots, "pagination-next", {}, () => [
            O(Mt, {
              next: "",
              label: e.labelNext,
              disabled: e.currentPage === e.totalPages
            }, null, 8, ["label", "disabled"])
          ], !0)
        ])
      ])
    ], 8, qi));
  }
}), Zu = /* @__PURE__ */ z(Gi, [["__scopeId", "data-v-7e82041f"]]), Ki = { class: "joy-screen-loader__content" }, Yi = {
  key: 0,
  class: "joy-screen-loader__content"
}, Zi = /* @__PURE__ */ A({
  __name: "VJoyScreenLoader",
  props: {
    /** Light or dark. Changes the spinner and background color */
    color: {
      type: String,
      default: "light"
    },
    /** The overlay mode set the component in an absolute position, and covers all the parent's area. */
    overlay: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    return (t, o) => (c(), v("div", {
      class: B(["joy-screen-loader", `joy-screen-loader--${e.color}`, { "joy-screen-loader--overlay": e.overlay }])
    }, [
      h("div", Ki, [
        w(t.$slots, "spinner", {}, () => [
          O(Xt, {
            color: e.color === "dark" ? "white" : "teal"
          }, null, 8, ["color"])
        ], !0),
        t.$slots.content ? (c(), v("div", Yi, [
          w(t.$slots, "content", {}, void 0, !0)
        ])) : k("", !0)
      ])
    ], 2));
  }
}), wo = /* @__PURE__ */ z(Zi, [["__scopeId", "data-v-266b7e2a"]]), Xi = {
  key: 0,
  class: /* @__PURE__ */ B(["joy-panel__header"])
}, Qi = {
  key: 0,
  class: "joy-panel__header-title-icon"
}, er = {
  key: 1,
  class: "joy-panel__header-action"
}, tr = {
  key: 2,
  class: "joy-panel__header-subtitle"
}, or = { class: "joy-panel__body" }, nr = {
  key: 1,
  class: "joy-panel__footer"
}, lr = /* @__PURE__ */ A({
  __name: "VJoyPanel",
  props: {
    flex: {
      type: String
    },
    noMargin: {
      type: Boolean,
      default: !1
    },
    padding: {
      type: String,
      default: "medium"
    },
    titleSize: {
      type: String,
      default: "large"
    },
    loading: {
      type: Boolean,
      default: !1
    },
    loadingColor: {
      type: String,
      default: "light"
    },
    variant: {
      type: String,
      default: "default"
    }
  },
  setup(e) {
    const t = ce("VJoyWrapperContext", {}), o = V(() => Object.keys(t).length > 0), l = K(), n = $(), i = V(() => !!l["panel-title"] || !!l["panel-subtitle"] || !!l["panel-title-action"] || !!l["panel-title-icon"]);
    return (a, r) => (c(), v("section", {
      ref_key: "panel",
      ref: n,
      style: X({ flex: e.flex }),
      class: B([
        "joy-panel",
        `joy-panel--${e.padding}`,
        `joy-panel--${e.variant}`,
        {
          "joy-panel--no-margin": e.noMargin || o.value,
          "joy-panel--loading": e.loading
        }
      ])
    }, [
      i.value ? (c(), v("header", Xi, [
        l["panel-title"] ? (c(), v("div", {
          key: 0,
          class: B(["joy-panel__header-title", `joy-panel__header-title--${e.titleSize}`])
        }, [
          l["panel-title-icon"] ? (c(), v("div", Qi, [
            w(a.$slots, "panel-title-icon", {}, void 0, !0)
          ])) : k("", !0),
          w(a.$slots, "panel-title", {}, void 0, !0)
        ], 2)) : k("", !0),
        l["panel-title-action"] ? (c(), v("div", er, [
          w(a.$slots, "panel-title-action", {}, void 0, !0)
        ])) : k("", !0),
        l["panel-subtitle"] ? (c(), v("div", tr, [
          w(a.$slots, "panel-subtitle", {}, void 0, !0)
        ])) : k("", !0)
      ])) : k("", !0),
      h("div", or, [
        w(a.$slots, "panel-body", {}, void 0, !0)
      ]),
      l["panel-action"] ? (c(), v("footer", nr, [
        w(a.$slots, "panel-action", {}, void 0, !0)
      ])) : k("", !0),
      e.loading ? (c(), T(wo, {
        key: 2,
        overlay: "",
        color: e.loadingColor
      }, {
        content: J(() => [
          w(a.$slots, "panel-loader-content", {}, void 0, !0)
        ]),
        _: 3
      }, 8, ["color"])) : k("", !0)
    ], 6));
  }
}), Xu = /* @__PURE__ */ z(lr, [["__scopeId", "data-v-b4158802"]]), ar = { class: "joy-panel-section" }, ir = {
  key: 0,
  class: "joy-panel-section__title"
}, rr = {
  key: 1,
  class: "joy-panel-section__content"
}, sr = /* @__PURE__ */ A({
  __name: "VJoyPanelSection",
  setup(e) {
    const t = K();
    return (o, l) => (c(), v("div", ar, [
      F(t)["panel-section-title"] ? (c(), v("div", ir, [
        w(o.$slots, "panel-section-title", {}, void 0, !0)
      ])) : k("", !0),
      F(t)["panel-section-content"] ? (c(), v("div", rr, [
        w(o.$slots, "panel-section-content", {}, void 0, !0)
      ])) : k("", !0)
    ]));
  }
}), Qu = /* @__PURE__ */ z(sr, [["__scopeId", "data-v-d88510ab"]]), ur = { class: "joy-password-requirement__label" }, cr = /* @__PURE__ */ A({
  __name: "VJoyPasswordRequirement",
  props: {
    label: {},
    status: { default: "neutral" }
  },
  setup(e) {
    const t = Ao(e, ["status"]);
    return (o, l) => (c(), v("div", N({
      class: ["joy-password-requirement", [`joy-password-requirement--${e.status}`]]
    }, e.status === "error" ? { "data-joy-form-error": "" } : {}), [
      e.status === "neutral" ? (c(), T(D, {
        key: 0,
        name: "circle",
        color: "neutral"
      })) : e.status === "success" ? (c(), T(D, {
        key: 1,
        name: "check-circle",
        color: "success"
      })) : (c(), T(D, {
        key: 2,
        name: "warning",
        size: "xsmall",
        color: "error"
      })),
      h("span", ur, P(t.label), 1)
    ], 16));
  }
}), ec = /* @__PURE__ */ z(cr, [["__scopeId", "data-v-57c149c0"]]), dr = /* @__PURE__ */ A({
  __name: "VJoyProductTourSpotlight",
  props: {
    disableOverlay: { type: Boolean }
  },
  setup(e) {
    return (t, o) => (c(), v("div", {
      class: B(["joy-product-tour-spotlight", { "joy-product-tour-spotlight--no-overlay": e.disableOverlay }])
    }, null, 2));
  }
}), fr = /* @__PURE__ */ z(dr, [["__scopeId", "data-v-343594f0"]]), yr = () => {
  const e = $(null);
  return {
    clearProductTourRef: () => {
      e.value = null;
    },
    storeProductTourRef: (l) => {
      var n;
      (n = e.value) == null || n.hide(), l && (e.value = l, e.value.show());
    },
    productToursRef: e
  };
}, jo = yr(), mr = { class: "joy-product-tour__content" }, pr = { class: "joy-product-tour__header" }, vr = {
  key: 0,
  class: "joy-product-tour__footer"
}, hr = { class: "joy-product-tour__footer___steps" }, gr = "joy-product-tour-spotlight__wrapper", br = /* @__PURE__ */ A({
  __name: "VJoyProductTourInner",
  props: {
    icon: {},
    steps: { default: 1 },
    step: { default: 1 },
    position: { default: "bottom" },
    open: { type: Boolean, default: !1 },
    maxWidth: { default: 500 },
    disableOverlay: { type: Boolean, default: !1 },
    spotlightPadding: { default: 8 },
    spotlightSelector: {},
    closeButton: { type: Boolean, default: !0 }
  },
  emits: ["product-tour:hide"],
  setup(e, { expose: t, emit: o }) {
    const l = o, n = e, { clearProductTourRef: i } = jo, a = $(null), r = $(null), u = $(null), s = $(null), m = $(null), d = $(n.open), f = $(), p = $(
      ho(u, a, {
        placement: n.position,
        whileElementsMounted(...x) {
          return Bl(...x, { ancestorResize: !0, ancestorScroll: !0, elementResize: !0 });
        },
        transform: !1,
        middleware: [
          lo(30),
          ao({
            limiter: io()
          }),
          oo({
            fallbackPlacements: ["bottom", "top", "left", "right"]
          }),
          po({ element: f, padding: 0 })
        ]
      })
    ), y = V(() => {
      const { middlewareData: x, placement: M } = p.value, E = x.arrow, q = {
        top: "bottom",
        right: "left",
        bottom: "top",
        left: "right"
      }[M.split("-")[0]];
      return {
        left: (E == null ? void 0 : E.x) && `${E == null ? void 0 : E.x}px`,
        top: (E == null ? void 0 : E.y) && `${E == null ? void 0 : E.y}px`,
        right: "",
        bottom: "",
        [q]: "-12px"
      };
    });
    function g() {
      var x;
      n.spotlightSelector && document.body.contains(document.querySelector(n.spotlightSelector)) && (u.value = document.querySelector(n.spotlightSelector), C({
        elementToHighlight: u.value,
        disableOverlay: n.disableOverlay
      }), (x = p.value) == null || x.update(), d.value = !0);
    }
    function b() {
      d.value = !1, i(), L(), l("product-tour:hide");
    }
    function C(x) {
      u.value && (x.disableOverlay || _(), j(x.elementToHighlight));
    }
    function _() {
      r.value = document.createElement("div"), r.value.classList.add("joy-product-tour__overlay"), r.value.addEventListener("click", b, { once: !0 }), r.value.style.position = "fixed", r.value.style.top = "0", r.value.style.left = "0", r.value.style.width = "100%", r.value.style.height = "100%", r.value.style.zIndex = "var(--joy-core-z-index-backdrop)", document.querySelector("body").appendChild(r.value);
    }
    function j(x) {
      x && (x.style.position = "relative", x.style.zIndex = "calc(var(--joy-core-z-index-backdrop) + 1)", s.value = O(fr, { disableOverlay: n.disableOverlay }), m.value = document.createElement("div"), m.value.classList.add(gr), document.body.appendChild(m.value), Ct(s.value, m.value), S());
    }
    function S() {
      if (!m.value)
        return;
      const { left: x, top: M, height: E, width: q } = u.value.getBoundingClientRect();
      m.value.style.left = `calc(${window.scrollX + x - n.spotlightPadding}px`, m.value.style.top = `${window.scrollY + M - n.spotlightPadding}px`, m.value.style.width = `${q}px`, m.value.style.height = `${E}px`, m.value.style.position = "absolute", m.value.style.padding = n.spotlightPadding + "px", m.value.style.boxSizing = "content-box";
    }
    function I() {
      r.value && r.value.remove();
    }
    function L() {
      I(), u.value && (u.value.style.position = "", u.value.style.zIndex = ""), m.value && (Ct(null, m.value), m.value.remove());
    }
    return W(p.value, () => {
      var x;
      s.value && ((x = a.value) != null && x.isConnected ? S() : b());
    }), Ot(() => {
      L();
    }), t({
      hide: b,
      show: g,
      isOpen: d
    }), (x, M) => {
      var E;
      return Xe((c(), v("div", {
        ref_key: "productTour",
        ref: a,
        class: "joy-product-tour__wrapper",
        role: "tooltip",
        style: X({ "--product-tour-width": e.maxWidth + "px", ...(E = p.value) == null ? void 0 : E.floatingStyles })
      }, [
        h("div", {
          ref_key: "productTourArrow",
          ref: f,
          class: "joy-product-tour__arrow",
          style: X(y.value)
        }, null, 4),
        h("div", {
          class: B([
            "joy-product-tour",
            `joy-product-tour--${e.position}`,
            {
              "joy-product-tour--open": d.value
            }
          ])
        }, [
          h("div", {
            class: B(["joy-product-tour__banner", { "joy-product-tour__hasBanner": x.$slots["product-tour-banner"] }])
          }, [
            w(x.$slots, "product-tour-banner", {}, void 0, !0)
          ], 2),
          h("div", {
            class: B(["joy-product-tour__preheader", { "joy-product-tour__hasPreheader": x.$slots["product-tour-preheader"] }])
          }, [
            h("div", null, [
              w(x.$slots, "product-tour-preheader", {}, void 0, !0)
            ]),
            e.closeButton ? (c(), T(Ve, {
              key: 0,
              class: "joy-product-tour__close",
              variant: "ghost",
              icon: "cross",
              size: "small",
              label: "Close",
              onClick: b
            })) : k("", !0)
          ], 2),
          h("div", mr, [
            e.icon ? (c(), T(D, {
              key: 0,
              class: "joy-product-tour__content___icon",
              name: e.icon,
              size: "medium"
            }, null, 8, ["name"])) : k("", !0),
            h("div", null, [
              h("div", pr, [
                w(x.$slots, "product-tour-header", {}, void 0, !0)
              ]),
              w(x.$slots, "product-tour-content", {}, void 0, !0)
            ])
          ]),
          x.$slots["product-tour-dismiss"] || x.$slots["product-tour-next"] ? (c(), v("div", vr, [
            h("div", { onClick: b }, [
              w(x.$slots, "product-tour-dismiss", {}, void 0, !0)
            ]),
            h("span", hr, [
              e.steps > 1 ? (c(), v(H, { key: 0 }, [
                R(P(e.step) + "/" + P(e.steps), 1)
              ], 64)) : k("", !0)
            ]),
            w(x.$slots, "product-tour-next", {}, void 0, !0)
          ])) : k("", !0)
        ], 2)
      ], 4)), [
        [Eo, d.value]
      ]);
    };
  }
}), wr = /* @__PURE__ */ z(br, [["__scopeId", "data-v-a0dee67d"]]), tc = /* @__PURE__ */ A({
  inheritAttrs: !1,
  __name: "VJoyProductTour",
  props: {
    icon: {},
    steps: {},
    step: {},
    position: {},
    open: { type: Boolean },
    maxWidth: {},
    disableOverlay: { type: Boolean },
    spotlightPadding: {},
    spotlightSelector: {},
    closeButton: { type: Boolean, default: !0 }
  },
  emits: ["product-tour:hide"],
  setup(e, { expose: t, emit: o }) {
    const l = $(!1), n = e, i = o, { storeProductTourRef: a, clearProductTourRef: r } = jo, u = $(), s = oe(), m = V(() => {
      if (l.value)
        return s;
    });
    function d() {
      a(u.value);
    }
    function f() {
      i("product-tour:hide");
    }
    function p(y = { fireHideEvent: !1 }) {
      var g;
      (g = u.value) == null || g.hide(), r(), y.fireHideEvent && f();
    }
    return ee(() => {
      l.value = !0, n.open && a(u.value);
    }), t({
      show: d,
      hide: p
    }), (y, g) => (c(), T(Te, { to: "body" }, [
      O(wr, N({ ...n, ...m.value }, {
        ref_key: "productTour",
        ref: u,
        "onProductTour:hide": f
      }), {
        "product-tour-banner": J(() => [
          w(y.$slots, "product-tour-banner")
        ]),
        "product-tour-preheader": J(() => [
          w(y.$slots, "product-tour-preheader")
        ]),
        "product-tour-header": J(() => [
          w(y.$slots, "product-tour-header")
        ]),
        "product-tour-content": J(() => [
          w(y.$slots, "product-tour-content")
        ]),
        "product-tour-dismiss": J(() => [
          w(y.$slots, "product-tour-dismiss")
        ]),
        "product-tour-next": J(() => [
          w(y.$slots, "product-tour-next")
        ]),
        _: 3
      }, 16)
    ]));
  }
}), oc = /* @__PURE__ */ A({
  __name: "VJoyProductTourTrigger",
  props: {
    productTour: {}
  },
  emits: ["click"],
  setup(e, { emit: t }) {
    const o = e, l = t, n = V(() => o.productTour), i = K(), a = V(() => i.default());
    async function r() {
      var u;
      l("click"), n.value && ((u = n.value) == null || u.show());
    }
    return (u, s) => (c(!0), v(H, null, G(a.value, (m) => (c(), T(Y(m), {
      key: m,
      onClick: r
    }))), 128));
  }
}), jr = { class: "joy-progress-bar-wrapper" }, kr = {
  key: 0,
  class: "joy-progress-bar-label joy-font-primary-250"
}, _r = /* @__PURE__ */ A({
  __name: "VJoyProgressBar",
  props: {
    /** import TJoyProgressBarColors */
    color: {
      type: String,
      default: "secondary"
    },
    /**
     * Total number of steps.
     */
    steps: {
      type: Number
    },
    /**
     * Current step number.
     */
    currentStep: {
      type: Number
    },
    /**
     * Progress bar percentage, percentage usage will override steps & currentStep definition.
     */
    percentage: {
      type: Number
    },
    /** Display the actual progress value next to the bar */
    showLabel: {
      type: Boolean,
      default: !1
    }
  },
  setup(e, { expose: t }) {
    const o = e, l = V(() => {
      let n = 0;
      return o.percentage ? n = o.percentage : o.currentStep && o.steps && (n = Math.round(o.currentStep / o.steps * 100)), n = Math.min(100, Math.max(0, n)), n + "%";
    });
    return t({
      computeInnerWidth: l
    }), (n, i) => (c(), T(se, {
      wrap: "nowrap",
      "column-gap": "1",
      align: "center",
      class: B([`joy-progress-bar_${e.color}`])
    }, {
      default: J(() => [
        h("div", jr, [
          h("div", {
            class: "joy-progress-bar-inner",
            style: X({ width: l.value })
          }, null, 4)
        ]),
        e.showLabel && e.percentage ? (c(), v("span", kr, P(e.percentage + "%"), 1)) : k("", !0)
      ]),
      _: 1
    }, 8, ["class"]));
  }
}), nc = /* @__PURE__ */ z(_r, [["__scopeId", "data-v-fb2f0e09"]]), $r = ["id", "value", "checked", "disabled", "required", "name"], Cr = { class: "joy-radio-label" }, Sr = { class: "joy-radio-header-right" }, xr = { class: "joy-radio-sublabel" }, Vr = { class: "joy-radio-content__wrapper" }, Tr = { class: "joy-radio-content" }, Ir = /* @__PURE__ */ A({
  __name: "VJoyRadio",
  props: {
    disabled: {
      type: Boolean,
      default: !1
    },
    id: {
      type: String
    },
    name: {
      type: String
    },
    required: {
      type: Boolean,
      default: !1
    },
    modelValue: {
      type: [String, Number]
    },
    /** Change the layout by using this property */
    theme: {
      type: String,
      default: "default"
    },
    value: {
      type: [String, Number],
      required: !0
    },
    /**
     * Invalid state of the component
     *
     * If not explicitly provided, will inherit from parent VJoyRadioGroup's invalid prop.
     * Note: A checked radio cannot be invalid (the `checked` state takes priority over `invalid` state).
     */
    invalid: {
      type: Boolean,
      default: void 0
    }
  },
  emits: ["update:modelValue"],
  setup(e, { expose: t, emit: o }) {
    const l = o, n = e, i = $(!1), a = $(!1), r = $(null), u = $(null), s = K(), m = V(() => !n.modelValue || !n.value ? !1 : n.modelValue === n.value), d = ce("VJoyRadioGroupInvalid", !1), f = V(() => n.invalid !== void 0 ? n.invalid : d), p = V(() => f.value);
    function y() {
      i.value = !!s["expandable-content"] && m.value;
    }
    function g() {
      l("update:modelValue", n.value), y();
    }
    ee(() => {
      n.theme === "outline" && y();
    });
    function b() {
      a.value = !0;
    }
    function C() {
      a.value = !1;
    }
    return W(
      () => n.modelValue,
      () => {
        y();
      }
    ), t({
      checked: m,
      isExpanded: i
    }), (_, j) => (c(), v("label", {
      ref_key: "root",
      ref: r,
      class: B([
        "joy-radio",
        `joy-radio--${e.theme}`,
        {
          "joy-radio--checked": m.value,
          "joy-radio--disabled": e.disabled,
          "joy-radio--invalid": p.value,
          "joy-radio--outline-focus": a.value && e.theme === "outline",
          "joy-radio--focus": a.value && e.theme === "default"
        }
      ])
    }, [
      h("input", {
        id: e.id,
        "data-joy-form-field": "",
        type: "radio",
        value: e.value,
        checked: m.value,
        disabled: e.disabled,
        required: e.required,
        name: e.name,
        onChange: g,
        onFocus: b,
        onBlur: C
      }, null, 40, $r),
      h("span", Cr, [
        w(_.$slots, "default", {}, void 0, !0),
        h("div", Sr, [
          w(_.$slots, "radio-header-right", {}, void 0, !0)
        ])
      ]),
      h("div", xr, [
        w(_.$slots, "radio-sublabel", {}, void 0, !0)
      ]),
      h("div", Vr, [
        h("div", {
          ref_key: "expandableElement",
          ref: u,
          class: B(["joy-radio-expandable", { "joy-radio-expandable--expanded": i.value }])
        }, [
          w(_.$slots, "expandable-content", {}, void 0, !0)
        ], 2),
        h("div", Tr, [
          w(_.$slots, "radio-content", {}, void 0, !0)
        ])
      ])
    ], 2));
  }
}), lc = /* @__PURE__ */ z(Ir, [["__scopeId", "data-v-6efefd03"]]), Lr = ["form", "name"], Br = /* @__PURE__ */ A({
  __name: "VJoyRadioGroup",
  props: {
    direction: { default: "horizontal" },
    form: {},
    name: {},
    invalid: { type: Boolean, default: !1 }
  },
  setup(e) {
    return te("VJoyRadioGroupInvalid", e.invalid), (o, l) => (c(), v("fieldset", {
      ref: "root",
      class: "joy-radio-group-fieldset",
      role: "radiogroup",
      form: e.form,
      name: e.name
    }, [
      w(o.$slots, "radio-group-legend", {}, void 0, !0),
      h("div", {
        class: B(["joy-radio-group-container", `joy-radio-group-${e.direction}`])
      }, [
        w(o.$slots, "default", {}, void 0, !0)
      ], 2)
    ], 8, Lr));
  }
}), ac = /* @__PURE__ */ z(Br, [["__scopeId", "data-v-cc091c50"]]), Ar = ["aria-label"], Er = { class: "joy-rating-stars" }, zr = { class: "joy-rating-stars__content" }, Jr = { key: 0 }, Pr = /* @__PURE__ */ A({
  __name: "VJoyRatingStars",
  props: {
    /** Between 0 and 5 */
    ratingValue: {
      type: Number,
      default: 0
    },
    /** Display the amount of review leading to the rating value */
    reviewCount: {
      type: Number,
      default: 0
    },
    size: {
      type: String,
      default: "medium"
    }
  },
  setup(e, { expose: t }) {
    const o = e, l = oe(), n = V(() => {
      let i = [], a = 0.24, r = 0.75;
      for (let u = 0; u < 5; u++)
        o.ratingValue > a ? i.push(o.ratingValue < r ? "half" : "full") : i.push("empty"), a += 1, r += 1;
      return i;
    });
    return t({
      setStars: n
    }), (i, a) => (c(), v("div", {
      role: "img",
      class: "joy-rating-stars__wrapper",
      "aria-label": F(l).ariaLabel || `Rating: ${e.ratingValue} out of 5`
    }, [
      h("ul", Er, [
        (c(!0), v(H, null, G(n.value, (r, u) => (c(), v("li", {
          key: u,
          class: B([`joy-rating-stars--${e.size}`])
        }, [
          r === "full" ? (c(), T(D, {
            key: 0,
            "aria-hidden": "true",
            name: "star-fill",
            color: "quaternary"
          })) : r === "half" ? (c(), T(D, {
            key: 1,
            "aria-hidden": "true",
            name: "star-half",
            color: "quaternary"
          })) : (c(), T(D, {
            key: 2,
            "aria-hidden": "true",
            name: "star",
            color: "quaternary"
          }))
        ], 2))), 128))
      ]),
      h("div", zr, [
        w(i.$slots, "rating-stars-content", {}, () => [
          e.reviewCount ? (c(), v("span", Jr, "(" + P(e.reviewCount) + ")", 1)) : k("", !0)
        ], !0)
      ])
    ], 8, Ar));
  }
}), Mr = /* @__PURE__ */ z(Pr, [["__scopeId", "data-v-df20c585"]]), Fr = ["id", "name", "aria-label", "aria-invalid", "required", "disabled"], Or = ["selected"], Dr = /* @__PURE__ */ A({
  __name: "VJoySelect",
  props: {
    /** aria-label is available only if 'label' property is undefined **/
    ariaLabel: {
      type: String
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    id: {
      type: String
    },
    invalid: {
      type: Boolean,
      default: !1
    },
    name: {
      type: String
    },
    required: {
      type: Boolean,
      default: !1
    },
    /** Display a label on top of the element. Handy if you only need to pass a string. If you need more, use the VJoyLabel. */
    label: String,
    labelSize: {
      type: String
    },
    optionalLabel: String,
    requiredMark: {
      type: Boolean,
      default: !1
    },
    /** Made to use the built-in v-model */
    modelValue: {
      type: [String, Number],
      default: ""
    },
    size: {
      type: String,
      default: "medium"
    }
    // ...TEXT_BASED_PROPS,
  },
  emits: ["update:modelValue"],
  setup(e, { expose: t, emit: o }) {
    const l = e;
    te(me, !0);
    const n = o, i = K(), a = V(() => {
      const g = (i == null ? void 0 : i.default) && (i == null ? void 0 : i.default());
      let b = [];
      return g.forEach((C) => {
        if (r(C))
          b.push(C);
        else {
          const _ = C.children;
          if (typeof _ == "string" || !_.length)
            return;
          const j = _.filter(r);
          b = [...b, ...j];
        }
      }), b;
    });
    function r(g) {
      return (g == null ? void 0 : g.type) === "option";
    }
    const u = $(), s = $(), m = $(!1), d = V(() => l.labelSize ? l.labelSize : l.size !== "medium" ? "small" : "medium");
    ee(() => {
      var C;
      const g = i["select-label"] && i["select-label"]();
      if (!g || !g.length)
        return;
      const b = g[0];
      if (b.type === "JoyLabel") {
        const _ = (C = b.props) == null ? void 0 : C.for;
        if (!_) {
          console.warn("JoyLabel for attribute is missing");
          return;
        }
        _ !== l.id && console.warn("JoyLabel for attribute does not match with JoySelect id");
      }
    });
    function f(g) {
      const b = g.target.value;
      n("update:modelValue", b);
    }
    function p() {
      m.value = !0;
    }
    function y() {
      m.value = !1;
    }
    return t({
      select: s
    }), (g, b) => (c(), v("div", {
      ref_key: "root",
      ref: u
    }, [
      w(g.$slots, "select-label", {}, () => [
        e.label ? (c(), T(Pe, {
          key: 0,
          required: e.required && e.requiredMark,
          "optional-label": e.optionalLabel,
          for: e.id || e.name,
          size: d.value
        }, {
          default: J(() => [
            R(P(e.label), 1)
          ]),
          _: 1
        }, 8, ["required", "optional-label", "for", "size"])) : k("", !0)
      ], !0),
      h("div", {
        class: B([
          `joy-select--${e.size}`,
          {
            "joy-select__wrapper": !0,
            "joy-select--invalid": e.invalid,
            "joy-select--disabled": e.disabled,
            "joy-select--focusing": m.value
          }
        ])
      }, [
        h("select", {
          id: e.id || e.name,
          ref_key: "select",
          ref: s,
          "data-joy-form-field": "",
          class: "joy-select",
          name: e.name,
          "aria-label": e.label ? void 0 : e.ariaLabel,
          "aria-invalid": e.invalid,
          required: e.required,
          disabled: e.disabled,
          onChange: f,
          onFocus: p,
          onBlur: y
        }, [
          (c(!0), v(H, null, G(a.value, (C) => {
            var _, j;
            return c(), v("option", N({
              key: (_ = C.props) == null ? void 0 : _.value
            }, { ref_for: !0 }, C.props, {
              selected: ((j = C.props) == null ? void 0 : j.value) === e.modelValue
            }), P(C.children), 17, Or);
          }), 128))
        ], 40, Fr),
        O(D, {
          class: "joy-select__chevron",
          name: "chevron-down"
        })
      ], 2)
    ], 512));
  }
}), ic = /* @__PURE__ */ z(Dr, [["__scopeId", "data-v-d5d840bc"]]), Rr = ["aria-disabled"], Nr = ["id", "value", "checked", "disabled", "required", "name"], qr = { class: "joy-selectable-item__label" }, Hr = /* @__PURE__ */ A({
  __name: "VJoySelectableItem",
  props: {
    disabled: { type: Boolean, default: !1 },
    id: {},
    invalid: { type: Boolean, default: !1 },
    multiple: { type: Boolean, default: !1 },
    name: {},
    required: { type: Boolean, default: !1 },
    checked: { type: Boolean },
    value: {},
    label: {},
    subLabel: {},
    icon: {}
  },
  emits: ["update:checked"],
  setup(e, { emit: t }) {
    const o = t, l = De() + "--JoySelectableItem", n = e, i = $(), a = $(!1), r = n.multiple ? "div" : "label", u = V(() => n.id || l), s = {
      onRadioChange: () => {
        o("update:checked", n.value);
      },
      onClick: () => {
        n.checked && !n.multiple && o("update:checked", "");
      },
      onLabelClick: (d) => {
        n.multiple || d.stopPropagation();
      },
      onFocus: () => {
        a.value = !0;
      },
      onBlur: () => {
        a.value = !1;
      }
    };
    function m(d) {
      o("update:checked", d);
    }
    return (d, f) => (c(), v("div", {
      class: B([
        "joy-selectable-item__wrapper",
        {
          "joy-selectable-item--focusing": a.value
        }
      ]),
      "aria-disabled": e.disabled,
      onClick: f[5] || (f[5] = //@ts-ignore
      (...p) => s.onClick && s.onClick(...p))
    }, [
      e.multiple ? k("", !0) : (c(), v("input", {
        key: 0,
        id: u.value,
        ref_key: "inputRadio",
        ref: i,
        "data-joy-form-field": "",
        type: "radio",
        value: e.value,
        checked: e.checked,
        disabled: e.disabled,
        required: e.required,
        name: e.name,
        onChange: f[0] || (f[0] = //@ts-ignore
        (...p) => s.onRadioChange && s.onRadioChange(...p)),
        onFocus: f[1] || (f[1] = //@ts-ignore
        (...p) => s.onFocus && s.onFocus(...p)),
        onBlur: f[2] || (f[2] = //@ts-ignore
        (...p) => s.onBlur && s.onBlur(...p))
      }, null, 40, Nr)),
      (c(), T(Y(F(r)), {
        for: u.value,
        class: B([
          "joy-selectable-item",
          {
            "joy-selectable-item--disabled": e.disabled,
            "joy-selectable-item--checked": e.checked,
            "joy-selectable-item--multiple": e.multiple,
            "joy-selectable-item--single": !e.multiple,
            "joy-selectable-item--invalid": e.invalid
          }
        ]),
        onClick: s.onLabelClick
      }, {
        default: J(() => [
          e.multiple ? (c(), T(vt, {
            key: 0,
            id: u.value,
            checked: e.checked,
            disabled: e.disabled,
            value: e.value,
            name: e.name,
            "display-focus": !1,
            required: e.required,
            invalid: e.invalid,
            onFocus: f[3] || (f[3] = () => s.onFocus()),
            onBlur: f[4] || (f[4] = () => s.onBlur()),
            "onUpdate:checked": m
          }, {
            default: J(() => [
              w(d.$slots, "default", {}, void 0, !0)
            ]),
            _: 3
          }, 8, ["id", "checked", "disabled", "value", "name", "required", "invalid"])) : k("", !0),
          h("div", qr, [
            e.multiple ? k("", !0) : w(d.$slots, "default", { key: 0 }, void 0, !0)
          ]),
          h("div", {
            class: B([{ "joy-selectable-item__sublabel": d.$slots["selectable-item-sublabel"] }])
          }, [
            w(d.$slots, "selectable-item-sublabel", {}, () => [
              R(P(e.subLabel), 1)
            ], !0)
          ], 2)
        ]),
        _: 3
      }, 8, ["for", "class", "onClick"]))
    ], 10, Rr));
  }
}), Wr = /* @__PURE__ */ z(Hr, [["__scopeId", "data-v-1bc198e0"]]), Ur = ["id"], Gr = /* @__PURE__ */ A({
  __name: "VJoySelectableItemGroup",
  props: {
    options: {},
    id: {},
    value: { default: null },
    valueKey: {},
    multiple: { type: Boolean, default: !1 },
    fullWidth: { type: Boolean, default: !1 },
    required: { type: Boolean, default: !1 },
    label: {},
    labelKey: {},
    labelSize: { default: "medium" },
    optionalLabel: {},
    requiredMark: { type: Boolean, default: !1 },
    invalid: { type: Boolean },
    errorMessage: {}
  },
  emits: ["update:value"],
  setup(e, { emit: t }) {
    const o = t, l = e;
    te(me, !0);
    function n(r) {
      return typeof l.value == "string" ? l.value === a(r) : (l.value || []).includes(a(r));
    }
    function i(r, u) {
      if (!l.multiple)
        return o("update:value", u);
      let s = [...l.value || []];
      u && typeof u == "boolean" ? s.push(r) : s.splice(s.indexOf(r), 1), o("update:value", s);
    }
    function a(r) {
      return l.valueKey && Object.prototype.hasOwnProperty.call(r, l.valueKey) ? r[l.valueKey] : r.value;
    }
    return (r, u) => (c(), v("fieldset", {
      id: e.id,
      class: "joy-selectable-item-group__wrapper"
    }, [
      e.label ? (c(), T(Pe, {
        key: 0,
        "tag-name": "legend",
        required: e.required && e.requiredMark,
        "optional-label": e.optionalLabel,
        size: e.labelSize
      }, {
        default: J(() => [
          R(P(e.label), 1)
        ]),
        _: 1
      }, 8, ["required", "optional-label", "size"])) : k("", !0),
      h("div", {
        class: B([
          "joy-selectable-item-group",
          {
            "joy-selectable-item-group--multiple": e.multiple,
            "joy-selectable-item-group--single": !e.multiple,
            "joy-selectable-item-group--full": e.fullWidth,
            "joy-selectable-item-group--invalid": e.invalid
          }
        ])
      }, [
        (c(!0), v(H, null, G(e.options, (s) => (c(), T(Wr, N({ ref_for: !0 }, s.attrs, {
          id: s.id,
          key: s.id,
          name: s.name,
          disabled: s.disabled,
          value: a(s),
          multiple: e.multiple,
          checked: n(s),
          invalid: e.invalid,
          "onUpdate:checked": (m) => i(a(s), m)
        }), yt({
          default: J(() => [
            w(r.$slots, "item", N({ ref_for: !0 }, s), () => [
              R(P(e.labelKey && s[e.labelKey] || s.label), 1)
            ], !0)
          ]),
          _: 2
        }, [
          s.subLabel ? {
            name: "selectable-item-sublabel",
            fn: J(() => [
              R(P(s.subLabel), 1)
            ]),
            key: "0"
          } : void 0
        ]), 1040, ["id", "name", "disabled", "value", "multiple", "checked", "invalid", "onUpdate:checked"]))), 128))
      ], 2),
      e.errorMessage && e.invalid ? (c(), T(_t, {
        key: 1,
        "no-html-error-text": e.errorMessage,
        class: "joy-mt-2"
      }, null, 8, ["no-html-error-text"])) : k("", !0)
    ], 8, Ur));
  }
}), rc = /* @__PURE__ */ z(Gr, [["__scopeId", "data-v-83760d1d"]]), Kr = /* @__PURE__ */ A({
  __name: "VJoySeparator",
  props: {
    /** Main text to apply in the central area */
    text: {
      type: String
    },
    size: {
      type: String,
      default: "default"
    }
  },
  setup(e) {
    return (t, o) => (c(), v("div", {
      class: B(["joy-separator", { "joy-separator__small": e.size === "small" }])
    }, [
      h("span", null, P(e.text), 1)
    ], 2));
  }
}), sc = /* @__PURE__ */ z(Kr, [["__scopeId", "data-v-21db2899"]]), Yr = ["id"], Zr = { class: "joy-step__stroke" }, Xr = {
  key: 0,
  class: "joy-step__label"
}, Qr = /* @__PURE__ */ A({
  __name: "VJoyStep",
  props: {
    /** Set it to completed to change it's color */
    completed: {
      type: Boolean,
      default: !1
    },
    /** Progress substep of the current step  */
    currentSubStep: {
      type: Number,
      default: 0
    },
    /** Adjust the text size, not the component size */
    size: {
      type: String,
      default: "default"
    },
    /** Set the amount of sub steps of the current step */
    subSteps: {
      type: Number,
      default: 1
    },
    id: {
      type: String,
      default: "joy-step-value--" + Qe()
    },
    showLabel: {
      type: Boolean,
      default: !0
    }
  },
  emits: ["update:subSteps"],
  setup(e, { expose: t, emit: o }) {
    const l = e, n = o, i = $(0.1), a = V(() => l.completed ? "100%" : r.value ? l.subSteps <= 1 || l.currentSubStep === 1 ? "10%" : (Math.min(l.currentSubStep / l.subSteps - i.value, 1 - i.value) * 100).toFixed(1) + "%" : "0%"), r = V(() => l.currentSubStep > 0);
    function u(s) {
      s <= 0 && console.warn("subSteps must be equal or greater than 1"), n("update:subSteps");
    }
    return W(() => l.subSteps, u), t({
      progress: a
    }), (s, m) => (c(), v("div", {
      id: e.id,
      class: B([
        "joy-step",
        `joy-step--size-${e.size}`,
        {
          "joy-step--completed": e.completed,
          "joy-step--ongoing": r.value
        }
      ])
    }, [
      h("span", Zr, [
        h("span", {
          class: "joy-step__stroke--filled",
          style: X({ maxWidth: a.value })
        }, null, 4)
      ]),
      O(ft, { name: "joy-step__label" }, {
        default: J(() => [
          e.showLabel ? (c(), v("span", Xr, [
            w(s.$slots, "default", {}, void 0, !0)
          ])) : k("", !0)
        ]),
        _: 3
      })
    ], 10, Yr));
  }
}), es = /* @__PURE__ */ z(Qr, [["__scopeId", "data-v-3820cdf3"]]), ts = { class: "joy-stepper" }, os = /* @__PURE__ */ A({
  __name: "VJoyStepper",
  props: {
    /** Current step value */
    step: {
      type: Number,
      required: !0
    },
    /** Each main step can have sub-steps to have more specific visual progress feedback  */
    subStep: {
      type: Number,
      default: 1
    }
  },
  setup(e, { expose: t }) {
    const o = e, l = K(), n = ce("VJoyStepperShowLabels", !0), i = V(() => {
      const f = l.default();
      return f.length === 1 && typeof f[0].type != "object" ? f[0].children.filter(a) : f.filter(a);
    });
    function a(f) {
      var p;
      return ((p = f.type) == null ? void 0 : p.__name) === "VJoyStep";
    }
    const r = V(() => o.step > 0 ? i.value[o.step - 1] : i.value[0]), u = V(() => r.value.props === null ? !1 : o.subStep <= 0 || o.subStep > m.value), s = V(() => u.value && r.value.props ? r.value.props["sub-steps"] : o.subStep), m = V(() => r.value.props === null ? r.value.type.props.subSteps.default : r.value.props["sub-steps"]);
    function d(f) {
      return f !== o.step - 1 ? 0 : s.value;
    }
    return t({
      currentItemSubStep: s,
      steps: i,
      invalidSubStepValue: u
    }), (f, p) => (c(), v("div", ts, [
      (c(!0), v(H, null, G(i.value, (y, g) => {
        var b;
        return c(), T(es, N({ ref_for: !0 }, y.props, {
          key: (b = y.props) == null ? void 0 : b.id,
          completed: g < e.step - 1,
          "current-sub-step": d(g),
          "show-label": F(n)
        }), {
          default: J(() => {
            var C;
            return [
              (C = y.children) != null && C.default ? (c(), T(Y(y.children.default), { key: 0 })) : k("", !0)
            ];
          }),
          _: 2
        }, 1040, ["completed", "current-sub-step", "show-label"]);
      }), 128))
    ]));
  }
}), uc = /* @__PURE__ */ z(os, [["__scopeId", "data-v-22705668"]]), ns = ["id", "aria-hidden", "aria-labelledby"], ls = /* @__PURE__ */ A({
  __name: "VJoyTab",
  props: {
    /**
     * A tab id or name must be provided for each `joy-tab`. It's used internally to reference
     * the selected tab
     */
    tab: {
      type: [String, Number],
      required: !0
    },
    /**
     * The title given to the button
     */
    label: {
      type: [String, Number]
    },
    /**
     * Allow to have a link on the button. When clicking on the button, you will be redirected to the target of the URL.
     */
    href: {
      type: String,
      required: !1
    },
    /** Activates a little notification badge in the tab button. */
    notification: {
      type: Boolean,
      required: !1
    }
  },
  setup(e) {
    const t = e, o = ce("VJoyTabs", $("")), l = V(() => o.value === t.tab);
    return (n, i) => (c(), v("div", {
      id: `joy-tab-${e.tab}`,
      role: "tabpanel",
      "aria-hidden": l.value ? void 0 : "true",
      "aria-labelledby": `joy-tab-${e.tab}`,
      class: B({
        "joy-tab": !0,
        "joy-tab__selected": l.value
      })
    }, [
      w(n.$slots, "default", {}, void 0, !0)
    ], 10, ns));
  }
}), cc = /* @__PURE__ */ z(ls, [["__scopeId", "data-v-60bfe6bd"]]), as = ["id", "href", "aria-selected", "aria-controls"], is = {
  type: "button",
  tabindex: "-1"
}, rs = /* @__PURE__ */ A({
  __name: "TabButton",
  props: {
    /**
     * Boolean to change style if tabButton is selected
     */
    selected: {
      type: Boolean,
      default: !1
    },
    /**
     * Id of the tab, used for aria prop
     */
    tab: {
      type: [String, Number],
      required: !0
    },
    /**
     * Href props to send to a link. If filled, it replaces the default comportment
     */
    href: {
      type: String,
      required: !1
    },
    /**
     * Label of the button. If filled, it replaces the default slot
     */
    label: {
      type: [String, Number],
      required: !1
    },
    notifications: {
      type: Number
    }
  },
  emits: ["changeTab"],
  setup(e, { emit: t }) {
    const o = e, l = t, n = V(() => typeof o.notifications == "number");
    function i() {
      l("changeTab");
    }
    function a(r) {
      (r.code === "Enter" || r.code === "NumpadEnter") && l("changeTab");
    }
    return (r, u) => (c(), v("a", {
      id: `joy-tab-${e.tab}`,
      href: e.href,
      "aria-selected": e.selected ? "true" : "false",
      "aria-controls": `job-tab-${e.tab}`,
      tabindex: "0",
      role: "tab",
      onClick: i,
      onKeydown: u[0] || (u[0] = (s) => a(s))
    }, [
      h("div", {
        class: B({
          "joy-tab-button": !0,
          "joy-tab-button__selected": e.selected
        })
      }, [
        h("button", is, [
          w(r.$slots, "default", {}, () => [
            R(P(e.label), 1)
          ], !0),
          n.value ? (c(), T(Zt, {
            key: 0,
            class: "joy-tab-button_notifications",
            variant: "pink",
            number: e.notifications
          }, null, 8, ["number"])) : k("", !0)
        ])
      ], 2)
    ], 40, as));
  }
}), ss = /* @__PURE__ */ z(rs, [["__scopeId", "data-v-358b26cc"]]), us = { class: "joy-tabs" }, cs = /* @__PURE__ */ A({
  __name: "VJoyTabs",
  props: {
    /** Use this prop to activate a specific tab by default by giving its name */
    selectedTab: {
      type: String
    }
  },
  emits: ["update:selected-tab"],
  setup(e, { expose: t, emit: o }) {
    const l = e, n = o, i = K(), a = $(l.selectedTab);
    te("VJoyTabs", a);
    const r = $(null), u = $(null), s = $(!1), m = $(!1), d = V(() => {
      const b = i.default();
      return b.length === 1 && typeof b[0].type != "object" ? b[0].children.filter(f) : b.filter(f);
    });
    function f(b) {
      var C;
      return ((C = b == null ? void 0 : b.type) == null ? void 0 : C.__name) === "VJoyTab";
    }
    function p(b) {
      return b.props.tab === a.value;
    }
    function y() {
      u.value && r.value && u.value.scrollWidth > r.value.offsetWidth ? (m.value = u.value.scrollLeft > 0, s.value = u.value.scrollLeft + r.value.offsetWidth < u.value.scrollWidth) : (m.value = !1, s.value = !1);
    }
    function g(b, C = !0) {
      b && C && (a.value = b, n("update:selected-tab", b));
    }
    return W(
      () => l.selectedTab,
      (b) => {
        b && g(b);
      },
      { immediate: !0 }
    ), ee(() => {
      var b;
      y(), (b = u.value) == null || b.addEventListener("scroll", y);
    }), Je(() => {
      var b;
      (b = u.value) == null || b.removeEventListener("scroll", y);
    }), t({
      tabs: d
    }), (b, C) => (c(), v("div", us, [
      h("div", {
        ref_key: "buttonListWrapper",
        ref: r,
        class: B({
          "joy-tabs-buttons__wrapper": !0,
          "joy-tabs-buttons__wrapper--scroll-end": s.value,
          "joy-tabs-buttons__wrapper--scroll-start": m.value
        })
      }, [
        h("div", {
          ref_key: "buttonList",
          ref: u,
          class: "joy-tabs-buttons",
          role: "tablist"
        }, [
          (c(!0), v(H, null, G(d.value, (_) => (c(), v("div", {
            key: _.props.tab
          }, [
            O(ss, {
              tab: _.props.tab,
              label: _.props.label,
              href: _.props.href,
              notifications: _.props.notifications,
              selected: p(_),
              onChangeTab: () => g(_.props.tab, !_.props.href)
            }, {
              default: J(() => {
                var j;
                return [
                  (j = _.children) != null && j.header ? (c(), T(Y(_.children.header), { key: 0 })) : k("", !0)
                ];
              }),
              _: 2
            }, 1032, ["tab", "label", "href", "notifications", "selected", "onChangeTab"])
          ]))), 128))
        ], 512)
      ], 2),
      h("div", null, [
        w(b.$slots, "default", {}, void 0, !0)
      ])
    ]));
  }
}), dc = /* @__PURE__ */ z(cs, [["__scopeId", "data-v-9aea2d41"]]), ds = ["id", "role", "tabindex"], fs = /* @__PURE__ */ A({
  __name: "VJoyTag",
  props: {
    label: {},
    size: { default: "medium" },
    variant: { default: "primary" },
    draggable: { type: Boolean, default: !1 },
    removable: { type: Boolean, default: !1 },
    selected: { type: Boolean },
    selectable: { type: Boolean },
    link: { type: Boolean, default: !1 },
    value: { default: void 0 },
    strikethrough: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    id: {}
  },
  emits: ["selected", "remove", "click"],
  setup(e, { emit: t }) {
    const o = ["primary", "secondary"], l = t, n = e, i = V(() => ({
      "joy-tag": !0,
      "joy-tag__selected": n.selected,
      "joy-tag__selectable": n.selectable || n.link,
      "joy-tag_draggable": n.draggable,
      "joy-tag__strikethrough": n.strikethrough,
      "joy-tag__disabled": n.disabled,
      ["joy-tag__" + n.size]: !0,
      ["joy-tag__" + n.variant]: !0
    })), a = De() + "--JoyTag", r = V(() => n.id || a);
    function u() {
      l("remove", { value: n.value });
    }
    function s() {
      n.disabled || (l("click"), n.selectable && o.includes(n.variant) && l("selected", { selected: !n.selected, value: n.value }));
    }
    return (m, d) => (c(), v("span", {
      id: r.value,
      class: B([i.value]),
      role: e.link || e.selectable ? "button" : void 0,
      tabindex: e.link || e.selectable && !e.disabled ? 0 : void 0,
      onClick: s
    }, [
      w(m.$slots, "default", {}, () => [
        e.draggable ? (c(), T(D, {
          key: 0,
          class: "joy-tag__drag",
          name: "drag",
          size: "xxsmall"
        })) : k("", !0),
        R(" " + P(e.label), 1)
      ], !0),
      e.removable ? (c(), T(D, {
        key: 0,
        class: "joy-tag__removable",
        name: "cross",
        size: "xxsmall",
        role: "button",
        onClick: zo(u, ["stop"]),
        onKeydown: Re(u, ["enter"])
      })) : k("", !0)
    ], 10, ds));
  }
}), ko = /* @__PURE__ */ z(fs, [["__scopeId", "data-v-4d8f5321"]]);
var Me = /* @__PURE__ */ ((e) => (e.DUPLICATED_ENTRY = "DUPLICATED_ENTRY", e.INVALID_EMAIL = "INVALID_EMAIL", e))(Me || {});
function Ft(e) {
  if (!Array.isArray(e) && typeof e != "string")
    return console.warn("Values needs to be an array of emails, or email."), !1;
  function t(o) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(o);
  }
  return Array.isArray(e) ? e.find((l) => {
    if (!t(l))
      return l;
  }) === void 0 : t(e);
}
const ys = { class: "joy-tags-input__wrapper" }, ms = ["id", "name", "placeholder"], ps = { key: 0 }, vs = { key: 1 }, hs = /* @__PURE__ */ A({
  __name: "VJoyTagsInput",
  props: {
    name: {},
    placeholder: { default: "Add your items here" },
    variant: { default: "primary" },
    size: { default: "small" },
    modelValue: { default: () => [] },
    invalid: { type: Boolean, default: !1 },
    validation: { default: "none" },
    duplicationError: {},
    invalidEmailError: {}
  },
  emits: ["update:modelValue", "validation:error"],
  setup(e, { expose: t, emit: o }) {
    const l = e;
    te(me, !0);
    const n = o, i = $(l.modelValue), a = $(!1), r = $(null), u = $(l.invalid), s = $(null), m = V(() => l.validation === "email"), d = V(() => m.value && s.value === "INVALID_EMAIL" && !!l.invalidEmailError), f = V(() => s.value === "DUPLICATED_ENTRY" && !!l.duplicationError), p = V(() => u.value && (d.value || f.value));
    function y() {
      var M;
      const L = i.value.map((E) => E.trim());
      return new Set(L).size !== L.length ? !0 : (M = r.value) != null && M.value ? L.includes(r.value.value.trim()) : !1;
    }
    function g() {
      var M, E;
      let L = !1;
      if (m.value) {
        let q = i.value;
        (M = r.value) != null && M.value && (q = [...q, (E = r.value) == null ? void 0 : E.value]), L = !Ft(q);
      }
      const x = y();
      u.value = L || x, x ? s.value = Me.DUPLICATED_ENTRY : L ? s.value = Me.INVALID_EMAIL : s.value = null;
    }
    function b() {
      var L;
      (L = r.value) != null && L.value && (i.value = [...i.value, r.value.value], r.value.value = "", n("update:modelValue", i.value));
    }
    function C(L) {
      var x;
      if (L == null || L.preventDefault(), g(), y()) {
        n("validation:error", Me.DUPLICATED_ENTRY);
        return;
      }
      if (m.value && ((x = r.value) != null && x.value) && !Ft(r.value.value)) {
        n("validation:error", Me.INVALID_EMAIL);
        return;
      }
      b();
    }
    function _(L) {
      var M;
      (m.value ? ["Enter", ",", " "] : ["Enter", ","]).includes(L.key) && C(L), L.key === "Backspace" && ((M = r.value) == null ? void 0 : M.value) === "" && (i.value.pop(), n("update:modelValue", i.value), m.value && g());
    }
    function j() {
      a.value = !0;
    }
    function S() {
      a.value = !1, C();
    }
    function I(L) {
      var x;
      i.value = i.value.filter((M) => M !== L.value), n("update:modelValue", i.value), (x = r.value) == null || x.focus(), g();
    }
    return W(
      () => l.modelValue,
      () => {
        m.value && g();
      },
      { immediate: !0 }
    ), t({
      isInvalid: u,
      hasDuplicates: y
    }), (L, x) => (c(), v("div", ys, [
      L.$slots.default ? (c(), T(Pe, {
        key: 0,
        id: e.name,
        class: "joy-tags-input__label"
      }, {
        default: J(() => [
          w(L.$slots, "default", {}, void 0, !0)
        ]),
        _: 3
      }, 8, ["id"])) : k("", !0),
      h("div", {
        class: B([
          "joy-tags-input__inner",
          {
            "joy-tags-input__inner--focused": a.value,
            "joy-tags-input__inner--invalid": u.value
          }
        ])
      }, [
        (c(!0), v(H, null, G(i.value, (M) => (c(), T(ko, {
          key: M,
          variant: e.variant,
          removable: !0,
          size: e.size,
          label: M,
          value: M,
          onRemove: I
        }, {
          default: J(() => [
            w(L.$slots, "tag", N({ ref_for: !0 }, { name: M }), void 0, !0)
          ]),
          _: 2
        }, 1032, ["variant", "size", "label", "value"]))), 128)),
        h("input", {
          id: e.name,
          ref_key: "inputEl",
          ref: r,
          "data-joy-form-field": "",
          type: "text",
          name: e.name,
          placeholder: e.placeholder,
          onKeydown: _,
          onFocus: j,
          onBlur: S
        }, null, 40, ms)
      ], 2),
      p.value ? (c(), T(_t, {
        key: 1,
        class: "joy-tags-input__error"
      }, {
        default: J(() => [
          h("ul", null, [
            f.value ? (c(), v("li", ps, P(e.duplicationError), 1)) : k("", !0),
            d.value ? (c(), v("li", vs, P(e.invalidEmailError), 1)) : k("", !0)
          ])
        ]),
        _: 1
      })) : k("", !0)
    ]));
  }
}), fc = /* @__PURE__ */ z(hs, [["__scopeId", "data-v-efb84377"]]), gs = /* @__PURE__ */ A({
  __name: "VJoyTagsList",
  props: {
    align: {
      type: String,
      default: "left"
    },
    modelValue: {
      type: Array
    },
    /** Tags list. Array of objects containing at least a label. "value" is mandatory if dealing with removable or selectable tags */
    tags: {
      type: Array,
      default() {
        return [];
      }
    },
    /** You can either pass this property to make all generated tags removable, or pass the `removable: true` to each tag in "tags" prop. */
    removable: {
      type: Boolean,
      default: !1
    },
    /** Make all VJoyTag selectable. Can be overriden by setting selectable: false in specific tags property entry. */
    selectable: {
      type: Boolean,
      default: !1
    },
    /** Apply variant for all VJoyTag. Can be overriden by setting a variant property in specific tags entry. */
    variant: {
      type: String,
      default: "primary"
    }
  },
  emits: ["update:modelValue", "removeTag"],
  setup(e, { emit: t }) {
    const o = t, l = e;
    function n(s) {
      var m;
      return l.removable ? !1 : (m = l.modelValue) == null ? void 0 : m.includes(s.value);
    }
    function i(s) {
      return !l.modelValue || l.removable || s.removable ? !1 : s.selectable !== void 0 ? s.selectable : l.selectable;
    }
    function a(s) {
      return s.removable !== void 0 ? s.removable : l.removable;
    }
    function r(s, m) {
      let d = [];
      s.selected && !n(m) ? d = [...l.modelValue || [], m.value] : d = (l.modelValue || []).filter((f) => f !== m.value), o("update:modelValue", d);
    }
    function u(s) {
      o("removeTag", s.value);
    }
    return (s, m) => (c(), v("div", {
      class: B(["joy-tags-list", `joy-tags-list--${e.align}`])
    }, [
      (c(!0), v(H, null, G(e.tags, (d) => (c(), T(ko, N({
        key: d.value || d.label
      }, { ref_for: !0 }, d, {
        selectable: i(d),
        removable: a(d),
        variant: d.variant ? d.variant : e.variant,
        selected: n(d),
        onRemove: u,
        onSelected: (f) => r(f, d)
      }), {
        default: J(() => [
          w(s.$slots, "tag", N({ ref_for: !0 }, {
            ...d,
            selectable: i(d),
            selected: n(d),
            removable: a(d)
          }), void 0, !0)
        ]),
        _: 2
      }, 1040, ["selectable", "removable", "variant", "selected", "onSelected"]))), 128))
    ], 2));
  }
}), yc = /* @__PURE__ */ z(gs, [["__scopeId", "data-v-1d8003ef"]]), bs = {}, ws = {
  class: /* @__PURE__ */ B(["joy-template-shape__shapes"])
};
function js(e, t) {
  return c(), v("div", ws, [...t[0] || (t[0] = [
    Ht('<div class="shapes__wrapper" data-v-2077977e><div class="shape_1" data-v-2077977e></div><div class="shape_2" data-v-2077977e></div><div class="shape_3" data-v-2077977e></div><div class="shape_4" data-v-2077977e></div></div>', 1)
  ])]);
}
const ks = /* @__PURE__ */ z(bs, [["render", js], ["__scopeId", "data-v-2077977e"]]), _s = { class: "joy-template__wrapper" }, $s = {
  key: 0,
  class: "joy-template__heading"
}, Cs = {
  key: 0,
  class: "joy-template-slot-back"
}, Ss = { class: "joy-template__heading___headings" }, xs = {
  key: 0,
  class: "joy-template-slot-title"
}, Vs = {
  key: 1,
  class: "joy-template-slot-subtitle"
}, Ts = {
  key: 1,
  class: "joy-template-slot-actions"
}, Is = {
  key: 0,
  class: "joy-template-slot-main"
}, Ls = {
  key: 1,
  class: "joy-template-slot-sidebar"
}, Bs = /* @__PURE__ */ A({
  __name: "VJoyTemplate",
  props: {
    /** Takes 100% of free space */
    full: { type: Boolean, default: !1 },
    sidebar: { type: String, default: "right" },
    loading: {
      type: Boolean,
      default: !1
    },
    loadingColor: {
      type: String,
      default: "light"
    },
    /** Decorative purpose, on bottom right corner */
    shapes: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const t = e, o = K(), l = V(() => !!o["template-back"] || !!o["template-title"] || !!o["template-subtitle"] || !!o["template-actions"]);
    return (n, i) => (c(), v("div", {
      class: B(["joy-template", { "joy-template--full": e.full, "joy-template--loading": e.loading }])
    }, [
      e.shapes ? (c(), T(ks, { key: 0 })) : k("", !0),
      h("div", _s, [
        l.value ? (c(), v("div", $s, [
          o["template-back"] ? (c(), v("div", Cs, [
            w(n.$slots, "template-back", {}, void 0, !0)
          ])) : k("", !0),
          h("div", Ss, [
            o["template-title"] ? (c(), v("div", xs, [
              w(n.$slots, "template-title", {}, void 0, !0)
            ])) : k("", !0),
            o["template-subtitle"] ? (c(), v("div", Vs, [
              w(n.$slots, "template-subtitle", {}, void 0, !0)
            ])) : k("", !0)
          ]),
          o["template-actions"] ? (c(), v("div", Ts, [
            w(n.$slots, "template-actions", {}, void 0, !0)
          ])) : k("", !0)
        ])) : k("", !0),
        h("div", {
          class: B([
            "joy-template__content",
            {
              "joy-template__content--reverse": t.sidebar === "left"
            }
          ])
        }, [
          n.$slots["template-main"] ? (c(), v("div", Is, [
            w(n.$slots, "template-main", {}, void 0, !0)
          ])) : k("", !0),
          n.$slots["template-sidebar"] ? (c(), v("div", Ls, [
            w(n.$slots, "template-sidebar", {}, void 0, !0)
          ])) : k("", !0)
        ], 2)
      ]),
      e.loading ? (c(), T(wo, {
        key: 1,
        overlay: "",
        color: e.loadingColor
      }, {
        content: J(() => [
          w(n.$slots, "template-loader-content", {}, void 0, !0)
        ]),
        _: 3
      }, 8, ["color"])) : k("", !0)
    ], 2));
  }
}), mc = /* @__PURE__ */ z(Bs, [["__scopeId", "data-v-37b74fad"]]), As = /* @__PURE__ */ A({
  __name: "VJoyText",
  props: {
    /** Defines the tag name of the Node you want to create. By default it's a simple P tag. Lowercase only */
    tagName: {
      type: String,
      default: "p"
    },
    /** Choose a pre-configured set of CSS rules : font-family, font-size, line-height, font-weight.  */
    preset: {
      type: String,
      default: "primary-400"
    }
  },
  setup(e) {
    return (t, o) => (c(), T(Y(e.tagName), {
      class: B(`joy-text joy-font-${e.preset}`)
    }, {
      default: J(() => [
        w(t.$slots, "default", {}, void 0, !0)
      ]),
      _: 3
    }, 8, ["class"]));
  }
}), pc = /* @__PURE__ */ z(As, [["__scopeId", "data-v-8a40109a"]]), Es = ["aria-disabled"], zs = { class: "joy-textarea_wrapper" }, Js = ["id", "disabled", "name", "required", "minlength", "value"], Ps = {
  key: 1,
  class: "joy-textarea_helpers"
}, Ms = {
  inheritAttrs: !1
}, Fs = /* @__PURE__ */ A({
  ...Ms,
  __name: "VJoyTextarea",
  props: {
    autofocus: {
      type: Boolean,
      default: !1
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    id: {
      type: String
    },
    invalid: {
      type: Boolean,
      default: !1
    },
    name: {
      type: String
    },
    required: {
      type: Boolean,
      default: !1
    },
    /** Use it to render a basic string label. Otherwise use VJoyLabel like the WithLabel story. */
    label: String,
    labelSize: {
      type: String,
      default: "medium"
    },
    optionalLabel: String,
    requiredMark: {
      type: Boolean,
      default: !1
    },
    modelValue: {
      type: String,
      default: ""
    },
    modelModifiers: {
      default: () => ({
        lazy: !1
      })
    },
    autogrow: {
      type: Boolean,
      default: !1
    },
    minlength: {
      type: Number
    },
    minlengthLabel: String,
    maxlength: {
      type: Number
    }
  },
  emits: ["update:modelValue"],
  setup(e, { expose: t, emit: o }) {
    const l = o, n = e;
    te(me, !0);
    const i = K(), a = $(), { triggerResize: r } = Ln({
      element: n.autogrow ? a : void 0
    }), u = $(!1), s = $(!1);
    go(a, n.autofocus);
    const m = V(() => n.maxlength ? n.modelValue.length > n.maxlength : !1), d = V(() => n.minlength ? n.modelValue.length < n.minlength : !1), f = V(() => !!(n.label || i.default)), p = {
      onInput: (y) => {
        n.modelModifiers.lazy || l("update:modelValue", y.target.value), p.triggerResize();
      },
      onChange: (y) => {
        n.modelModifiers.lazy && l("update:modelValue", y.target.value);
      },
      onBlur: () => {
        s.value = !1, u.value = m.value || d.value;
      },
      onFocus: () => {
        s.value = !0;
      },
      /**
       * Here we store the function in an object to more easily test it with vitest.
       * There is an issue when we try to use spyOn vm object directly.
       * */
      triggerResize: r
    };
    return W(
      () => n.modelValue,
      () => {
        p.triggerResize();
      },
      { flush: "post" }
    ), t({
      isInvalid: u,
      valueOverMaxlength: m,
      valueUnderMinlength: d,
      triggerResize: r,
      eventHandlers: p
    }), (y, g) => (c(), v("div", {
      "aria-disabled": e.disabled,
      class: B([
        "joy-textarea",
        {
          "joy-textarea_invalid": u.value || e.invalid,
          "joy-textarea_disabled": e.disabled,
          "joy-textarea_autogrow": e.autogrow,
          "joy-textarea_focusing": s.value
        }
      ])
    }, [
      f.value ? (c(), T(Pe, {
        key: 0,
        for: e.id,
        required: e.required && e.requiredMark,
        "optional-label": e.optionalLabel,
        size: e.labelSize
      }, {
        default: J(() => [
          w(y.$slots, "default", {}, () => [
            R(P(e.label), 1)
          ], !0)
        ]),
        _: 3
      }, 8, ["for", "required", "optional-label", "size"])) : k("", !0),
      h("div", zs, [
        h("textarea", N(y.$attrs, {
          id: e.id,
          ref_key: "textarea",
          ref: a,
          "data-joy-form-field": "",
          class: "joy-native-textarea",
          disabled: e.disabled,
          name: e.name,
          required: e.required,
          minlength: e.minlength,
          value: e.modelValue,
          onInput: g[0] || (g[0] = //@ts-ignore
          (...b) => p.onInput && p.onInput(...b)),
          onChange: g[1] || (g[1] = //@ts-ignore
          (...b) => p.onChange && p.onChange(...b)),
          onFocus: g[2] || (g[2] = //@ts-ignore
          (...b) => p.onFocus && p.onFocus(...b)),
          onBlur: g[3] || (g[3] = //@ts-ignore
          (...b) => p.onBlur && p.onBlur(...b))
        }), null, 16, Js)
      ]),
      e.minlength || e.maxlength ? (c(), v("div", Ps, [
        e.minlength ? (c(), v("p", {
          key: 0,
          class: B(["joy-textarea-min", { "joy-textarea-min-invalid": e.invalid }])
        }, [
          d.value ? k("", !0) : (c(), T(D, {
            key: 0,
            name: "check",
            color: "neutral",
            size: "xxsmall"
          })),
          R(" " + P(e.minlengthLabel || `Minimum ${e.minlength} characters`), 1)
        ], 2)) : k("", !0),
        e.maxlength ? (c(), v("p", {
          key: 1,
          class: B(["joy-textarea-count", { "joy-textarea-count-invalid": m.value }])
        }, P(e.modelValue.length + "/" + e.maxlength), 3)) : k("", !0)
      ])) : k("", !0)
    ], 10, Es));
  }
}), vc = /* @__PURE__ */ z(Fs, [["__scopeId", "data-v-f62629b6"]]), Os = /* @__PURE__ */ A({
  __name: "VJoyTitleBrand",
  props: {
    tag: { default: "p" }
  },
  setup(e) {
    return (t, o) => (c(), T(Y(e.tag), { class: "joy-title-brand joy-font-secondary-200" }, {
      default: J(() => [
        w(t.$slots, "default", {}, void 0, !0)
      ]),
      _: 3
    }));
  }
}), hc = /* @__PURE__ */ z(Os, [["__scopeId", "data-v-72b57f87"]]), Ds = { class: "joy-toggle__wrapper" }, Rs = ["name", "disabled", "checked", "required", "aria-checked", "value"], Ns = { class: "joy-toggle__symbol" }, qs = { class: "joy-toggle__symbol-bubble" }, Hs = {
  key: 0,
  class: "joy-toggle__symbol-smile"
}, Ws = { class: "joy-toggle__content-label" }, Us = /* @__PURE__ */ A({
  __name: "VJoyToggle",
  props: {
    modelValue: {
      type: Boolean,
      default: !1
    },
    value: {
      type: String,
      default: "on"
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    id: {
      type: String
    },
    invalid: {
      type: Boolean,
      default: !1
    },
    name: {
      type: String
    },
    required: {
      type: Boolean,
      default: !1
    },
    // ...CHECKBOX_BASED_PROPS,
    label: String,
    variant: {
      type: String,
      default: "default"
    },
    /**
     * Position of the label text relative to the toggle switch
     */
    labelPosition: {
      type: String,
      default: "right"
    }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const o = t;
    te(me, !0), K();
    const l = $(!1), n = {
      onChange: (i) => {
        const a = i.target.checked;
        o("update:modelValue", a);
      },
      onFocus: () => {
        l.value = !0;
      },
      onBlur: () => {
        l.value = !1;
      }
    };
    return (i, a) => (c(), v("div", Ds, [
      h("label", {
        class: B([
          "joy-toggle",
          "joy-toggle__" + e.variant,
          {
            "joy-toggle__checked": e.modelValue,
            "joy-toggle__disabled": e.disabled,
            "joy-toggle__focusing": l.value
          }
        ])
      }, [
        h("input", {
          ref: "input",
          "data-joy-form-field": "",
          type: "checkbox",
          class: "joy-toggle__input",
          role: "checkbox",
          name: e.name,
          disabled: e.disabled,
          checked: e.modelValue,
          required: e.required,
          "aria-checked": e.modelValue,
          value: e.value,
          onChange: a[0] || (a[0] = //@ts-ignore
          (...r) => n.onChange && n.onChange(...r)),
          onFocus: a[1] || (a[1] = //@ts-ignore
          (...r) => n.onFocus && n.onFocus(...r)),
          onBlur: a[2] || (a[2] = //@ts-ignore
          (...r) => n.onBlur && n.onBlur(...r))
        }, null, 40, Rs),
        h("p", {
          class: B(["joy-toggle__content", { "joy-toggle__content--label-left": e.labelPosition === "left" }])
        }, [
          h("span", Ns, [
            h("span", qs, [
              e.variant === "default" ? (c(), v("span", Hs, [...a[3] || (a[3] = [
                h("svg", {
                  width: "18",
                  height: "10",
                  viewBox: "0 0 18 10",
                  fill: "currentColor",
                  xmlns: "http://www.w3.org/2000/svg"
                }, [
                  h("path", {
                    d: "M9.0237 9.14856C15.7144 9.14856 17.8736 2.22231 17.9649 1.91853L17.9345 1.94891C18.1778 1.15908 17.7216 0.308485 16.9309 0.0654591C16.1402 -0.177566 15.2886 0.278108 15.0453 1.06794C14.9845 1.25021 13.5551 6.11073 8.99328 6.11073C4.43147 6.11073 3.03249 1.43248 2.97167 1.21983C2.75878 0.399622 1.90724 -0.0560541 1.11652 0.156593C0.295397 0.369241 -0.160787 1.18945 0.0520982 2.00967C0.721165 4.4703 3.48869 9.14856 9.0237 9.14856Z",
                    fill: "currentColor"
                  })
                ], -1)
              ])])) : (c(), T(D, {
                key: 1,
                name: "eye",
                class: "joy-toggle__icon"
              }))
            ])
          ]),
          h("span", Ws, [
            w(i.$slots, "default", {}, () => [
              R(P(e.label), 1)
            ], !0)
          ])
        ], 2)
      ], 2)
    ]));
  }
}), gc = /* @__PURE__ */ z(Us, [["__scopeId", "data-v-71b1ca7c"]]), Gs = { class: "joy-user-card__picture" }, Ks = { class: "joy-user-card__informations" }, Ys = { class: "joy-user-card__title" }, Zs = { class: "joy-user-card__subtitle joy-font-primary-450" }, Xs = /* @__PURE__ */ A({
  __name: "VJoyUserCard",
  props: {
    /**
     * Giving a link will make the whole component wrapped by an hyperlink
     */
    link: {
      type: String
    },
    /**
     * Use this prop if you don't want to use the user-card-avatar slot.
     */
    photoUrl: {
      type: String
    },
    fullName: {
      type: String
    },
    subTitle: {
      type: String
    },
    /** Introduce a VJoyRatingStars component with given rating */
    ratingValue: {
      type: Number
    }
  },
  setup(e) {
    return (t, o) => (c(), T(Y(e.link ? "a" : "div"), N({
      class: "joy-user-card",
      href: e.link,
      title: e.fullName
    }, t.$attrs), {
      default: J(() => [
        h("div", Gs, [
          w(t.$slots, "user-card-avatar", {}, () => [
            O(un, {
              "photo-url": e.photoUrl,
              "full-name": e.fullName
            }, null, 8, ["photo-url", "full-name"])
          ], !0)
        ]),
        h("div", Ks, [
          h("p", Ys, [
            w(t.$slots, "user-card-title", {}, () => [
              R(P(e.fullName), 1)
            ], !0)
          ]),
          h("p", Zs, [
            w(t.$slots, "user-card-subtitle", {}, () => [
              R(P(e.subTitle), 1)
            ], !0)
          ]),
          w(t.$slots, "user-card-rating-stars", {}, () => [
            e.ratingValue ? (c(), T(Mr, {
              key: 0,
              "rating-value": e.ratingValue
            }, null, 8, ["rating-value"])) : k("", !0)
          ], !0),
          h("div", null, [
            w(t.$slots, "default", {}, void 0, !0)
          ])
        ])
      ]),
      _: 3
    }, 16, ["href", "title"]));
  }
}), bc = /* @__PURE__ */ z(Xs, [["__scopeId", "data-v-e0dba25f"]]), Qs = { class: "joy-walkthrough-trigger__content" }, eu = {
  key: 0,
  class: "joy-pr-3"
}, tu = {
  key: 1,
  class: "joy-pl-3"
}, ou = /* @__PURE__ */ A({
  __name: "VJoyWalkthroughTrigger",
  props: {
    icon: {},
    title: {},
    subtitle: {},
    open: { type: Boolean }
  },
  setup(e) {
    const o = $(e.open);
    return (l, n) => {
      const i = dt("joy-ripple");
      return Xe((c(), v("button", N(l.$attrs, {
        type: "button",
        class: "joy-walkthrough-trigger joy-bgcolor-neutral-60 joy-core-radius-5",
        onClick: n[0] || (n[0] = (a) => o.value = !o.value)
      }), [
        e.icon ? (c(), T(D, {
          key: 0,
          color: "white",
          class: "joy-walkthrough-trigger__icon joy-mr-3",
          name: e.icon
        }, null, 8, ["name"])) : k("", !0),
        h("div", Qs, [
          e.title ? (c(), v("span", eu, P(e.title), 1)) : k("", !0),
          e.subtitle ? (c(), v("span", tu, P(e.subtitle), 1)) : k("", !0)
        ]),
        O(D, {
          class: "joy-ml-3",
          color: "white",
          name: o.value ? "chevron-down" : "chevron-up"
        }, null, 8, ["name"])
      ], 16)), [
        [i]
      ]);
    };
  }
}), nu = /* @__PURE__ */ z(ou, [["__scopeId", "data-v-e34e1407"]]), lu = { class: "joy-walkthrough-modal__illustration" }, au = { class: "joy-walkthrough-modal__content___titles" }, iu = { class: "joy-walkthrough-modal__content___title" }, ru = { class: "joy-walkthrough-modal__content___subtitle" }, su = {
  key: 0,
  class: "joy-mt-4"
}, uu = {
  key: 1,
  class: "joy-mt-4 joy-walkthrough-modal__content-inner"
}, cu = {
  type: "button",
  class: "joy-walkthrough-modal__footer-button joy-color-secondary-50 joy-font-primary-300"
}, du = /* @__PURE__ */ A({
  __name: "VJoyWalkthrough",
  props: {
    open: { type: Boolean, default: !1 },
    triggerTitle: {},
    triggerSubtitle: {},
    triggerIcon: {},
    footer: {},
    triggerAttrs: {},
    disableTeleport: { type: Boolean }
  },
  emits: ["hide", "hide:header", "hide:footer"],
  setup(e, { expose: t, emit: o }) {
    const l = e, n = o;
    let i = null;
    const a = $(l.open), r = $(!1);
    function u() {
      a.value ? d() : a.value = !0;
    }
    function s() {
      d(), n("hide"), n("hide:header");
    }
    function m() {
      d(), n("hide"), n("hide:footer");
    }
    function d() {
      i && clearTimeout(i), r.value = !0, i = setTimeout(() => {
        a.value = !1, r.value = !1;
      }, 200);
    }
    return W(
      () => l.open,
      (f) => {
        a.value = f;
      }
    ), t({
      isOpen: a
    }), (f, p) => (c(), T(Te, {
      to: "body",
      disabled: e.disableTeleport
    }, [
      h("div", {
        class: B(["joy-walkthrough joy-core-radius-4", { "joy-walkthrough--collapsed": !a.value }])
      }, [
        a.value ? (c(), v("div", N({ key: 0 }, f.$attrs, {
          class: ["joy-walkthrough-modal joy-core-elevation-4", { "joy-walkthrough-modal--hiding": r.value }]
        }), [
          O(se, {
            "no-margin": "",
            role: "button",
            class: "joy-walkthrough-modal__header joy-pt-5 joy-pl-6 joy-pb-5 joy-pr-6 joy-bgcolor-neutral-60",
            onClick: s
          }, {
            default: J(() => [
              e.triggerIcon ? (c(), T(D, {
                key: 0,
                color: "white",
                name: e.triggerIcon
              }, null, 8, ["name"])) : k("", !0),
              O(se, {
                justify: "space-between",
                class: "joy-walkthrough-modal__title",
                "no-margin": ""
              }, {
                default: J(() => [
                  R(P(e.triggerTitle) + " ", 1),
                  O(D, {
                    color: "white",
                    name: a.value ? "chevron-down" : "chevron-up"
                  }, null, 8, ["name"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          h("div", {
            class: B(["joy-walkthrough-modal__content joy-p-6", { "joy-walkthrough-modal__content--with-footer": e.footer }])
          }, [
            O(se, {
              "no-margin": "",
              wrap: "nowrap"
            }, {
              default: J(() => [
                h("div", lu, [
                  w(f.$slots, "walkthrough-illustration", {}, void 0, !0)
                ]),
                h("div", au, [
                  h("div", iu, [
                    w(f.$slots, "walkthrough-title", {}, void 0, !0)
                  ]),
                  h("div", ru, [
                    w(f.$slots, "walkthrough-subtitle", {}, void 0, !0)
                  ])
                ])
              ]),
              _: 3
            }),
            f.$slots["walkthrough-progress"] ? (c(), v("div", su, [
              w(f.$slots, "walkthrough-progress", {}, void 0, !0)
            ])) : k("", !0),
            f.$slots["walkthrough-content"] ? (c(), v("div", uu, [
              w(f.$slots, "walkthrough-content", {}, void 0, !0)
            ])) : k("", !0)
          ], 2),
          e.footer ? (c(), v("div", {
            key: 0,
            class: "joy-walkthrough-modal__footer joy-p-6",
            onClick: m
          }, [
            h("button", cu, P(e.footer), 1)
          ])) : k("", !0)
        ], 16)) : k("", !0),
        a.value ? k("", !0) : (c(), T(nu, N({ key: 1 }, e.triggerAttrs, {
          title: e.triggerTitle,
          subtitle: e.triggerSubtitle,
          icon: e.triggerIcon,
          class: "joy-walkthrough-trigger",
          onClick: u
        }), null, 16, ["title", "subtitle", "icon"]))
      ], 2)
    ], 8, ["disabled"]));
  }
}), wc = /* @__PURE__ */ z(du, [["__scopeId", "data-v-bfb1ca7c"]]), jc = {
  install: (e) => {
    typeof window < "u" && Yt(), e.directive("joy-ripple", Wt), e.directive("bind-once", Oo);
  }
};
export {
  jc as JoyVueLightPlugin,
  pu as VJoyAdminBanner,
  vu as VJoyAvailability,
  un as VJoyAvatar,
  hu as VJoyAvatarsList,
  gu as VJoyBadge,
  bu as VJoyBadgeLevel,
  wu as VJoyBlockSkeleton,
  ju as VJoyBottomSheet,
  ku as VJoyBottomSheetTrigger,
  Ee as VJoyButton,
  _u as VJoyButtonCard,
  vt as VJoyCheckbox,
  $u as VJoyCheckboxCard,
  Cu as VJoyCheckboxGroup,
  Su as VJoyCollapse,
  Zl as VJoyCollapseItem,
  xu as VJoyCompanyAvatar,
  Vu as VJoyDialog,
  Tu as VJoyDialogTrigger,
  Zt as VJoyDot,
  Iu as VJoyDrawer,
  Lu as VJoyDrawerTrigger,
  Bu as VJoyDropdown,
  Sa as VJoyDropdownList,
  Au as VJoyDropzone,
  Eu as VJoyFilterBar,
  zu as VJoyFilterBarButton,
  Ju as VJoyFloatingActionsBar,
  _t as VJoyFormError,
  Pu as VJoyFormFieldSkeleton,
  Mu as VJoyFormGroup,
  Fu as VJoyFunnel,
  Ou as VJoyFunnelFooter,
  Du as VJoyFunnelHeader,
  Ru as VJoyHighlight,
  D as VJoyIcon,
  Ve as VJoyIconButton,
  gi as VJoyIndicator,
  Nu as VJoyIndicators,
  $t as VJoyInput,
  qu as VJoyInputDigit,
  Hu as VJoyInputNumber,
  Wu as VJoyInputPassword,
  Pe as VJoyLabel,
  Uu as VJoyLink,
  Gu as VJoyListItem,
  Ku as VJoyMenu,
  Yu as VJoyMenuItem,
  Cu as VJoyMultiCheckbox,
  Zu as VJoyPagination,
  Xu as VJoyPanel,
  Qu as VJoyPanelSection,
  ec as VJoyPasswordRequirement,
  tc as VJoyProductTour,
  oc as VJoyProductTourTrigger,
  nc as VJoyProgressBar,
  lc as VJoyRadio,
  ac as VJoyRadioGroup,
  Mr as VJoyRatingStars,
  wo as VJoyScreenLoader,
  ic as VJoySelect,
  Wr as VJoySelectableItem,
  rc as VJoySelectableItemGroup,
  sc as VJoySeparator,
  Go as VJoySnackbar,
  Xt as VJoySpinner,
  es as VJoyStep,
  uc as VJoyStepper,
  cc as VJoyTab,
  dc as VJoyTabs,
  ko as VJoyTag,
  fc as VJoyTagsInput,
  yc as VJoyTagsList,
  mc as VJoyTemplate,
  pc as VJoyText,
  vc as VJoyTextarea,
  hc as VJoyTitleBrand,
  gc as VJoyToggle,
  Pl as VJoyTooltip,
  bc as VJoyUserCard,
  wc as VJoyWalkthrough,
  nu as VJoyWalkthroughTrigger,
  se as VJoyWrapper,
  Yt as createAllSnackbarsContainer,
  mu as pushVJoySnackbar,
  yu as resetCount,
  Wt as vJoyRipple
};
